webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LoungerReservation = exports.Lounger = exports.CustomForm = exports.Folder = exports.News = exports.Image = exports.Ticket = exports.Period = exports.Auth = exports.OtherEvent = exports.Tag = exports.Menu = exports.Widget = exports.Film = exports.Spectacle = exports.Concert = exports.ArtistsListWidget = exports.Registration = exports.Occurrence = exports.InstagramFolder = exports.Page = exports.Popup = exports.Attachment = exports.StandCategory = exports.Stand = exports.Color = exports.Edition = exports.Stage = exports.SiteSettings = undefined;

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _axios = __webpack_require__(30);

var _axios2 = _interopRequireDefault(_axios);

var _service = __webpack_require__(405);

var _service2 = _interopRequireDefault(_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_axios2.default.defaults.baseURL = "https://backend.opener.sparing.blue/";

var SiteSettings = exports.SiteSettings = {
    update: function update(payload) {
        return _axios2.default.put('/core/admin/settings/', payload);
    },
    get: function get(payload) {
        return _axios2.default.get('/core/admin/settings/', payload);
    },
    refresh: function refresh() {
        return _axios2.default.get('/core/admin/refresh-frontend/');
    }
};

var Stage = exports.Stage = (0, _extends3.default)({}, (0, _service2.default)('/stages/admin/:id/'), {
    changeOrder: function changeOrder(payload) {
        return _axios2.default.post('/stages/admin/set_order/', payload);
    }
});

var Edition = exports.Edition = (0, _extends3.default)({}, (0, _service2.default)('/core/editions/:id/'));

var Color = exports.Color = (0, _extends3.default)({}, (0, _service2.default)('/core/colors/:id/'));

var Stand = exports.Stand = (0, _extends3.default)({}, (0, _service2.default)('/stands/admin/:id/'), {
    tags: function tags() {
        return _axios2.default.get('/stands/admin/tags/');
    }
});

var StandCategory = exports.StandCategory = (0, _extends3.default)({}, (0, _service2.default)('/stands/admin/categories/:id/'));

var Attachment = exports.Attachment = (0, _extends3.default)({}, (0, _service2.default)('/attachments/:id/'), {
    upload: function upload(payload) {
        return _axios2.default.post('/attachments/', payload, {
            headers: { 'content-type': 'multipart/form-data' }
        });
    }
});

var Popup = exports.Popup = (0, _extends3.default)({}, (0, _service2.default)('/popups/:id/'), {
    all: function all() {
        return _axios2.default.get('/popups/all/');
    }
});

var Page = exports.Page = (0, _extends3.default)({}, (0, _service2.default)('/pages/admin/:slug/'), {
    slug: function slug(id, payload) {
        return _axios2.default.put('/pages/admin/slug/' + id + '/', payload);
    }
});

var InstagramFolder = exports.InstagramFolder = (0, _extends3.default)({}, (0, _service2.default)('/instagram/:id/'), {
    remote: function remote(payload) {
        return _axios2.default.get('/instagram/remote/', payload);
    },
    all: function all() {
        return _axios2.default.get('/instagram/all/');
    }
});

var Occurrence = exports.Occurrence = {
    fetch: function fetch(params, payload) {
        return _axios2.default.get('/events/spectacles/occurrences/', payload);
    },
    exportUrl: function exportUrl(id) {
        return _axios2.default.defaults.baseURL + 'events/spectacles/occurrences/' + id + '/export/';
    }
};

var Registration = exports.Registration = (0, _extends3.default)({}, (0, _service2.default)('/events/spectacles/registrations/:id/'));

var ArtistsListWidget = exports.ArtistsListWidget = {
    preview: function preview(payload) {
        return _axios2.default.post('/artists-list-widget/preview/', payload);
    }
};

var Concert = exports.Concert = (0, _extends3.default)({}, (0, _service2.default)('/events/concerts/:id/'), {
    tags: function tags() {
        return _axios2.default.get('/events/concerts/tags/');
    },
    changeOrder: function changeOrder(payload) {
        return _axios2.default.post('/events/concerts/change_order/', payload);
    },
    getOrder: function getOrder(payload) {
        return _axios2.default.get('/events/concerts/get_order/', payload);
    }
});

var Spectacle = exports.Spectacle = (0, _extends3.default)({}, (0, _service2.default)('/events/spectacles/:id/'), {
    tags: function tags() {
        return _axios2.default.get('/events/spectacles/tags/');
    },
    changeOrder: function changeOrder(payload) {
        return _axios2.default.post('/events/spectacles/change_order/', payload);
    },
    getOrder: function getOrder(payload) {
        return _axios2.default.get('/events/spectacles/get_order/', payload);
    }
});

var Film = exports.Film = (0, _extends3.default)({}, (0, _service2.default)('/events/films/:id/'), {
    tags: function tags() {
        return _axios2.default.get('/events/films/tags/');
    },
    changeOrder: function changeOrder(payload) {
        return _axios2.default.post('/events/films/change_order/', payload);
    },
    getOrder: function getOrder(payload) {
        return _axios2.default.get('/events/films/get_order/', payload);
    }
});

var Widget = exports.Widget = (0, _extends3.default)({}, (0, _service2.default)('/widgets/:id/'), {
    types: function types(params) {
        return _axios2.default.get('/widgets/types/', { params: params });
    },
    validate: function validate(payload) {
        return _axios2.default.post('/widgets/validate/', payload);
    },
    available: function available(params) {
        return _axios2.default.get('/widgets/available/', { params: params });
    }
});

var Menu = exports.Menu = (0, _extends3.default)({}, (0, _service2.default)('/menu/admin/:id/'), {
    availableLinkOptions: function availableLinkOptions() {
        return _axios2.default.get('/menu/available-options/');
    }
});

var Tag = exports.Tag = {
    availableTags: function availableTags() {
        return _axios2.default.get('/events/available-tags/');
    }
};

var OtherEvent = exports.OtherEvent = (0, _extends3.default)({}, (0, _service2.default)('/events/others/:id/'), {
    tags: function tags() {
        return _axios2.default.get('/events/others/tags/');
    },
    eventTypes: function eventTypes() {
        return _axios2.default.get('/events/others/event_types/');
    },
    changeOrder: function changeOrder(payload) {
        return _axios2.default.post('/events/others/change_order/', payload);
    },
    getOrder: function getOrder(payload) {
        return _axios2.default.get('/events/others/get_order/', payload);
    }
});

var Auth = exports.Auth = {
    login: function login(payload) {
        return _axios2.default.post('/api-token-auth/', payload);
    },
    tokenRefresh: function tokenRefresh(payload) {
        return _axios2.default.post('/api-token-refresh/', payload);
    }
};

var Period = exports.Period = (0, _extends3.default)({}, (0, _service2.default)('/tickets/periods/:id/'));

var Ticket = exports.Ticket = (0, _extends3.default)({}, (0, _service2.default)('/tickets/:id/'));

var Image = exports.Image = (0, _extends3.default)({}, (0, _service2.default)('/galleries/admin/images/:id/'), {
    all: function all(params) {
        return _axios2.default.get('/core/admin/photos/', { params: params });
    }
});

var News = exports.News = (0, _extends3.default)({}, (0, _service2.default)('/news/admin/:id/'), {
    tags: function tags() {
        return _axios2.default.get('/news/admin/tags/');
    }
});

var Folder = exports.Folder = (0, _extends3.default)({}, (0, _service2.default)('/galleries/admin/folders/:id/'), {
    all: function all() {
        return _axios2.default.get('/galleries/admin/folders/all/');
    }
});

var CustomForm = exports.CustomForm = (0, _extends3.default)({}, (0, _service2.default)('/forms/admin/:id/'), {
    all: function all() {
        return _axios2.default.get('/forms/admin/all/');
    },
    fieldTypes: function fieldTypes() {
        return _axios2.default.get('/forms/admin/fields/');
    },
    validateField: function validateField(payload) {
        return _axios2.default.post('/forms/admin/fields/validation', payload);
    },
    clone: function clone(id) {
        return _axios2.default.post('/forms/admin/' + id + '/clone/');
    },

    fetchFormData: function fetchFormData(id) {
        return _axios2.default.get('/forms/admin/data/' + id + '/');
    },
    exportFormData: function exportFormData(id, email) {
        var baseURL = _axios2.default.defaults.baseURL;
        if (baseURL[baseURL.length - 1] !== '/') {
            baseURL += '/';
        }
        if (email) {
            return _axios2.default.get(baseURL + 'forms/admin/' + id + '/export/?email=' + email);
        } else {
            var config = {
                responseType: 'blob'
            };
            return _axios2.default.get(baseURL + 'forms/admin/' + id + '/export/', config);
        }
    }
});

var Lounger = exports.Lounger = (0, _extends3.default)({}, (0, _service2.default)('/admin/loungers/:id/'));

var LoungerReservation = exports.LoungerReservation = (0, _extends3.default)({}, (0, _service2.default)('/admin/loungers/reservations/:id/'), {
    mark_as_paid: function mark_as_paid(id) {
        return _axios2.default.post('/admin/loungers/reservations/' + id + '/mark_as_paid/');
    },
    exportUrl: function exportUrl() {
        return _axios2.default.defaults.baseURL + 'admin/loungers/reservations/export_csv/';
    }
});

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(537)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(312),
  /* template */
  __webpack_require__(764),
  /* scopeId */
  "data-v-5f3838c6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(305),
  /* template */
  __webpack_require__(774),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(521)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(326),
  /* template */
  __webpack_require__(748),
  /* scopeId */
  "data-v-4a1b89f5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(523)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(313),
  /* template */
  __webpack_require__(750),
  /* scopeId */
  "data-v-4c60f035",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vueRouter = __webpack_require__(72);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _Login = __webpack_require__(678);

var _Login2 = _interopRequireDefault(_Login);

var _ = __webpack_require__(655);

var _2 = _interopRequireDefault(_);

var _Home = __webpack_require__(674);

var _Home2 = _interopRequireDefault(_Home);

var _Main = __webpack_require__(682);

var _Main2 = _interopRequireDefault(_Main);

var _RegistrationsList = __webpack_require__(695);

var _RegistrationsList2 = _interopRequireDefault(_RegistrationsList);

var _RegistrationSettings = __webpack_require__(694);

var _RegistrationSettings2 = _interopRequireDefault(_RegistrationSettings);

var _MenusList = __webpack_require__(685);

var _MenusList2 = _interopRequireDefault(_MenusList);

var _MenuForm = __webpack_require__(683);

var _MenuForm2 = _interopRequireDefault(_MenuForm);

var _PopupsList = __webpack_require__(692);

var _PopupsList2 = _interopRequireDefault(_PopupsList);

var _PopupForm = __webpack_require__(691);

var _PopupForm2 = _interopRequireDefault(_PopupForm);

var _EditionsList = __webpack_require__(665);

var _EditionsList2 = _interopRequireDefault(_EditionsList);

var _EditionForm = __webpack_require__(664);

var _EditionForm2 = _interopRequireDefault(_EditionForm);

var _ColorsList = __webpack_require__(658);

var _ColorsList2 = _interopRequireDefault(_ColorsList);

var _ColorForm = __webpack_require__(657);

var _ColorForm2 = _interopRequireDefault(_ColorForm);

var _StagesList = __webpack_require__(697);

var _StagesList2 = _interopRequireDefault(_StagesList);

var _StageForm = __webpack_require__(696);

var _StageForm2 = _interopRequireDefault(_StageForm);

var _PagesList = __webpack_require__(690);

var _PagesList2 = _interopRequireDefault(_PagesList);

var _PageForm = __webpack_require__(689);

var _PageForm2 = _interopRequireDefault(_PageForm);

var _WidgetsList = __webpack_require__(707);

var _WidgetsList2 = _interopRequireDefault(_WidgetsList);

var _WidgetForm = __webpack_require__(706);

var _WidgetForm2 = _interopRequireDefault(_WidgetForm);

var _EventsList = __webpack_require__(668);

var _EventsList2 = _interopRequireDefault(_EventsList);

var _EventForm = __webpack_require__(666);

var _EventForm2 = _interopRequireDefault(_EventForm);

var _EventsOrder = __webpack_require__(669);

var _EventsOrder2 = _interopRequireDefault(_EventsOrder);

var _FolderForm = __webpack_require__(675);

var _FolderForm2 = _interopRequireDefault(_FolderForm);

var _FoldersList = __webpack_require__(676);

var _FoldersList2 = _interopRequireDefault(_FoldersList);

var _AttachmentsList = __webpack_require__(656);

var _AttachmentsList2 = _interopRequireDefault(_AttachmentsList);

var _SettingsForm = __webpack_require__(693);

var _SettingsForm2 = _interopRequireDefault(_SettingsForm);

var _PeriodsList = __webpack_require__(703);

var _PeriodsList2 = _interopRequireDefault(_PeriodsList);

var _PeriodForm = __webpack_require__(702);

var _PeriodForm2 = _interopRequireDefault(_PeriodForm);

var _TicketsList = __webpack_require__(705);

var _TicketsList2 = _interopRequireDefault(_TicketsList);

var _TicketForm = __webpack_require__(704);

var _TicketForm2 = _interopRequireDefault(_TicketForm);

var _CustomFormsList = __webpack_require__(660);

var _CustomFormsList2 = _interopRequireDefault(_CustomFormsList);

var _CustomForm = __webpack_require__(659);

var _CustomForm2 = _interopRequireDefault(_CustomForm);

var _StandsList = __webpack_require__(701);

var _StandsList2 = _interopRequireDefault(_StandsList);

var _StandForm = __webpack_require__(700);

var _StandForm2 = _interopRequireDefault(_StandForm);

var _NewsList = __webpack_require__(688);

var _NewsList2 = _interopRequireDefault(_NewsList);

var _NewsForm = __webpack_require__(687);

var _NewsForm2 = _interopRequireDefault(_NewsForm);

var _CategoriesList = __webpack_require__(698);

var _CategoriesList2 = _interopRequireDefault(_CategoriesList);

var _CategoryForm = __webpack_require__(699);

var _CategoryForm2 = _interopRequireDefault(_CategoryForm);

var _ImagesList = __webpack_require__(673);

var _ImagesList2 = _interopRequireDefault(_ImagesList);

var _GalleriesList = __webpack_require__(670);

var _GalleriesList2 = _interopRequireDefault(_GalleriesList);

var _GalleryForm = __webpack_require__(671);

var _GalleryForm2 = _interopRequireDefault(_GalleryForm);

var _LoungerList = __webpack_require__(680);

var _LoungerList2 = _interopRequireDefault(_LoungerList);

var _LoungerForm = __webpack_require__(679);

var _LoungerForm2 = _interopRequireDefault(_LoungerForm);

var _ReservationList = __webpack_require__(681);

var _ReservationList2 = _interopRequireDefault(_ReservationList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = [{
    path: '/login',
    component: _Login2.default,
    name: 'Login',
    hidden: true,
    meta: {
        guests: true
    }
}, {
    path: '/404',
    component: _2.default,
    name: '404',
    hidden: true,
    meta: {
        guests: true
    }
}, {
    path: '/',
    component: _Home2.default,
    name: 'Home',
    iconCls: 'el-icon-star-on',
    meta: { label: 'Home' },
    hidden: true
}, {
    path: '/stages',
    component: _Home2.default,
    iconCls: 'fa fa-slideshare',
    meta: { label: 'Sceny i miejsca' },
    children: [{
        path: '', component: _StagesList2.default, name: 'Stages List', meta: { label: 'Lista' }
    }, {
        path: 'add', component: _StageForm2.default, name: 'Add Stage', meta: { label: 'Dodaj' }
    }, {
        path: ':id', component: _StageForm2.default, name: 'Edit Stage', hidden: true, meta: { label: 'Edytuj scenę' }
    }]
}, {
    path: '/tickets',
    component: _Home2.default,
    iconCls: 'fa fa-ticket',
    meta: { label: 'Bilety' },
    children: [{
        path: 'periods', component: _PeriodsList2.default, name: 'Periods List', meta: { label: 'Okresy biletowe' }
    }, {
        path: 'periods/add', component: _PeriodForm2.default, name: 'Add Period', meta: { label: 'Dodaj okres biletowy' }
    }, {
        path: 'periods/:id',
        component: _PeriodForm2.default,
        name: 'Edit Period',
        hidden: true,
        meta: { label: 'Edytuj okresy biletowe' }
    }, {
        path: '', component: _TicketsList2.default, name: 'Tickets List', meta: { label: 'Lista biletów' }
    }, {
        path: 'add', component: _TicketForm2.default, name: 'Add Ticket', meta: { label: 'Dodaj bilet' }
    }, {
        path: ':id', component: _TicketForm2.default, name: 'Edit Ticket', hidden: true, meta: { label: 'Edytuj bilet' }
    }]
}, {
    path: '/loungers',
    component: _Home2.default,
    iconCls: 'fa fa-sun-o',
    meta: { label: 'Leżaki' },
    children: [{
        path: '',
        component: _LoungerList2.default,
        name: 'Lounger List',
        meta: { label: 'Lista leżaków' }
    }, {
        path: 'add',
        component: _LoungerForm2.default,
        name: 'Add Lounger',
        meta: { label: 'Dodaj leżak' }
    }, {
        path: 'reservations',
        component: _ReservationList2.default,
        name: 'Reservation List',
        meta: { label: 'Lista rezerwacji' }
    }, {
        path: ':id',
        component: _LoungerForm2.default,
        name: 'Edit Lounger',
        hidden: true,
        meta: { label: 'Edytuj leżak' }
    }]
}, {
    path: '/editions',
    component: _Home2.default,
    iconCls: 'fa fa-rocket',
    meta: { label: 'Edycje festiwalu' },
    children: [{
        path: '', component: _EditionsList2.default, name: 'Editions List', meta: { label: 'Lista edycji' }
    }, {
        path: 'add', component: _EditionForm2.default, name: 'Add Edition', meta: { label: 'Dodaj edycję' }
    }, {
        path: ':id', component: _EditionForm2.default, name: 'Edit Edition', hidden: true, meta: { label: 'Edytuj edycję' }
    }]
}, {
    path: '/news',
    component: _Home2.default,
    iconCls: 'fa fa-newspaper-o',
    meta: { label: 'Newsy' },
    children: [{
        path: '', component: _NewsList2.default, name: 'News List', meta: { label: 'Lista newsów' }
    }, {
        path: 'add', component: _NewsForm2.default, name: 'Add News', meta: { label: 'Dodaj news' }
    }, {
        path: ':id', component: _NewsForm2.default, name: 'Edit News', hidden: true, meta: { label: 'Edytuj news' }
    }]
}, {
    path: '/galleries',
    component: _Home2.default,
    iconCls: 'fa fa-photo',
    meta: { label: 'Galerie' },
    children: [{
        path: 'images', component: _ImagesList2.default, name: 'Images List', hidden: true, meta: { label: 'Zdjęcia' }
    }, {
        path: '', component: _GalleriesList2.default, name: 'Galleries List', meta: { label: 'Lista galerii' }
    }, {
        path: 'add', component: _GalleryForm2.default, name: 'Add Gallery', meta: { label: 'Dodaj galerię' }
    }, {
        path: ':id', component: _GalleryForm2.default, name: 'Edit Gallery', hidden: true, meta: { label: 'Edytuj galerię' }
    }]
}, {
    path: '/menu',
    component: _Home2.default,
    iconCls: 'fa fa-bars',
    meta: { label: 'Menu' },
    children: [{
        path: '', component: _MenusList2.default, name: 'Menus List', meta: { label: 'Lista menu' }
    }, {
        path: ':id', component: _MenuForm2.default, name: 'Edit Menu', hidden: true, meta: { label: 'Edytuj menu' }
    }]
}, {
    path: '/pages',
    component: _Home2.default,
    iconCls: 'fa fa-desktop',
    meta: { label: 'Podstrony' },
    children: [{
        path: '', component: _PagesList2.default, name: 'Pages List', meta: { label: 'Lista stron' }
    }, {
        path: 'add', component: _PageForm2.default, name: 'Add Page', meta: { label: 'Dodaj stronę' }
    }, {
        path: ':slug', component: _PageForm2.default, name: 'Edit Page', hidden: true, meta: { label: 'Edytuj stronę' }
    }]
}, {
    path: '/widgets',
    component: _Home2.default,
    iconCls: 'fa fa-cubes',
    meta: { label: 'Widgety globalne' },
    children: [{
        path: '', component: _WidgetsList2.default, name: 'Widgets List', meta: { label: 'Lista' }
    }, {
        path: ':type/add',
        component: _WidgetForm2.default,
        name: 'Add Widget',
        hidden: true,
        meta: { label: 'Dodaj widget' }
    }, {
        path: ':id', component: _WidgetForm2.default, name: 'Edit Widget', hidden: true, meta: { label: 'Edytuj widget' }
    }]
}, {
    path: '/popups',
    component: _Home2.default,
    iconCls: 'fa fa-window-close-o',
    meta: { label: 'Popupy' },
    children: [{
        path: '', component: _PopupsList2.default, name: 'Popups List', meta: { label: 'Lista popupów' }
    }, {
        path: 'add', component: _PopupForm2.default, name: 'Add Popup', meta: { label: 'Dodaj popup' }
    }, {
        path: ':id', component: _PopupForm2.default, name: 'Edit Popup', hidden: true, meta: { label: 'Edytuj popup' }
    }]
}, {
    path: '/events/concerts',
    component: _Home2.default,
    iconCls: 'fa fa-music',
    meta: { label: 'Koncerty' },
    children: [{
        path: '',
        component: _EventsList2.default,
        name: 'Concerts List',
        meta: { label: 'Lista koncertów', eventType: 'music' }
    }, {
        path: 'add',
        component: _EventForm2.default,
        name: 'Add Concert',
        meta: { label: 'Dodaj koncert', eventType: 'music' }
    }, {
        path: 'order',
        component: _EventsOrder2.default,
        name: 'Concerts Order',
        meta: { label: 'Kolejność koncertów', eventType: 'music' }
    }, {
        path: ':id',
        component: _EventForm2.default,
        name: 'Edit Concert',
        hidden: true,
        meta: { label: 'Edytuj koncert', eventType: 'music' }
    }]
}, {
    path: '/events/films',
    component: _Home2.default,
    iconCls: 'fa fa-video-camera',
    meta: { label: 'Filmy - Kino' },
    children: [{
        path: '', component: _EventsList2.default, name: 'Films List', meta: { label: 'Lista filmów', eventType: 'cinema' }
    }, {
        path: 'add', component: _EventForm2.default, name: 'Add Film', meta: { label: 'Dodaj film', eventType: 'cinema' }
    }, {
        path: 'order',
        component: _EventsOrder2.default,
        name: 'Films Order',
        meta: { label: 'Kolejność filmów', eventType: 'cinema' }
    }, {
        path: ':id',
        component: _EventForm2.default,
        name: 'Edit Film',
        hidden: true,
        meta: { label: 'Edytuj film', eventType: 'cinema' }
    }]
}, {
    path: '/events/seances',
    component: _Home2.default,
    iconCls: 'fa fa-child',
    meta: { label: 'Teatr' },
    children: [{
        path: '',
        component: _EventsList2.default,
        name: 'Spectacles List',
        meta: { label: 'Lista spektakli', eventType: 'theater' }
    }, {
        path: 'add',
        component: _EventForm2.default,
        name: 'Add Spectacle',
        meta: { label: 'Dodaj spektakl', eventType: 'theater' }
    }, {
        path: 'order',
        component: _EventsOrder2.default,
        name: 'Spectacles Order',
        meta: { label: 'Kolejność spektakli', eventType: 'theater' }
    }, {
        path: 'registrations',
        component: _RegistrationsList2.default,
        name: 'Registrations List',
        meta: { label: 'Zapisy' }
    }, {
        path: 'registration-settings',
        component: _RegistrationSettings2.default,
        name: 'Registration Settings',
        meta: { label: 'Ustawienia zapisów' }
    }, {
        path: 'registration-regulations',
        redirect: { name: 'Edit Page', params: { slug: 'regulamin-do-spektakli' } },
        name: 'Edit Registrations Regulations',
        meta: { label: 'Regulamin zapisów' }
    }, {
        path: ':id',
        component: _EventForm2.default,
        name: 'Edit Spectacle',
        hidden: true,
        meta: { label: 'Edytuj spektakl', eventType: 'theater' }
    }]
}, {
    path: '/events/others',
    component: _Home2.default,
    iconCls: 'fa fa-question',
    meta: { label: 'Wydarzenia miasteczko' },
    children: [{
        path: '',
        component: _EventsList2.default,
        name: 'OtherEvents List',
        meta: { label: 'Lista wydarzeń', eventType: 'others' }
    }, {
        path: 'add',
        component: _EventForm2.default,
        name: 'Add OtherEvent',
        meta: { label: 'Dodaj wydarzenie', eventType: 'others' }
    }, {
        path: 'order',
        component: _EventsOrder2.default,
        name: 'OtherEvent Order',
        meta: { label: 'Kolejność wydarzeń', eventType: 'others' }
    }, {
        path: ':id',
        component: _EventForm2.default,
        name: 'Edit OtherEvent',
        hidden: true,
        meta: { label: 'Edytuj wydarzenie', eventType: 'others' }
    }]
}, {
    path: '/stands',
    component: _Home2.default,
    iconCls: 'fa fa-truck',
    meta: { label: 'Stoiska' },
    children: [{
        path: 'categories/', component: _CategoriesList2.default, name: 'StandCategories List', meta: { label: 'Kategorie' }
    }, {
        path: 'categories/add',
        component: _CategoryForm2.default,
        name: 'Add StandCategory',
        hidden: true,
        meta: { label: 'Dodaj kategorię' }
    }, {
        path: 'categories/:id',
        component: _CategoryForm2.default,
        name: 'Edit StandCategory',
        hidden: true,
        meta: { label: 'Edytuj kategorie' }
    }, {
        path: '', component: _StandsList2.default, name: 'Stands List', meta: { label: 'Lista stoisk' }
    }, {
        path: 'add', component: _StandForm2.default, name: 'Add Stand', meta: { label: 'Dodaj stoisko' }
    }, {
        path: ':id', component: _StandForm2.default, name: 'Edit Stand', hidden: true, meta: { label: 'Edytuj stoisko' }
    }]
}, {
    path: '/instagram',
    component: _Home2.default,
    iconCls: 'fa fa-instagram',
    meta: { label: 'Instagram' },
    children: [{
        path: '', component: _FoldersList2.default, name: 'Folders List', meta: { label: 'Lista folderów' }
    }, {
        path: 'add', component: _FolderForm2.default, name: 'Add Folder', meta: { label: 'Dodaj folder' }
    }, {
        path: ':id', component: _FolderForm2.default, name: 'Edit Folder', hidden: true, meta: { label: 'Edytuj folder' }
    }]
}, {
    path: '/forms',
    component: _Home2.default,
    iconCls: 'fa fa-vcard',
    meta: { label: 'Formularze' },
    children: [{
        path: '', component: _CustomFormsList2.default, name: 'CustomForms List', meta: { label: 'Lista formularzy' }
    }, {
        path: 'add', component: _CustomForm2.default, name: 'Add CustomForm', meta: { label: 'Dodaj formularz' }
    }, {
        path: ':id',
        component: _CustomForm2.default,
        name: 'Edit CustomForm',
        hidden: true,
        meta: { label: 'Edytuj formularz' }
    }]
}, {
    path: '/settings',
    component: _Home2.default,
    iconCls: 'fa fa-cog',
    meta: { label: 'Ustawienia' },
    children: [{
        path: '', component: _SettingsForm2.default, name: 'Settings Form', meta: { label: 'Konfiguracja strony' }
    }, {
        path: 'colors', component: _ColorsList2.default, name: 'Colors List', meta: { label: 'Lista kolorów' }
    }, {
        path: 'colors/add', component: _ColorForm2.default, name: 'Add Color', hidden: true, meta: { label: 'Dodaj kolor' }
    }, {
        path: 'colors/:id', component: _ColorForm2.default, name: 'Edit Color', hidden: true, meta: { label: 'Edytuj kolor' }
    }]
}, {
    path: '/attachments',
    component: _Home2.default,
    iconCls: 'fa fa-download',
    meta: { label: 'Załączniki' },
    children: [{
        path: '', component: _AttachmentsList2.default, name: 'Attachments List', meta: { label: 'Lista załączników' }
    }]
}, {
    path: '*',
    hidden: true,
    redirect: { path: '/404' }
}];

var router = new _vueRouter2.default({
    routes: routes
});

router.beforeEach(function (to, from, next) {
    var isUserLoggedIn = window.localStorage.getItem('token');
    if (!to.meta.guests && !isUserLoggedIn) {
        next({ name: 'Login', query: { next: to.path } });
        return;
    }
    next();
});

exports.default = router;

/***/ }),
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(483)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(314),
  /* template */
  __webpack_require__(709),
  /* scopeId */
  "data-v-01bf273a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(492)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(329),
  /* template */
  __webpack_require__(719),
  /* scopeId */
  "data-v-1a7d83ef",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 241 */,
/* 242 */,
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _pl = __webpack_require__(409);

var _pl2 = _interopRequireDefault(_pl);

var _en = __webpack_require__(408);

var _en2 = _interopRequireDefault(_en);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	pl: _pl2.default,
	en: _en2.default
};

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = __webpack_require__(26);

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = __webpack_require__(31);

var _keys2 = _interopRequireDefault(_keys);

var _vue = __webpack_require__(8);

var _vue2 = _interopRequireDefault(_vue);

var _api = __webpack_require__(2);

var _availableWidgetsForms = __webpack_require__(407);

var _availableWidgetsForms2 = _interopRequireDefault(_availableWidgetsForms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.mixin({
    methods: {
        addLanguageSuffix: function addLanguageSuffix(field) {
            return field + '_' + this.$store.state.currentFormLanguage;
        },
        getRouteName: function getRouteName(route) {
            if (route.meta && route.meta.label) {
                return route.meta.label;
            }
            return route.name;
        },
        changeOrder: function changeOrder(arr, index, direction) {
            var placeAfterSwap = index + direction;
            if (placeAfterSwap < 0 || placeAfterSwap >= arr.length) {
                return;
            }
            var tmp = arr[index];
            this.$set(arr, index, arr[placeAfterSwap]);
            this.$set(arr, placeAfterSwap, tmp);
        },
        checkForErrors: function checkForErrors(errorsList, nestedFieldsArray) {
            var errors = errorsList;
            if (!Array.isArray(errors)) {
                return false;
            }

            for (var i = 0; i < nestedFieldsArray.length; i++) {
                if (errors === undefined) {
                    return false;
                }
                errors = errors[nestedFieldsArray[i]];
            }
            if (errors === undefined) return false;
            return (0, _keys2.default)(errors).length > 0;
        },
        getWidgetComponent: function getWidgetComponent(type) {
            return _availableWidgetsForms2.default[type];
        },
        successHandler: function successHandler(response) {
            if (this.loading !== undefined) {
                this.loading = false;
            }

            var message = response.status === 201 ? 'Element został dodany' : 'Zmiany zostały zapisane';

            this.$message({
                message: message,
                type: 'success'
            });

            if (this.redirectRoute) {
                this.$router.push(this.redirectRoute);
            }
        },
        errorHandler: function errorHandler(error) {
            if (this.loading !== undefined) {
                this.loading = false;
            }

            if (error.response) {
                var errors = error.response.data;

                var message = 'Wystąpił problem podczas przetwarzania formularza.';

                if (error.response.data.non_field_errors !== undefined) {
                    message += '<br>' + error.response.data.non_field_errors.join(', ');
                }

                if (error.response.status === 413) {
                    message += '<br> Przesłane dane (np. pliki) są zbyt duże.';
                }

                this.$message({
                    message: message,
                    dangerouslyUseHTMLString: true,
                    type: 'error'
                });

                var languageErrors = {};

                var parseErrorsDict = function parseErrorsDict(errorsObj) {
                    (0, _keys2.default)(errorsObj).forEach(function (key) {
                        if (key.endsWith('_en') || key.endsWith('_pl')) {
                            var parts = key.split('_');
                            var lang = parts[parts.length - 1];
                            languageErrors[lang] = true;
                        }
                        var values = errorsObj[key];
                        if (Array.isArray(values)) {
                            if (typeof values[0] === 'string') {
                                errorsObj[key] = values.join(', ');
                            } else if ((0, _typeof3.default)(values[0]) === 'object') {
                                for (var i = 0; i < values.length; i++) {
                                    errorsObj[key][i] = parseErrorsDict(values[i]);
                                }
                            }
                        }
                    });
                    return errorsObj;
                };

                this.errors = parseErrorsDict(errors);

                languageErrors = (0, _keys2.default)(languageErrors);
                var currentFormLanguage = this.$store.state.currentFormLanguage;

                if (languageErrors.length > 0 && !languageErrors.includes(currentFormLanguage)) {
                    this.$store.commit('setCurrentFormLanguage', languageErrors[0]);
                }
            } else if (error.request) {
                console.log(error.request);
            } else {
                var _message = 'Wystąpił problem podczas przetwarzania formularza.<br> Sprawdź czy przesłane dane nie są zbyt duże.';

                console.log('Error', error.message);
                this.$message({
                    message: _message,
                    dangerouslyUseHTMLString: true,
                    type: 'error'
                });
            }
        },
        removeItemFromFormset: function removeItemFromFormset(field, item) {
            var index = field.indexOf(item);
            if (index > -1) {
                field.splice(index, 1);
            }
        },
        duplicateAnotherField: function duplicateAnotherField(value, target) {
            if (!this.form[target]) {
                this.form[target] = value;
            }
        }
    },
    computed: {
        eventDetails: function eventDetails() {
            var type = this.$route.meta.eventType;
            var events = {
                'theater': {
                    routes: { add: 'Add Spectacle', edit: 'Edit Spectacle' },
                    labels: { name: 'Nazwa sztuki', additional_name: 'Nazwa teatru' },
                    service: _api.Spectacle
                },
                'music': {
                    routes: { add: 'Add Concert', edit: 'Edit Concert' },
                    labels: { name: 'Nazwa wykonawcy' },
                    service: _api.Concert
                },
                'others': {
                    routes: { add: 'Add OtherEvent', edit: 'Edit OtherEvent' },
                    labels: { name: 'Nazwa wydarzenia' },
                    service: _api.OtherEvent
                },
                'cinema': {
                    routes: { add: 'Add Film', edit: 'Edit Film' },
                    labels: { name: 'Nazwa filmu', additional_name: 'Reżyser' },
                    service: _api.Film
                }
            };
            return events[type];
        }
    }
});

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(31);

var _keys2 = _interopRequireDefault(_keys);

var _vue = __webpack_require__(8);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(73);

var _vuex2 = _interopRequireDefault(_vuex);

var _auth = __webpack_require__(411);

var _auth2 = _interopRequireDefault(_auth);

var _api = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

exports.default = new _vuex2.default.Store({
    state: {
        currentFormLanguage: 'pl',
        stages: [],
        editions: [],
        colors: [],
        availableWidgets: {},
        availableLinkOptions: {
            "event": [],
            "page": [],
            "news": [],
            "stand": []
        },
        widgetTypes: {},
        idBasedWidgetTypes: {},
        fieldTypes: {}
    },
    mutations: {
        setCurrentFormLanguage: function setCurrentFormLanguage(state, language) {
            state.currentFormLanguage = language;
        },
        setStages: function setStages(state, payload) {
            state.stages = payload;
        },
        setEditions: function setEditions(state, payload) {
            state.editions = payload;
        },
        setColors: function setColors(state, payload) {
            state.colors = payload;
        },
        setAvailableWidgets: function setAvailableWidgets(state, payload) {
            state.availableWidgets = payload;
        },
        setAvailableLinkOptions: function setAvailableLinkOptions(state, payload) {
            state.availableLinkOptions = payload;
        },
        setIdBasedWidgetTypes: function setIdBasedWidgetTypes(state, payload) {
            state.idBasedWidgetTypes = payload;
        },
        setWidgetTypes: function setWidgetTypes(state, payload) {
            state.widgetTypes = payload;
        },
        setAvailableFields: function setAvailableFields(state, payload) {
            state.availableFields = payload;
        },
        setFieldTypes: function setFieldTypes(state, payload) {
            state.fieldTypes = payload;
        }
    },
    actions: {
        fetchStages: function fetchStages(_ref) {
            var commit = _ref.commit;

            return _api.Stage.fetch().then(function (response) {
                commit('setStages', response.data);
            }).catch(function (error) {
                console.error(error);
            });
        },
        fetchEditions: function fetchEditions(_ref2) {
            var commit = _ref2.commit;

            return _api.Edition.fetch().then(function (response) {
                commit('setEditions', response.data);
            }).catch(function (error) {
                console.error(error);
            });
        },
        fetchColors: function fetchColors(_ref3) {
            var commit = _ref3.commit;

            return _api.Color.fetch().then(function (response) {
                commit('setColors', response.data);
            }).catch(function (error) {
                console.error(error);
            });
        },
        fetchAvailableWidgets: function fetchAvailableWidgets(_ref4) {
            var commit = _ref4.commit;

            return _api.Widget.available().then(function (response) {
                commit('setAvailableWidgets', response.data);
            }).catch(function (error) {
                console.error(error);
            });
        },
        fetchAvailableLinkOptions: function fetchAvailableLinkOptions(_ref5) {
            var commit = _ref5.commit;

            _api.Menu.availableLinkOptions().then(function (response) {
                commit('setAvailableLinkOptions', response.data);
            }).catch(function (error) {
                console.error(error);
            });
        },
        fetchWidgetTypes: function fetchWidgetTypes(_ref6) {
            var commit = _ref6.commit;

            return _api.Widget.types().then(function (response) {
                commit('setWidgetTypes', response.data);
                var idBasedWidgetTypes = {};
                (0, _keys2.default)(response.data).map(function (key) {
                    idBasedWidgetTypes[response.data[key].polymorphic_ctype] = {
                        'resourcetype': key,
                        'label': response.data[key].label,
                        'global': response.data[key].global_scope,
                        'polymorphic_ctype': response.data[key].polymorphic_ctype
                    };
                });
                commit('setIdBasedWidgetTypes', idBasedWidgetTypes);
            });
        },
        fetchFieldTypes: function fetchFieldTypes(_ref7) {
            var commit = _ref7.commit;

            return _api.CustomForm.fieldTypes().then(function (response) {
                commit('setFieldTypes', response.data);
            });
        }
    },
    getters: {},
    setters: {},
    modules: {
        auth: _auth2.default
    }
});

/***/ }),
/* 246 */,
/* 247 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 248 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 249 */,
/* 250 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(568)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(303),
  /* template */
  __webpack_require__(797),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(508)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(304),
  /* template */
  __webpack_require__(735),
  /* scopeId */
  "data-v-308c5a87",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(512)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(306),
  /* template */
  __webpack_require__(739),
  /* scopeId */
  "data-v-361528ae",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(495)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(307),
  /* template */
  __webpack_require__(722),
  /* scopeId */
  "data-v-1e12e277",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(308),
  /* template */
  __webpack_require__(718),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(513)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(310),
  /* template */
  __webpack_require__(740),
  /* scopeId */
  "data-v-37d0eac4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(579)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(311),
  /* template */
  __webpack_require__(808),
  /* scopeId */
  "data-v-e6966b4e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(315),
  /* template */
  __webpack_require__(785),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(575)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(317),
  /* template */
  __webpack_require__(804),
  /* scopeId */
  "data-v-d7d8a008",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    name: 'app',
    beforeCreate: function beforeCreate() {
        if (localStorage.lang !== undefined) {
            this.$i18n.locale = localStorage.lang;
        } else {
            localStorage.setItem('lang', this.$i18n.locale);
        }
    },
    mounted: function mounted() {
        this.$store.dispatch('fetchColors');
    }
};

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _elementUi = __webpack_require__(71);

exports.default = {
    extends: _elementUi.ColorPicker,
    mounted: function mounted() {
        this.$store.dispatch('fetchColors');
    },

    methods: {
        clearValue: function clearValue() {
            this.$emit('input', '');
            this.$emit('change', '');
            this.showPanelColor = false;
            this.showPicker = false;
            this.resetColor();
        },
        copyColor: function copyColor(color) {
            this.$emit('input', color);
            this.$emit('change', color);
            this.showPanelColor = false;
            this.showPicker = false;
            this.resetColor();
        }
    }
};

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['value', 'errors', 'required', 'clearable'],
    mounted: function mounted() {
        this.$store.dispatch('fetchEditions');
    }
};

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _api = __webpack_require__(2);

exports.default = {
    props: ["value"],
    methods: {
        sendFile: function sendFile(files) {
            var _this = this;

            var data = new FormData();
            var file = files[0];
            data.append("file", file, file.name);
            return _api.Attachment.upload(data).then(function (response) {
                _this.uploadSuccess(response);
            }).catch(function (error) {
                _this.uploadError(error);
            });
        },
        uploadSuccess: function uploadSuccess(response) {
            this.$emit('input', response.data.file);
        },
        uploadError: function uploadError(error) {
            console.error(error, 'error while file uploading');
            this.$message({
                message: "Wystąpił problem podczas wysyłania pliku.",
                type: 'error'
            });
        },
        removeFile: function removeFile() {
            this.$emit('input', '');
        },

        onDrop: function onDrop(e) {
            e.stopPropagation();
            e.preventDefault();
            var files = e.dataTransfer.files;
            this.sendFile(files);
        },
        onChange: function onChange(e) {
            var files = e.target.files;
            this.sendFile(files);
        }
    }
};

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	data: function data() {
		return {
			availableLanguages: [{ flag: '/static/Poland.png', code: 'pl', label: 'Polski' }, { flag: '/static/England.png', code: 'en', label: 'Angielski' }]
		};
	},

	methods: {
		changeLanguage: function changeLanguage(language) {
			this.$store.commit('setCurrentFormLanguage', language);
		}
	}
};

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['index', 'items', 'label', 'errors'],
    computed: {
        item: function item() {
            return this.items[this.index];
        }
    }
};

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	data: function data() {
		return {
			multiLanguage: false
		};
	},

	computed: {
		langToChange: function langToChange() {
			return this.$i18n.locale === 'pl' ? 'en' : 'pl';
		}
	},
	methods: {
		logout: function logout() {
			var _this = this;

			this.$confirm(this.$i18n.t('areYouSure'), this.$i18n.t('logout'), {}).then(function () {
				window.localStorage.removeItem('token');
				_this.$router.push('/login');
			}).catch(function () {});
		},
		setLang: function setLang() {
			localStorage.lang = this.langToChange;
			this.$i18n.locale = this.langToChange;

			this.$router.go(this.$router.currentRoute);
		}
	}
};

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _PhotosDialog = __webpack_require__(239);

var _PhotosDialog2 = _interopRequireDefault(_PhotosDialog);

var _vue = __webpack_require__(8);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ["value"],
    data: function data() {
        return {
            bus: new _vue2.default()
        };
    },

    components: {
        PhotosDialog: _PhotosDialog2.default
    },
    methods: {
        removeImage: function removeImage() {
            this.$emit('input', null);
        },
        onDrop: function onDrop(e) {
            e.stopPropagation();
            e.preventDefault();
            var files = e.dataTransfer.files;
            this.onImageChange(files);
        },
        onChange: function onChange(e) {
            var files = e.target.files;
            this.onImageChange(files);
        },
        onImageChange: function onImageChange(files) {
            var _this = this;

            if (files && files[0]) {
                var reader = new FileReader();
                reader.onload = function (e) {
                    _this.$emit('input', e.target.result);
                };
                reader.readAsDataURL(files[0]);
            }
        },
        openDialog: function openDialog() {
            this.bus.$emit('openPhotosDialog');
        },
        dialogSubmitted: function dialogSubmitted(photo) {
            this.$emit('input', photo);
        }
    }
};

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(46);

var _assign2 = _interopRequireDefault(_assign);

var _api = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        "value": { type: Object },
        "errors": {
            type: [Object, String],
            default: function _default() {}
        }
    },
    mounted: function mounted() {
        if (this.value) {
            this.form = (0, _assign2.default)({}, this.value);
        }
        this.fetchData();
    },

    methods: {
        resetOptions: function resetOptions() {
            var _this = this;

            if (this.form.anchor_type === '') {
                setTimeout(function () {
                    _this.$emit('input', null);
                }, 0);
                return;
            }
            delete this.form.page;
            delete this.form.event;
            delete this.form.stand;
            delete this.form.news;
            this.form.url = '';
        },
        fetchData: function fetchData() {
            this.$store.dispatch('fetchAvailableLinkOptions');
        },
        getAnchorObject: function getAnchorObject() {
            var anchorType = this.form.anchor_type;

            if (anchorType === undefined || anchorType === "url") {
                return;
            }

            var anchorObjectId = this.form[anchorType];
            var options = this.availableLinkOptions[anchorType];
            if (options === undefined) {
                return;
            }

            var findObj = function findObj(item) {
                return item.value === anchorObjectId;
            };
            return options.find(findObj);
        },
        anchorErrors: function anchorErrors() {
            if (typeof this.errors === 'string') {
                return this.errors;
            } else {
                var errors = this.errors && this.errors['anchor_type'];
                if (Array.isArray(errors)) {
                    return errors.join(', ');
                } else {
                    return errors;
                }
            }
        }
    },
    computed: {
        availableWidgets: function availableWidgets() {
            if (this.form.anchor_type === 'url') return [];
            var anchorObject = this.getAnchorObject();
            if (anchorObject) {
                return anchorObject.widgets;
            }
            return [];
        },
        errorsParsed: function errorsParsed() {
            return this.errors || {};
        },
        availableLinkOptions: function availableLinkOptions() {
            return this.$store.state.availableLinkOptions;
        }
    },
    watch: {
        form: {
            handler: function handler(value) {
                this.$emit('input', value);
            },

            deep: true
        }
    },
    data: function data() {
        return {
            form: {},
            anchorOptions: [{ "label": "URL", "value": "url" }, { "label": "Wydarzenie", "value": "event" }, { "label": "Podstrona", "value": "page" }, { "label": "Stoisko", "value": "stand" }, { "label": "News", "value": "news" }]
        };
    }
};

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        listFilters: {
            type: Array
        },
        selectedFilters: {
            type: Object
        },
        allowDeselect: {
            default: true
        }
    },
    mounted: function mounted() {
        var _this = this;

        this.listFilters.forEach(function (entry) {
            entry.options.forEach(function (option) {
                if (option.defaultSelected) {
                    _this.setFilter(entry, option);
                }
            });
        });
    },

    methods: {
        setFilter: function setFilter(entry, option) {
            var newValue = this.selectedFilters[entry.query_param];
            var sameValue = newValue === option.value;
            if (!this.allowDeselect && sameValue) {
                return;
            }
            newValue = sameValue ? '' : option.value;
            var filter = {
                query_param: entry.query_param,
                value: newValue
            };
            this.$emit('setFilter', filter);
        },
        activeOption: function activeOption(entry, option) {
            var entrySelected = this.selectedFilters.hasOwnProperty(entry.query_param);
            var optionSelected = this.selectedFilters[entry.query_param] === option.value;
            return entrySelected && optionSelected;
        }
    }
};

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__(47);

var _promise2 = _interopRequireDefault(_promise);

var _cropperjs = __webpack_require__(459);

var _cropperjs2 = _interopRequireDefault(_cropperjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            cropperjsInstance: {}
        };
    },

    methods: {
        emitChanges: function emitChanges() {
            this.$emit('update:croppers', this.croppers);
        },
        destroyCroppers: function destroyCroppers() {
            var _this = this;

            this.croppers.forEach(function (cropper) {
                if (_this.cropperjsInstance[cropper.id]) {
                    _this.cropperjsInstance[cropper.id].destroy();
                    delete _this.cropperjsInstance[cropper.id];
                }
            });
        },
        updateData: function updateData() {
            var _this2 = this;

            this.croppers.forEach(function (cropper) {
                cropper.params = _this2.cropperjsInstance[cropper.id].getData();
            });
            this.emitChanges();
        },
        initializeCroppers: function initializeCroppers() {
            var _this3 = this;

            if (!this.photo) {
                return;
            }

            this.destroyCroppers();

            var convertInitToPromise = function convertInitToPromise(cropper) {
                return new _promise2.default(function (resolve, reject) {
                    _this3.cropperjsInstance[cropper.id] = _this3.initializeCropper(cropper, resolve);
                });
            };

            var croppersDone = this.croppers.map(convertInitToPromise);

            _promise2.default.all(croppersDone).then(this.updateData);
        },
        initializeCropper: function initializeCropper(cropper, resolve) {
            var _this4 = this;

            return new _cropperjs2.default(document.getElementById(cropper.id), {
                aspectRatio: cropper.aspect,
                zoomable: false,
                scalable: false,
                checkCrossOrigin: false,
                ready: function ready(e) {
                    if (cropper.params) {
                        e.target.cropper.setData(cropper.params);
                    }
                    e.target.addEventListener('cropend', _this4.updateData);
                    resolve();
                }
            });
        },
        onImageChange: function onImageChange(file) {
            this.$emit('update:photo', file);
            setTimeout(this.initializeCroppers, 0);
        }
    },
    props: ['croppers', 'photo', 'errors'],
    watch: {
        photo: function photo(value) {
            setTimeout(this.initializeCroppers, 0);
        }
    }
};

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _api = __webpack_require__(2);

exports.default = {
    props: ["bus"],
    data: function data() {
        return {
            photos: {},
            dialogFormVisible: false,
            page: 1,
            search: '',
            pageSize: 10,
            count: 0,
            loading: false
        };
    },

    watch: {
        dialogFormVisible: function dialogFormVisible(value) {
            if (value) {
                this.resetFilters();
                this.fetchData();
            }
        }
    },
    mounted: function mounted() {
        this.bus.$on('openPhotosDialog', this.openDialog);
    },

    methods: {
        resetFilters: function resetFilters() {
            this.search = '';
            this.page = 1;
        },
        searchData: function searchData() {
            this.page = 1;
            this.fetchData();
        },
        fetchData: function fetchData() {
            var _this = this;

            var filters = {
                q: this.search,
                page: this.page
            };
            this.loading = true;
            this.photos = [];
            _api.Image.all(filters).then(function (response) {
                _this.photos = response.data.results;
                _this.pageSize = response.data.page_size;
                _this.count = response.data.count;
                _this.loading = false;
            });
        },
        openDialog: function openDialog() {
            this.dialogFormVisible = true;
        },
        handleClose: function handleClose(done) {
            this.dialogFormVisible = false;
        },
        cancelForm: function cancelForm() {
            this.dialogFormVisible = false;
            this.$emit('cancel');
        },
        submitPhoto: function submitPhoto(photo) {
            this.$emit('submit', photo);
            this.dialogFormVisible = false;
        },
        handlePageChange: function handlePageChange(value) {
            this.page = value;
            this.fetchData();
        },
        truncate: function truncate(text) {
            if (text) {
                return text.slice(0, 20);
            }
            return '';
        }
    }
};

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__(582);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ["value"],
    created: function created() {
        var _this = this;

        this.submitSearch = (0, _lodash2.default)(function () {
            _this.$emit('submit');
        }, 300);
    },

    methods: {
        onInput: function onInput(value) {
            this.$emit('input', value);
            this.submitSearch();
        }
    }
};

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _api = __webpack_require__(2);

exports.default = {
    methods: {
        getChildPath: function getChildPath(parentPath, childPath) {
            if (parentPath === undefined) {
                return childPath;
            }
            if (parentPath.endsWith('/')) {
                return '' + parentPath + childPath;
            }
            return parentPath + '/' + childPath;
        },
        handleOpen: function handleOpen() {},
        handleClose: function handleClose() {},

        handleSelect: function handleSelect(a, b) {},
        logout: function logout() {
            var _this = this;

            this.$confirm(this.$i18n.t('areYouSure'), this.$i18n.t('logout'), {}).then(function () {
                window.localStorage.removeItem('token');
                _this.$router.push('/login');
            }).catch(function () {});
        },
        refreshFrontend: function refreshFrontend() {
            var _this2 = this;

            var msg = 'Zmiany z panelu administracyjnego zostaną wprowadzone na stronę opener.pl';
            this.$confirm(msg, 'Aktualizacja', {
                type: 'warning'
            }).then(function () {
                _api.SiteSettings.refresh().then(function (response) {
                    _this2.$message({
                        message: 'Rozpoczęto aktualizację. Zmiany zostaną wprowadzone za kilka minut.',
                        type: 'success'
                    });
                }).catch(function (error) {
                    var status = error.response.status;
                    var msg = 'Wystąpił błąd podczas łączenia z serwerem. Spróbuj ponownie za chwilę.';

                    if (status === 400) {
                        msg = 'Proces aktualizacji jest w trakcie. Poczekaj aż się zakończy.';
                    }

                    if (status === 406) {
                        msg = 'Proces aktualizacji można przeprowadzić jedynie na środowisku produkcyjnym.';
                    }

                    _this2.$message({
                        message: msg,
                        type: 'error'
                    });
                });
            });
        }
    },
    computed: {
        availableRoutes: function availableRoutes() {
            return this.$router.options.routes.filter(function (route) {
                return !route.hidden;
            });
        }
    }
};

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__(30);

var _axios2 = _interopRequireDefault(_axios);

var _tinymce = __webpack_require__(619);

var _tinymce2 = _interopRequireDefault(_tinymce);

__webpack_require__(618);

__webpack_require__(480);

__webpack_require__(481);

var _PhotosDialog = __webpack_require__(239);

var _PhotosDialog2 = _interopRequireDefault(_PhotosDialog);

var _vue = __webpack_require__(8);

var _vue2 = _interopRequireDefault(_vue);

var _api = __webpack_require__(2);

__webpack_require__(594);

__webpack_require__(602);

__webpack_require__(596);

__webpack_require__(616);

__webpack_require__(600);

__webpack_require__(604);

__webpack_require__(606);

__webpack_require__(610);

__webpack_require__(612);

__webpack_require__(614);

__webpack_require__(608);

__webpack_require__(598);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        value: { type: String },
        simple: { type: Boolean }
    },
    data: function data() {
        var _this = this;

        return {
            bus: new _vue2.default(),
            activeInput: null,
            innerVisible: false,
            simpleEditorInit: {
                menubar: false,
                plugins: "advlist image autoresize imagetools textcolor colorpicker paste media link code",
                toolbar: "bold italic backcolor forecolor | link code",
                file_browser_callback: function file_browser_callback(field_name, url, type, win) {
                    _this.activeInput = win.document.getElementById(field_name);
                    _this.openDialog();
                }
            },
            editorInit: {
                menubar: false,
                image_advtab: true,
                extended_valid_elements: "svg[*],defs[*],pattern[*],desc[*],metadata[*],g[*],mask[*],path[*],line[*],marker[*],rect[*],circle[*],ellipse[*],polygon[*],polyline[*],linearGradient[*],radialGradient[*],stop[*],image[*],view[*],text[*],textPath[*],title[*],tspan[*],glyph[*],symbol[*],switch[*],use[*]",
                plugins: "advlist image autoresize imagetools textcolor colorpicker paste media link lists code",
                toolbar: "undo redo | formatselect fontsizeselect | bold italic underline backcolor forecolor | alignleft aligncenter alignright alignjustify | bullist numlist | removeformat | image media link code | spotify arrowButton blackButton",
                block_formats: 'Paragraph=p;Header 3=h3;Header 4=h4;Header 5=h5',
                content_css: '/static/wyswig.css',

                paste_data_images: true,
                setup: function setup(editor) {
                    editor.addButton('spotify', {
                        text: 'Spotify',
                        icon: false,
                        onclick: function onclick() {
                            _this.addSpotify(editor);
                        }
                    });
                    editor.addButton('arrowButton', {
                        text: 'Przycisk - strzałka',
                        icon: false,
                        onclick: function onclick() {
                            _this.addArrowButton(editor);
                        }
                    });
                    editor.addButton('blackButton', {
                        text: 'Czarny przycisk',
                        icon: false,
                        onclick: function onclick() {
                            _this.addBlackButton(editor);
                        }
                    });
                },
                file_browser_callback: function file_browser_callback(field_name, url, type, win) {
                    _this.activeInput = win.document.getElementById(field_name);
                    _this.openDialog();
                }
            }
        };
    },

    watch: {
        value: function value(_value) {
            if (_value === undefined) {
                this.$emit('input', '');
            }
        }
    },
    components: {
        PhotosDialog: _PhotosDialog2.default
    },
    methods: {
        sendFile: function sendFile(option) {
            var _this2 = this;

            var data = new FormData();
            data.append("file", option.file, option.file.name);
            return _api.Attachment.upload(data).then(function (response) {
                _this2.uploadSuccess(response);
            }).catch(function (error) {
                _this2.uploadError(error);
            });
        },
        uploadSuccess: function uploadSuccess(response) {
            this.activeInput.value = response.data.file;
            this.closeDialog();
        },
        uploadError: function uploadError(error) {
            console.error(error, 'error while file uploading');
            this.$message({
                message: "Wystąpił problem podczas wysyłania pliku.",
                type: 'error'
            });
        },
        openDialog: function openDialog() {
            this.innerVisible = true;
        },
        closeDialog: function closeDialog() {
            this.innerVisible = false;
        },
        addSpotify: function addSpotify(editor) {
            var _this3 = this;

            this.$prompt('Podaj identyfikator URI playlisty', 'Spotify', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Anuluj'
            }).then(function (value) {
                editor.insertContent(_this3.getSpotifyHTML(value.value));
            }).catch(function () {});
        },
        addArrowButton: function addArrowButton(editor) {
            var button = this.getArrowButtonHTML('Nazwa przycisku');
            editor.insertContent(button);
        },
        getArrowButtonHTML: function getArrowButtonHTML(title) {
            return '\n              <div class="arrow-wrapper">\n                <span class="text">\n                  <a href="#">' + title + '</a>\n                </span>\n                <svg class="goto-svg" xmlns="http://www.w3.org/2000/svg" width="31" height="9" viewBox="0 0 31 9">\n                  <path class="cls-1" d="M26.229,0.217l4.2,4.21-4.2,4.211"/>\n                  <path class="cls-1" d="M29.375,4.739H0.625"/>\n                </svg>\n              </div>\n            ';
        },
        addBlackButton: function addBlackButton(editor) {
            var button = this.getBlackButtonHTML('Nazwa przycisku');
            editor.insertContent(button);
        },
        getBlackButtonHTML: function getBlackButtonHTML(title) {
            return '\n              <button class="btn btn--black btn--inline-block">' + title + '</button>\n            ';
        },
        getSpotifyHTML: function getSpotifyHTML(spotifyURI) {
            var button = '\n                <a href="' + spotifyURI + '" class="wysiwyg-button">\n                  <span class="wysiwyg-button__content">\n                    <span class="wysiwyg-button__text">Pos\u0142uchaj na&nbsp;</span>\n                    <span class="sr-only">Spotify</span>\n                    <svg class="wysiwyg-button__logo" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 559 168">\n                     <path class="wysiwyg-button__path" fill="#000" d="m83.996 0.277c-46.249 0-83.743 37.493-83.743 83.742 0 46.251 37.494 83.741 83.743 83.741 46.254 0 83.744-37.49 83.744-83.741 0-46.246-37.49-83.738-83.745-83.738l0.001-0.004zm38.404 120.78c-1.5 2.46-4.72 3.24-7.18 1.73-19.662-12.01-44.414-14.73-73.564-8.07-2.809 0.64-5.609-1.12-6.249-3.93-0.643-2.81 1.11-5.61 3.926-6.25 31.9-7.288 59.263-4.15 81.337 9.34 2.46 1.51 3.24 4.72 1.73 7.18zm10.25-22.802c-1.89 3.072-5.91 4.042-8.98 2.152-22.51-13.836-56.823-17.843-83.448-9.761-3.453 1.043-7.1-0.903-8.148-4.35-1.04-3.453 0.907-7.093 4.354-8.143 30.413-9.228 68.222-4.758 94.072 11.127 3.07 1.89 4.04 5.91 2.15 8.976v-0.001zm0.88-23.744c-26.99-16.031-71.52-17.505-97.289-9.684-4.138 1.255-8.514-1.081-9.768-5.219-1.254-4.14 1.08-8.513 5.221-9.771 29.581-8.98 78.756-7.245 109.83 11.202 3.73 2.209 4.95 7.016 2.74 10.733-2.2 3.722-7.02 4.949-10.73 2.739zm94.56 3.072c-14.46-3.448-17.03-5.868-17.03-10.953 0-4.804 4.52-8.037 11.25-8.037 6.52 0 12.98 2.455 19.76 7.509 0.2 0.153 0.46 0.214 0.71 0.174 0.26-0.038 0.48-0.177 0.63-0.386l7.06-9.952c0.29-0.41 0.21-0.975-0.18-1.288-8.07-6.473-17.15-9.62-27.77-9.62-15.61 0-26.52 9.369-26.52 22.774 0 14.375 9.41 19.465 25.67 23.394 13.83 3.187 16.17 5.857 16.17 10.629 0 5.29-4.72 8.58-12.32 8.58-8.44 0-15.33-2.85-23.03-9.51-0.19-0.17-0.45-0.24-0.69-0.23-0.26 0.02-0.49 0.14-0.65 0.33l-7.92 9.42c-0.33 0.4-0.29 0.98 0.09 1.32 8.96 8 19.98 12.22 31.88 12.22 16.82 0 27.69-9.19 27.69-23.42 0.03-12.007-7.16-18.657-24.77-22.941l-0.03-0.013zm62.86-14.26c-7.29 0-13.27 2.872-18.21 8.757v-6.624c0-0.523-0.42-0.949-0.94-0.949h-12.95c-0.52 0-0.94 0.426-0.94 0.949v73.601c0 0.52 0.42 0.95 0.94 0.95h12.95c0.52 0 0.94-0.43 0.94-0.95v-23.23c4.94 5.53 10.92 8.24 18.21 8.24 13.55 0 27.27-10.43 27.27-30.369 0.02-19.943-13.7-30.376-27.26-30.376l-0.01 0.001zm12.21 30.375c0 10.149-6.25 17.239-15.21 17.239-8.85 0-15.53-7.41-15.53-17.239 0-9.83 6.68-17.238 15.53-17.238 8.81-0.001 15.21 7.247 15.21 17.237v0.001zm50.21-30.375c-17.45 0-31.12 13.436-31.12 30.592 0 16.972 13.58 30.262 30.91 30.262 17.51 0 31.22-13.39 31.22-30.479 0-17.031-13.62-30.373-31.01-30.373v-0.002zm0 47.714c-9.28 0-16.28-7.46-16.28-17.344 0-9.929 6.76-17.134 16.07-17.134 9.34 0 16.38 7.457 16.38 17.351 0 9.927-6.8 17.127-16.17 17.127zm68.27-46.53h-14.25v-14.566c0-0.522-0.42-0.948-0.94-0.948h-12.95c-0.52 0-0.95 0.426-0.95 0.948v14.566h-6.22c-0.52 0-0.94 0.426-0.94 0.949v11.127c0 0.522 0.42 0.949 0.94 0.949h6.22v28.795c0 11.63 5.79 17.53 17.22 17.53 4.64 0 8.49-0.96 12.12-3.02 0.3-0.16 0.48-0.48 0.48-0.82v-10.6c0-0.32-0.17-0.63-0.45-0.8-0.28-0.18-0.63-0.19-0.92-0.04-2.49 1.25-4.9 1.83-7.6 1.83-4.15 0-6.01-1.89-6.01-6.11v-26.76h14.25c0.52 0 0.94-0.426 0.94-0.949v-11.126c0.02-0.523-0.4-0.949-0.93-0.949l-0.01-0.006zm49.64 0.057v-1.789c0-5.263 2.02-7.61 6.54-7.61 2.7 0 4.87 0.536 7.3 1.346 0.3 0.094 0.61 0.047 0.85-0.132 0.25-0.179 0.39-0.466 0.39-0.77v-10.91c0-0.417-0.26-0.786-0.67-0.909-2.56-0.763-5.84-1.546-10.76-1.546-11.95 0-18.28 6.734-18.28 19.467v2.74h-6.22c-0.52 0-0.95 0.426-0.95 0.948v11.184c0 0.522 0.43 0.949 0.95 0.949h6.22v44.405c0 0.53 0.43 0.95 0.95 0.95h12.94c0.53 0 0.95-0.42 0.95-0.95v-44.402h12.09l18.52 44.402c-2.1 4.66-4.17 5.59-6.99 5.59-2.28 0-4.69-0.68-7.14-2.03-0.23-0.12-0.51-0.14-0.75-0.07-0.25 0.09-0.46 0.27-0.56 0.51l-4.39 9.63c-0.21 0.46-0.03 0.99 0.41 1.23 4.58 2.48 8.71 3.54 13.82 3.54 9.56 0 14.85-4.46 19.5-16.44l22.46-58.037c0.12-0.292 0.08-0.622-0.1-0.881-0.17-0.257-0.46-0.412-0.77-0.412h-13.48c-0.41 0-0.77 0.257-0.9 0.636l-13.81 39.434-15.12-39.46c-0.14-0.367-0.49-0.61-0.88-0.61h-22.12v-0.003zm-28.78-0.057h-12.95c-0.52 0-0.95 0.426-0.95 0.949v56.481c0 0.53 0.43 0.95 0.95 0.95h12.95c0.52 0 0.95-0.42 0.95-0.95v-56.477c0-0.523-0.42-0.949-0.95-0.949v-0.004zm-6.4-25.719c-5.13 0-9.29 4.152-9.29 9.281 0 5.132 4.16 9.289 9.29 9.289s9.28-4.157 9.28-9.289c0-5.128-4.16-9.281-9.28-9.281zm113.42 43.88c-5.12 0-9.11-4.115-9.11-9.112s4.04-9.159 9.16-9.159 9.11 4.114 9.11 9.107c0 4.997-4.04 9.164-9.16 9.164zm0.05-17.365c-4.67 0-8.2 3.71-8.2 8.253 0 4.541 3.51 8.201 8.15 8.201 4.67 0 8.2-3.707 8.2-8.253 0-4.541-3.51-8.201-8.15-8.201zm2.02 9.138l2.58 3.608h-2.18l-2.32-3.31h-1.99v3.31h-1.82v-9.564h4.26c2.23 0 3.69 1.137 3.69 3.051 0.01 1.568-0.9 2.526-2.21 2.905h-0.01zm-1.54-4.315h-2.37v3.025h2.37c1.18 0 1.89-0.579 1.89-1.514 0-0.984-0.71-1.511-1.89-1.511z"/>\n                    </svg>\n                  </span>\n                </a>\n                ';
            return button;
        },
        openPhotosDialog: function openPhotosDialog() {
            this.bus.$emit('openPhotosDialog');
        },
        dialogCancelled: function dialogCancelled() {},
        dialogSubmitted: function dialogSubmitted(photo) {
            this.activeInput.value = photo;
            this.closeDialog();
        }
    }
};

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(46);

var _assign2 = _interopRequireDefault(_assign);

var _stringify = __webpack_require__(81);

var _stringify2 = _interopRequireDefault(_stringify);

var _BaseField = __webpack_require__(624);

var _BaseField2 = _interopRequireDefault(_BaseField);

var _api = __webpack_require__(2);

var _availableFieldsForms = __webpack_require__(406);

var _availableFieldsForms2 = _interopRequireDefault(_availableFieldsForms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ["field", "bus"],
    data: function data() {
        return {
            formCopy: {},
            originalForm: {},
            fieldComponent: null,
            errors: {},
            dialogFormVisible: false
        };
    },
    mounted: function mounted() {
        this.bus.$on('openFieldDialog', this.openDialog);
    },

    methods: {
        openDialog: function openDialog(field, errors) {
            this.formCopy = JSON.parse((0, _stringify2.default)(field));
            this.originalForm = field;
            this.fieldComponent = _availableFieldsForms2.default[field.resourcetype];
            this.dialogFormVisible = true;
            this.errors = errors || {};
        },
        handleClose: function handleClose(done) {
            var formWasChanged = (0, _stringify2.default)(this.formCopy) !== (0, _stringify2.default)(this.originalForm);
            if (formWasChanged) {
                this.$confirm('Zmiany zostaną utracone.').then(function (response) {
                    done();
                }).catch(function (_) {});
            } else {
                done();
            }
        },
        cancelForm: function cancelForm() {
            this.dialogFormVisible = false;
            this.$emit('cancel');
        },
        submitForm: function submitForm() {
            var _this = this;

            _api.CustomForm.validateField(this.formCopy).then(function (response) {
                _this.$emit('submit');
                _this.originalForm = (0, _assign2.default)(_this.originalForm, _this.formCopy);
                _this.dialogFormVisible = false;
            }).catch(this.errorHandler);
        }
    },
    components: {
        BaseField: _BaseField2.default
    }
};

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _FieldDialog = __webpack_require__(622);

var _FieldDialog2 = _interopRequireDefault(_FieldDialog);

var _api = __webpack_require__(2);

var _vue = __webpack_require__(8);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ["fields", "errors"],
    data: function data() {
        return {
            bus: new _vue2.default(),
            selectedField: {}
        };
    },
    beforeMount: function beforeMount() {
        this.fetchData();
    },

    components: {
        FieldDialog: _FieldDialog2.default
    },
    methods: {
        fetchData: function fetchData() {
            this.$store.dispatch('fetchFieldTypes');
        },
        editField: function editField(field, errors) {
            this.bus.$emit('openFieldDialog', field, errors);
        },
        addField: function addField(type) {
            this.fields.push({
                'resourcetype': type
            });
        },
        getLabel: function getLabel(resourcetype) {
            var field = this.$store.state.fieldTypes[resourcetype];
            var label = field && field.label;
            return label || resourcetype;
        },
        dialogCancelled: function dialogCancelled() {},
        dialogSubmitted: function dialogSubmitted() {
            this.$forceUpdate();
        },
        removeField: function removeField(field, i) {
            this.removeItemFromFormset(this.fields, field);
            this.removeItemFromFormset(this.errors, this.errors[i]);
        }
    }
};

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['form', 'errors']
};

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['form', 'errors'],
    data: function data() {
        return {
            charFieldTypes: [{ label: 'Tekst', value: 'StandardCharField' }, { label: 'Tylko litery', value: 'AlphabeticField' }, { label: 'Data', value: 'DateField' }, { label: 'Data i czas', value: 'DateTimeField' }, { label: 'Email', value: 'EmailField' }, { label: 'Link', value: 'URLField' }, { label: 'Liczba', value: 'NumberField' }]
        };
    }
};

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['form', 'errors'],
    methods: {
        addChoice: function addChoice() {
            if (this.form.choices === undefined) this.form.choices = [];
            this.form.choices.push({});
            this.$forceUpdate();
        },
        removeChoice: function removeChoice(choice) {
            this.removeItemFromFormset(this.form.choices, choice);
            this.$forceUpdate();
        }
    }
};

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['form', 'errors']
};

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['form', 'errors']
};

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(81);

var _stringify2 = _interopRequireDefault(_stringify);

var _values = __webpack_require__(413);

var _values2 = _interopRequireDefault(_values);

var _BaseWidget = __webpack_require__(240);

var _BaseWidget2 = _interopRequireDefault(_BaseWidget);

var _api = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ["widget", "bus"],
    data: function data() {
        return {
            formCopy: {},
            originalForm: {},
            widgetComponent: null,
            errors: {},
            dialogFormVisible: false
        };
    },

    computed: {
        widgetType: function widgetType() {
            var _this = this;

            var typeFilter = function typeFilter(type) {
                return type['resourcetype'] === _this.formCopy.resourcetype;
            };
            var foundType = (0, _values2.default)(this.$store.state.idBasedWidgetTypes).find(typeFilter);
            if (foundType) {
                return foundType;
            }
            return {};
        },
        availableWidgets: function availableWidgets() {
            if (this.formCopy.resourcetype) {
                var ctype = this.widgetType['polymorphic_ctype'];
                return this.$store.state.availableWidgets[ctype];
            }
            return [];
        }
    },
    mounted: function mounted() {
        this.bus.$on('openWidgetDialog', this.openDialog);
    },

    watch: {
        dialogFormVisible: function dialogFormVisible(value) {
            if (!value) {
                this.widgetComponent = null;
            }
        }
    },
    methods: {
        openDialog: function openDialog(widget, errors) {
            this.formCopy = JSON.parse((0, _stringify2.default)(widget));
            this.originalForm = widget;
            this.widgetComponent = this.getWidgetComponent(widget.resourcetype);
            this.dialogFormVisible = true;
            this.errors = errors || {};
        },
        globalWidgetSet: function globalWidgetSet(e) {
            var widget = this.availableWidgets.find(function (widget) {
                return widget.id === e;
            });
            if (widget) {
                this.$set(this, 'formCopy', {
                    name_pl: widget.name_pl,
                    id: widget.id,
                    resourcetype: this.formCopy.resourcetype
                });
            }
        },
        handleClose: function handleClose(done) {
            var formWasChanged = (0, _stringify2.default)(this.formCopy) !== (0, _stringify2.default)(this.originalForm);
            if (formWasChanged) {
                this.$confirm('Zmiany zostaną utracone.').then(function (response) {
                    done();
                }).catch(function (_) {});
            } else {
                done();
            }
        },
        cancelForm: function cancelForm() {
            this.dialogFormVisible = false;
            this.$emit('cancel');
        },
        submitForm: function submitForm() {
            var _this2 = this;

            _api.Widget.validate(this.formCopy).then(function (response) {
                _this2.$emit('submit', _this2.formCopy, _this2.originalForm);
                _this2.dialogFormVisible = false;
            }).catch(this.errorHandler);
        }
    },
    components: {
        BaseWidget: _BaseWidget2.default
    }
};

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _WidgetDialog = __webpack_require__(629);

var _WidgetDialog2 = _interopRequireDefault(_WidgetDialog);

var _api = __webpack_require__(2);

var _vue = __webpack_require__(8);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ["widgets", "errors", "lessDetails"],
    data: function data() {
        return {
            bus: new _vue2.default(),
            selectedWidget: {}
        };
    },
    beforeMount: function beforeMount() {
        this.fetchData();
    },

    components: {
        WidgetDialog: _WidgetDialog2.default
    },
    methods: {
        fetchData: function fetchData() {
            this.$store.dispatch('fetchAvailableWidgets');
            this.$store.dispatch('fetchWidgetTypes');
        },
        editWidget: function editWidget(widget, errors) {
            this.bus.$emit('openWidgetDialog', widget, errors);
        },
        addWidget: function addWidget(type) {
            this.widgets.push({
                'resourcetype': type.resourcetype
            });
        },
        getLabel: function getLabel(resourcetype) {
            var widget = this.$store.state.widgetTypes[resourcetype];
            var label = widget && widget.label;
            return label || resourcetype;
        },
        dialogCancelled: function dialogCancelled() {},
        dialogSubmitted: function dialogSubmitted(oldForm, newForm) {
            var index = this.widgets.indexOf(newForm);
            if (index > -1) {
                this.$set(this.widgets, index, oldForm);
            }
            this.$forceUpdate();
        },
        iconLoadError: function iconLoadError(error) {
            console.log('Nie znaleziono ikony dla widgetu ', error);
        },
        removeWidget: function removeWidget(widget, i) {
            this.removeItemFromFormset(this.widgets, widget);
            this.removeItemFromFormset(this.errors, this.errors[i]);
        }
    }
};

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _api = __webpack_require__(2);

var _ArtistsPreview = __webpack_require__(631);

var _ArtistsPreview2 = _interopRequireDefault(_ArtistsPreview);

var _EditionInput = __webpack_require__(18);

var _EditionInput2 = _interopRequireDefault(_EditionInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ["form", "errors"],
    data: function data() {
        return {
            availableTags: []
        };
    },
    mounted: function mounted() {
        this.fetchData();
    },

    components: {
        ArtistsPreview: _ArtistsPreview2.default,
        EditionInput: _EditionInput2.default
    },
    watch: {
        form: function form(value) {
            if (value.tags === undefined) {
                this.$set(this.form, 'tags', []);
            }
        }
    },
    methods: {
        fetchData: function fetchData() {
            var _this = this;

            this.$store.dispatch('fetchEditions');
            _api.Tag.availableTags().then(function (response) {
                var musicTags = response.data.find(function (obj) {
                    return obj.label === 'music';
                });
                _this.availableTags = musicTags.options;
            });
        }
    }
};

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _api = __webpack_require__(2);

exports.default = {
    props: ["form"],
    data: function data() {
        return {
            previewIsUpdating: false,
            data: []
        };
    },

    methods: {
        updatePreview: function updatePreview() {
            var _this = this;

            if (this.previewIsUpdating) return;
            this.previewIsUpdating = true;
            _api.ArtistsListWidget.preview(this.form).then(function (response) {
                _this.previewIsUpdating = false;
                _this.data = response.data;
            }, function (error) {
                _this.previewIsUpdating = false;
                console.error(error);
            });
        }
    },
    mounted: function mounted() {
        this.updatePreview();
    },

    watch: {
        form: {
            handler: function handler(value) {
                this.updatePreview();
            },

            deep: true
        }
    }
};

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['form', 'errors']
};

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _api = __webpack_require__(2);

var _lodash = __webpack_require__(43);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['form', 'errors'],
    methods: {
        addSection: function addSection() {
            var blankObject = {
                key: (0, _lodash2.default)()
            };
            if (!Array.isArray(this.form.boxes)) {
                this.$emit('update:form', (0, _extends3.default)({}, this.form, {
                    boxes: [blankObject]
                }));
            } else {
                this.form.boxes.push(blankObject);
            }
        }
    }
};

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _lodash = __webpack_require__(43);

var _lodash2 = _interopRequireDefault(_lodash);

var _api = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['form', 'errors'],
    data: function data() {
        return {
            types: [{ value: 'link', label: 'Link' }, { value: 'title', label: 'Tekst' }]
        };
    },

    methods: {
        getHeaderLabel: function getHeaderLabel(item) {
            if (item.item_type === undefined) {
                return 'Nowy breadcrumb';
            } else if (item.item_type === 'link') {
                return 'Link';
            } else if (item.item_type === 'title') {
                return 'Tekst ' + (item.title_pl || '');
            }
        },
        addSection: function addSection() {
            var blankObject = {
                key: (0, _lodash2.default)(),
                link: {}
            };
            if (!Array.isArray(this.form.items)) {
                this.$emit('update:form', (0, _extends3.default)({}, this.form, {
                    items: [blankObject]
                }));
            } else {
                this.form.items.push(blankObject);
            }
        },
        typeChanged: function typeChanged(item) {
            if (item.item_type === 'title') {
                item.link = null;
            }
        }
    }
};

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['form', 'errors'],
    data: function data() {
        return {
            maxColumns: 4
        };
    },

    methods: {
        columnsChanged: function columnsChanged() {
            if (!this.form.columns) return;
            for (var i = this.form.columns + 1; i <= this.maxColumns; i++) {
                this.form['column_' + i + '_pl'] = '';
                this.form['column_' + i + '_en'] = '';
            }
        }
    }
};

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _api = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['form', 'errors'],
    data: function data() {
        return {
            availableTileTypes: [{ imgSrc: '/static/tiles/huge_logotype.png', label: "Duże logo", value: "big_logo" }, { imgSrc: '/static/tiles/small_logotype.png', label: "Małe logo w rogu", value: "small_logo" }, { imgSrc: '/static/tiles/no_logotype.png', label: "Brak loga", value: "no_logo" }],
            tags: []
        };
    },
    mounted: function mounted() {
        this.fetchData();
    },

    methods: {
        fetchData: function fetchData() {
            var _this = this;

            _api.OtherEvent.tags().then(function (response) {
                _this.tags = response.data;
            });
        },
        addSection: function addSection() {
            var blankObject = {};
            if (!Array.isArray(this.form.sections)) {
                this.$emit('update:form', (0, _extends3.default)({}, this.form, {
                    sections: [blankObject]
                }));
            } else {
                this.form.sections.push(blankObject);
            }
        }
    }
};

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _api = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['form', 'errors'],
    methods: {
        addSection: function addSection() {
            var blankObject = {};
            if (!Array.isArray(this.form.questions)) {
                this.$emit('update:form', (0, _extends3.default)({}, this.form, {
                    questions: [blankObject]
                }));
            } else {
                this.form.questions.push(blankObject);
            }
        }
    }
};

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _api = __webpack_require__(2);

var _EditionInput = __webpack_require__(18);

var _EditionInput2 = _interopRequireDefault(_EditionInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['form', 'errors'],
    data: function data() {
        return {
            categories: []
        };
    },
    mounted: function mounted() {
        var _this = this;

        _api.StandCategory.fetch().then(function (response) {
            _this.categories = response.data;
        });
    },

    components: {
        EditionInput: _EditionInput2.default
    }
};

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _api = __webpack_require__(2);

exports.default = {
    props: ['form', 'errors'],
    data: function data() {
        return {
            forms: []
        };
    },

    methods: {
        fetchData: function fetchData() {
            var _this = this;

            _api.CustomForm.all().then(function (response) {
                _this.forms = response.data;
            });
        }
    },
    mounted: function mounted() {
        this.fetchData();
    }
};

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _keys = __webpack_require__(31);

var _keys2 = _interopRequireDefault(_keys);

var _api = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['form', 'errors'],
    data: function data() {
        return {
            galleries: []
        };
    },
    mounted: function mounted() {
        this.fetchData();
    },

    computed: {
        groupedGalleries: function groupedGalleries() {
            var _this = this;

            var groupedDict = {};

            var setDefault = function setDefault(gallery) {
                return groupedDict[gallery.edition] = [];
            };
            this.galleries.forEach(setDefault);

            var pushGallery = function pushGallery(gallery) {
                return groupedDict[gallery.edition].push(gallery);
            };
            this.galleries.forEach(pushGallery);

            var createProperFormat = function createProperFormat(key) {
                return { label: _this.editionLabels[key], options: groupedDict[key] };
            };
            var groupedArray = (0, _keys2.default)(groupedDict).map(createProperFormat);

            return groupedArray;
        },
        editionLabels: function editionLabels() {
            var mappedEditions = {};
            var mapEdition = function mapEdition(edition) {
                return mappedEditions[edition.id] = edition.year.toString();
            };
            this.$store.state.editions.forEach(mapEdition);
            return mappedEditions;
        }
    },
    methods: {
        fetchData: function fetchData() {
            var _this2 = this;

            this.$store.dispatch('fetchEditions');
            _api.Folder.all().then(function (response) {
                _this2.galleries = response.data;
            });
        },
        addSection: function addSection() {
            var blankObject = {};
            if (!Array.isArray(this.form.sections)) {
                this.$emit('update:form', (0, _extends3.default)({}, this.form, {
                    sections: [blankObject]
                }));
            } else {
                this.form.sections.push(blankObject);
            }
        }
    }
};

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['form', 'errors']
};

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _lodash = __webpack_require__(43);

var _lodash2 = _interopRequireDefault(_lodash);

var _api = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['form', 'errors'],
    methods: {
        addSection: function addSection() {
            var blankObject = {
                key: (0, _lodash2.default)(),
                link: {}
            };
            if (!Array.isArray(this.form.tiles)) {
                this.$emit('update:form', (0, _extends3.default)({}, this.form, {
                    tiles: [blankObject]
                }));
            } else {
                this.form.tiles.push(blankObject);
            }
        }
    }
};

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _api = __webpack_require__(2);

exports.default = {
    props: ['form', 'errors'],
    data: function data() {
        return {
            folders: []
        };
    },

    methods: {
        fetchData: function fetchData() {
            var _this = this;

            _api.InstagramFolder.all().then(function (response) {
                _this.folders = response.data;
            });
        }
    },
    mounted: function mounted() {
        this.fetchData();
    }
};

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuedraggable = __webpack_require__(241);

var _vuedraggable2 = _interopRequireDefault(_vuedraggable);

var _api = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['form', 'errors'],
    data: function data() {
        return {
            availableTags: {},
            availableTypes: []
        };
    },

    components: {
        draggable: _vuedraggable2.default
    },
    mounted: function mounted() {
        var _this = this;

        _api.Tag.availableTags().then(function (response) {
            _this.availableTypes = response.data.map(function (type) {
                return type.label;
            });
            var dictionary = {};
            response.data.forEach(function (type) {
                dictionary[type.label] = type.options;
            });
            _this.availableTags = dictionary;
        });
    },

    methods: {
        translateType: function translateType(type) {
            var translations = {
                "music": "Koncerty",
                "cinema": "Kino",
                "theater": "Teatr",
                "others": "Miasteczko"
            };
            return translations[type] || type;
        },
        resetTags: function resetTags(section) {
            section.tags = [];
        },
        tagsForType: function tagsForType(type) {
            if (!type) return [];
            return this.availableTags[type];
        },
        addSection: function addSection() {
            var blankObject = {};
            if (!Array.isArray(this.form.sections)) {
                this.$emit('update:form', (0, _extends3.default)({}, this.form, {
                    sections: [blankObject]
                }));
            } else {
                this.form.sections.push(blankObject);
            }
        }
    }
};

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['form', 'errors'],
    data: function data() {
        return {
            "mapPlaceholder": '<area alt="" title="VISA" href="https://visa.com" shape="rect" coords="1025, 314, 1166, 469" />'
        };
    }
};

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['form', 'errors']
};

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _api = __webpack_require__(2);

exports.default = {
    props: ['form', 'errors'],
    data: function data() {
        return {
            tags: []
        };
    },
    mounted: function mounted() {
        this.fetchData();
    },

    methods: {
        fetchData: function fetchData() {
            var _this = this;

            _api.News.tags().then(function (response) {
                _this.tags = response.data;
            });
        }
    }
};

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['form', 'errors']
};

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['form', 'errors'],
    methods: {
        addSection: function addSection() {
            var blankObject = {};
            if (!Array.isArray(this.form.slides)) {
                this.$emit('update:form', (0, _extends3.default)({}, this.form, {
                    slides: [blankObject]
                }));
            } else {
                this.form.slides.push(blankObject);
            }
        }
    }
};

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = __webpack_require__(32);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _api = __webpack_require__(2);

var _EditionInput = __webpack_require__(18);

var _EditionInput2 = _interopRequireDefault(_EditionInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['form', 'errors'],
    data: function data() {
        return {
            types: ["cinema", "theater"]
        };
    },

    methods: {
        translateType: function translateType(type) {
            var translations = {
                "music": "koncerty",
                "cinema": "kino",
                "theater": "teatr"
            };
            return translations[type] || type;
        },
        fetchData: function fetchData() {
            var _this = this;

            _api.OtherEvent.eventTypes().then(function (response) {
                _this.types = ["cinema", "theater"].concat((0, _toConsumableArray3.default)(response.data));
            });
        }
    },
    mounted: function mounted() {
        this.fetchData();
    },

    components: {
        EditionInput: _EditionInput2.default
    }
};

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _api = __webpack_require__(2);

var _lodash = __webpack_require__(43);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['form', 'errors'],
    methods: {
        addSection: function addSection() {
            var blankObject = {
                left_button_link_key: (0, _lodash2.default)('link_'),
                right_button_link_key: (0, _lodash2.default)('link_')
            };
            if (!Array.isArray(this.form.slides)) {
                this.$emit('update:form', (0, _extends3.default)({}, this.form, {
                    slides: [blankObject]
                }));
            } else {
                this.form.slides.push(blankObject);
            }
        }
    }
};

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _api = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['form', 'errors'],
    data: function data() {
        return {
            categories: []
        };
    },
    mounted: function mounted() {
        this.fetchData();
    },

    methods: {
        addSection: function addSection() {
            var blankObject = {};
            if (!Array.isArray(this.form.sections)) {
                this.$emit('update:form', (0, _extends3.default)({}, this.form, {
                    sections: [blankObject]
                }));
            } else {
                this.form.sections.push(blankObject);
            }
        },
        fetchData: function fetchData() {
            var _this = this;

            this.$store.dispatch('fetchEditions');
            _api.StandCategory.fetch().then(function (response) {
                _this.categories = response.data;
            });
        },
        getCategoryName: function getCategoryName(id) {
            var category = this.categories.find(function (category) {
                return category.id === id;
            });
            if (category) {
                return category.name_pl;
            }
        }
    }
};

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['form', 'errors']
};

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _api = __webpack_require__(2);

exports.default = {
    props: ['form', 'errors'],
    data: function data() {
        return {
            periods: [],
            tickets: [],
            types: [{ label: 'Pojedynczy bilet', value: 'ticket' }, { label: 'Okres sprzedaży', value: 'period' }]
        };
    },
    mounted: function mounted() {
        this.fetchData();
    },

    methods: {
        fetchData: function fetchData() {
            var _this = this;

            _api.Period.fetch().then(function (response) {
                _this.periods = response.data;
            });
            _api.Ticket.fetch().then(function (response) {
                _this.tickets = response.data;
            });
        }
    }
};

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = __webpack_require__(32);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _api = __webpack_require__(2);

var _EditionInput = __webpack_require__(18);

var _EditionInput2 = _interopRequireDefault(_EditionInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['form', 'errors'],
    data: function data() {
        return {
            types: ["cinema", "theater"]
        };
    },

    methods: {
        translateType: function translateType(type) {
            var translations = {
                "music": "koncerty",
                "cinema": "kino",
                "theater": "teatr"
            };
            return translations[type] || type;
        },
        fetchData: function fetchData() {
            var _this = this;

            _api.OtherEvent.eventTypes().then(function (response) {
                _this.types = ["cinema", "theater"].concat((0, _toConsumableArray3.default)(response.data));
            });
        }
    },
    mounted: function mounted() {
        this.fetchData();
    },

    components: {
        EditionInput: _EditionInput2.default
    }
};

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(5);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(4);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _ListFilterComponent = __webpack_require__(7);

var _ListFilterComponent2 = _interopRequireDefault(_ListFilterComponent);

var _api = __webpack_require__(2);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            filters: {
                available: [],
                selected: {}
            },
            data: [],
            count: 0,
            page: 1,
            pageSize: 100,
            listLoading: false,
            service: _api.Attachment
        };
    },

    methods: {
        formatDate: function formatDate(value) {
            if (value) {
                return (0, _moment2.default)(String(value)).format('MM/DD/YYYY hh:mm:ss');
            }
        },
        handlePageChange: function handlePageChange(val) {
            this.page = val;
            this.fetchData();
        },
        setFilter: function setFilter(filter) {
            this.page = 1;
            var key = filter.query_param;
            var value = filter.value;
            this.$set(this.filters.selected, key, value);
            this.fetchData();
        },
        fetchData: function fetchData() {
            var _this = this;

            var params = (0, _extends3.default)({
                page: this.page
            }, this.filters.selected);
            this.listLoading = true;
            this.service.fetch({}, { params: params }).then(function (response) {
                _this.count = response.data.count;
                _this.pageSize = response.data.page_size;
                _this.data = response.data.results;
                _this.listLoading = false;
            });
        },
        handleDelete: function handleDelete(index, row) {
            var _this2 = this;

            return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this2.$confirm(_this2.$i18n.t('deleteConfirmation'), _this2.$i18n.t('delete'), {
                                    type: 'warning'
                                });

                            case 2:

                                _this2.listLoading = true;
                                _context.next = 5;
                                return _this2.service.delete(row.id);

                            case 5:

                                _this2.listLoading = false;
                                _this2.$message({
                                    message: 'Element został usunięty',
                                    type: 'success'
                                });

                                _this2.fetchData();

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        }
    },
    mounted: function mounted() {
        this.fetchData();
    },

    components: {
        ListFilterComponent: _ListFilterComponent2.default
    }
};

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _api = __webpack_require__(2);

exports.default = {
    data: function data() {
        return {
            loading: false,
            redirectRoute: { name: 'Colors List' },
            form: {},
            errors: {},
            service: _api.Color
        };
    },
    mounted: function mounted() {
        this.fetchData();
    },

    methods: {
        fetchData: function fetchData() {
            var _this = this;

            if (this.$route.params.id) {
                this.service.get(this.$route.params.id).then(function (response) {
                    _this.form = response.data;
                });
            }
        },
        onSubmit: function onSubmit() {
            this.loading = true;
            var id = this.$route.params.id;
            var service = id ? this.service.update(id, this.form) : this.service.save(this.form);
            service.then(this.successHandler).catch(this.errorHandler);
        }
    }
};

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(5);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(4);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _api = __webpack_require__(2);

var _ListFilterComponent = __webpack_require__(7);

var _ListFilterComponent2 = _interopRequireDefault(_ListFilterComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            filters: {
                available: [],
                selected: {}
            },
            data: [],
            listLoading: false,
            service: _api.Color
        };
    },

    methods: {
        setFilter: function setFilter(filter) {
            this.page = 1;
            var key = filter.query_param;
            var value = filter.value;
            this.$set(this.filters.selected, key, value);
            this.fetchData();
        },
        fetchData: function fetchData() {
            var _this = this;

            var params = (0, _extends3.default)({
                page: this.page
            }, this.filters.selected);
            this.listLoading = true;
            this.service.fetch({}, { params: params }).then(function (response) {
                _this.data = response.data;
                _this.listLoading = false;
            });
        },
        handleDelete: function handleDelete(index, row) {
            var _this2 = this;

            return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this2.$confirm(_this2.$i18n.t('deleteConfirmation'), _this2.$i18n.t('delete'), {
                                    type: 'warning'
                                });

                            case 2:

                                _this2.listLoading = true;
                                _context.next = 5;
                                return _this2.service.delete(row.id);

                            case 5:

                                _this2.listLoading = false;
                                _this2.$message({
                                    message: 'Element został usunięty',
                                    type: 'success'
                                });

                                _this2.fetchData();

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        }
    },
    mounted: function mounted() {
        this.fetchData();
    },

    components: {
        ListFilterComponent: _ListFilterComponent2.default
    }
};

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _api = __webpack_require__(2);

var _EditionInput = __webpack_require__(18);

var _EditionInput2 = _interopRequireDefault(_EditionInput);

var _Sections = __webpack_require__(663);

var _Sections2 = _interopRequireDefault(_Sections);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            loading: false,
            redirectRoute: { name: 'CustomForms List' },
            form: {
                sections: []
            },
            errors: {},
            service: _api.CustomForm,
            fieldTypes: []
        };
    },
    mounted: function mounted() {
        this.fetchData();
    },

    methods: {
        fetchData: function fetchData() {
            var _this = this;

            if (this.$route.params.id) {
                this.loading = true;
                this.service.get(this.$route.params.id).then(function (response) {
                    _this.form = response.data;
                }).finally(function () {
                    _this.loading = false;
                });
            }
            this.service.fieldTypes().then(function (response) {
                _this.fieldTypes = response.data;
            });
        },
        onSubmit: function onSubmit() {
            this.loading = true;
            var id = this.$route.params.id;
            var service = id ? this.service.update(id, this.form) : this.service.save(this.form);
            service.then(this.successHandler).catch(this.errorHandler);
        }
    },
    components: {
        EditionInput: _EditionInput2.default,
        Sections: _Sections2.default
    }
};

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(5);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(4);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _api = __webpack_require__(2);

var _ListFilterComponent = __webpack_require__(7);

var _ListFilterComponent2 = _interopRequireDefault(_ListFilterComponent);

var _PreviewDialog = __webpack_require__(661);

var _PreviewDialog2 = _interopRequireDefault(_PreviewDialog);

var _vue = __webpack_require__(8);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      filters: {
        available: [],
        selected: {}
      },
      data: [],
      listLoading: false,
      service: _api.CustomForm,
      count: 0,
      page: 1,
      pageSize: 10,
      bus: new _vue2.default(),
      currentPreview: null,
      currentForm: null,
      exportLoading: false
    };
  },

  methods: {
    handlePageChange: function handlePageChange(val) {
      this.page = val;
      this.fetchData();
    },
    hasAnswers: function hasAnswers(form) {
      return form.formdata_set.length > 0;
    },
    setFilter: function setFilter(filter) {
      this.page = 1;
      var key = filter.query_param;
      var value = filter.value;
      this.$set(this.filters.selected, key, value);
      this.fetchData();
    },
    fetchData: function fetchData() {
      var _this = this;

      var params = (0, _extends3.default)({
        page: this.page
      }, this.filters.selected);
      this.listLoading = true;
      this.service.fetch({}, { params: params }).then(function (response) {
        _this.count = response.data.count;
        _this.pageSize = response.data.page_size;
        _this.data = response.data.results;
        _this.listLoading = false;
      });
    },
    handleDelete: function handleDelete(index, row) {
      var _this2 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.$confirm(_this2.$i18n.t('deleteConfirmation'), _this2.$i18n.t('delete'), {
                  type: 'warning'
                });

              case 2:

                _this2.listLoading = true;
                _context.next = 5;
                return _this2.service.delete(row.id);

              case 5:

                _this2.listLoading = false;
                _this2.$message({
                  message: 'Element został usunięty',
                  type: 'success'
                });

                _this2.fetchData();

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    handleClone: function handleClone(index, row) {
      var _this3 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.listLoading = true;
                _context2.next = 3;
                return _this3.service.clone(row.id);

              case 3:

                _this3.listLoading = false;
                _this3.$message({
                  message: 'Formularz został powielony',
                  type: 'success'
                });

                _this3.fetchData();

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    dialogCancelled: function dialogCancelled() {},
    dialogSubmitted: function dialogSubmitted() {},
    openDialog: function openDialog(data, form) {
      this.currentPreview = data;
      this.currentForm = form;
      this.bus.$emit('openPreviewDialog', data);
    },
    nextPreview: function nextPreview() {
      console.log();
      this.changePreview(1);
    },
    previousPreview: function previousPreview() {
      this.changePreview(-1);
    },
    slugify: function slugify(text) {
      return text.toString().toLowerCase().replace(/\s+/g, '-').replace(/[^\wąęśćżźńłó\-]+/g, '').replace(/\-\-+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
    },
    changePreview: function changePreview(diff) {
      if (this.currentPreview == null || this.currentForm == null) return;

      var currentIndex = this.currentForm.formdata_set.indexOf(this.currentPreview);

      if (currentIndex + diff < 0 || currentIndex + diff > this.currentForm.formdata_set.length - 1) {
        return;
      }

      var nextPreview = this.currentForm.formdata_set[currentIndex + diff];

      this.openDialog(nextPreview, this.currentForm);
    },
    exportFormDataDialog: function exportFormDataDialog(form) {
      var _this4 = this;

      if (form.formdata_set.length > 1000) {
        this.$prompt('Wprowadź adres e-mail, na który zostanie wysłany wyeksportowany formularz', 'E-mail', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
          inputErrorMessage: 'Niepoprawny adres e-mail'
        }).then(function (_ref) {
          var value = _ref.value;

          _this4.exportFormData(form, value);
        }).catch(function () {});
      } else {
        this.exportFormData(form);
      }
    },
    exportFormData: function exportFormData(form, email) {
      var _this5 = this;

      this.exportLoading = true;
      _api.CustomForm.exportFormData(form.id, email).then(function (response) {
        var isFile = response.data instanceof Blob;
        if (isFile) {
          var url = window.URL.createObjectURL(new Blob([response.data]));
          var link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', _this5.slugify(form.name_pl) + '.xlsx');
          document.body.appendChild(link);
          link.click();
        } else {
          _this5.$message({
            message: 'Plik zostanie wysłany na podany email',
            type: 'success'
          });
        }
      }).catch(function (err) {
        _this5.$message({
          message: 'Wystąpił bład podczas pobierania danych.',
          type: 'error'
        });
      }).finally(function () {
        _this5.exportLoading = false;
      });
    }
  },
  mounted: function mounted() {
    this.fetchData();
  },

  components: {
    ListFilterComponent: _ListFilterComponent2.default,
    PreviewDialog: _PreviewDialog2.default
  }
};

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _api = __webpack_require__(2);

exports.default = {
    data: function data() {
        return {
            errors: {},
            loading: false,
            dialogFormVisible: false,
            simpleFormData: {},
            formData: {
                sections: []
            }
        };
    },

    props: ["bus"],
    mounted: function mounted() {
        this.bus.$on('openPreviewDialog', this.openDialog);
    },

    methods: {
        openDialog: function openDialog(simpleFormData) {
            this.loading = true;
            this.simpleFormData = simpleFormData;
            this.formData = { sections: [] };
            this.fetchData();
            this.dialogFormVisible = true;
        },
        cancelForm: function cancelForm() {
            this.dialogFormVisible = false;
            this.$emit('cancel');
        },
        fetchData: function fetchData() {
            var _this = this;

            this.loading = true;
            _api.CustomForm.fetchFormData(this.simpleFormData.id).then(function (response) {
                _this.formData = response.data;
                _this.loading = false;
            });
        }
    }
};

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _FieldsInput = __webpack_require__(623);

var _FieldsInput2 = _interopRequireDefault(_FieldsInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['section', 'errors', 'fieldTypes'],
    components: {
        FieldsInput: _FieldsInput2.default
    }
};

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _SectionForm = __webpack_require__(662);

var _SectionForm2 = _interopRequireDefault(_SectionForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['sections', 'errors', 'fieldTypes'],
    methods: {
        addSection: function addSection() {
            if (this.sections === undefined) this.sections = [];
            this.sections.push({ fields: [] });
        }
    },
    components: {
        SectionForm: _SectionForm2.default
    }
};

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _api = __webpack_require__(2);

exports.default = {
    data: function data() {
        return {
            loading: false,
            redirectRoute: { name: 'Editions List' },
            form: {},
            errors: {},
            service: _api.Edition
        };
    },
    mounted: function mounted() {
        this.fetchData();
    },

    methods: {
        fetchData: function fetchData() {
            var _this = this;

            if (this.$route.params.id) {
                this.service.get(this.$route.params.id).then(function (response) {
                    _this.form = response.data;
                });
            }
        },
        onSubmit: function onSubmit() {
            this.loading = true;
            var id = this.$route.params.id;
            var service = id ? this.service.update(id, this.form) : this.service.save(this.form);
            service.then(this.successHandler).catch(this.errorHandler);
        }
    }
};

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _regenerator = __webpack_require__(5);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(4);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _api = __webpack_require__(2);

var _ListFilterComponent = __webpack_require__(7);

var _ListFilterComponent2 = _interopRequireDefault(_ListFilterComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			filters: {
				available: [],
				selected: {}
			},
			data: [],
			listLoading: false,
			service: _api.Edition
		};
	},

	methods: {
		setFilter: function setFilter(filter) {
			this.page = 1;
			var key = filter.query_param;
			var value = filter.value;
			this.$set(this.filters.selected, key, value);
			this.fetchData();
		},
		fetchData: function fetchData() {
			var _this = this;

			var params = (0, _extends3.default)({
				page: this.page
			}, this.filters.selected);
			this.listLoading = true;
			this.service.fetch({}, { params: params }).then(function (response) {
				_this.data = response.data;
				_this.listLoading = false;
			});
		},
		handleDelete: function handleDelete(index, row) {
			var _this2 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.next = 2;
								return _this2.$confirm(_this2.$i18n.t('deleteConfirmation'), _this2.$i18n.t('delete'), {
									type: 'warning'
								});

							case 2:

								_this2.listLoading = true;
								_context.next = 5;
								return _this2.service.delete(row.id);

							case 5:

								_this2.listLoading = false;
								_this2.$message({
									message: 'Element został usunięty',
									type: 'success'
								});

								_this2.fetchData();

							case 8:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this2);
			}))();
		}
	},
	mounted: function mounted() {
		this.fetchData();
	},

	components: {
		ListFilterComponent: _ListFilterComponent2.default
	}
};

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _PhotoCropper = __webpack_require__(69);

var _PhotoCropper2 = _interopRequireDefault(_PhotoCropper);

var _WidgetsInput = __webpack_require__(44);

var _WidgetsInput2 = _interopRequireDefault(_WidgetsInput);

var _EventOccurrences = __webpack_require__(667);

var _EventOccurrences2 = _interopRequireDefault(_EventOccurrences);

var _api = __webpack_require__(2);

var _EditionInput = __webpack_require__(18);

var _EditionInput2 = _interopRequireDefault(_EditionInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            loading: false,
            form: {
                occurrences: [],
                widgets: [],
                event_type: null
            },
            errors: {},
            availableEventTypes: [],
            availableTags: [],
            service: null,
            loadingPopups: false,
            popups: []
        };
    },
    mounted: function mounted() {
        this.fetchData();
    },

    computed: {
        eventType: function eventType() {
            return this.$route.meta.eventType;
        },

        croppers: {
            set: function set(updatedCroppers) {
                var _this = this;

                updatedCroppers.forEach(function (cropper) {
                    _this.$set(_this.form, cropper.photoFieldName, cropper.img);
                    _this.$set(_this.form, cropper.paramsFieldName, cropper.params);
                });
            },
            get: function get() {
                var _this2 = this;

                var croppers = [{
                    id: 'square',
                    aspect: 188 / 156,
                    photoFieldName: 'square_photo',
                    paramsFieldName: 'square_crop_params',
                    label: 'Kadr kwadratowy'
                }, {
                    id: 'horizontal',
                    aspect: 340 / 190,
                    photoFieldName: 'horizontal_photo',
                    paramsFieldName: 'horizontal_crop_params',
                    label: 'Kadr poziomy'
                }, {
                    id: 'vertical',
                    aspect: 140 / 291,
                    photoFieldName: 'vertical_photo',
                    paramsFieldName: 'vertical_crop_params',
                    label: 'Kadr pionowy'
                }];
                var mergeFieldNameWithValues = function mergeFieldNameWithValues(cropper) {
                    return (0, _extends3.default)({}, cropper, {
                        img: _this2.form[cropper.photoFieldName],
                        params: _this2.form[cropper.paramsFieldName]
                    });
                };
                return croppers.map(mergeFieldNameWithValues);
            }
        }
    },
    components: {
        PhotoCropper: _PhotoCropper2.default,
        EventOccurrences: _EventOccurrences2.default,
        WidgetsInput: _WidgetsInput2.default,
        EditionInput: _EditionInput2.default
    },
    beforeMount: function beforeMount() {
        this.service = this.eventDetails.service;
        this.redirectRoute = this.getRedirectRoute();
    },

    methods: {
        fetchData: function fetchData() {
            var _this3 = this;

            this.fetchPopups();
            this.$store.dispatch('fetchStages');
            this.$store.dispatch('fetchEditions');

            if (this.$route.params.id) {
                this.service.get(this.$route.params.id).then(function (response) {
                    _this3.form = response.data;
                    _this3.form.tags = _this3.form.tags.map(function (tag) {
                        return tag.name;
                    });
                });
            } else {
                this.form.event_type = this.eventType !== 'others' ? this.eventType : '';
            }

            this.service.tags().then(function (response) {
                var listToObj = function listToObj(item) {
                    return { name: item.name, id: item.id };
                };

                _this3.availableTags = response.data.map(listToObj);
            });

            if (this.eventType === 'others') {
                this.service.eventTypes().then(function (response) {
                    var listToObj = function listToObj(type) {
                        return { label: type, value: type };
                    };
                    _this3.availableEventTypes = response.data.map(listToObj);
                });
            }
        },
        getRedirectRoute: function getRedirectRoute() {
            var type = this.eventType;
            var routes = {
                'theater': 'Spectacles List',
                'music': 'Concerts List',
                'others': 'OtherEvents List',
                'cinema': 'Films List'
            };
            return { name: routes[type] };
        },
        fetchPopups: function fetchPopups() {
            var _this4 = this;

            _api.Popup.all().then(function (response) {
                _this4.popups = response.data;
            });
        },
        onSubmit: function onSubmit() {
            var _this5 = this;

            this.loading = true;
            var id = this.$route.params.id;
            var payload = (0, _extends3.default)({}, this.form);
            var prepareTags = function prepareTags(tag) {
                return typeof tag === 'string' ? { name: tag, event_type: _this5.eventType } : tag;
            };
            payload.tags = payload.tags.map(prepareTags);
            var service = id ? this.service.update(id, payload) : this.service.save(payload);
            service.then(this.successHandler).catch(this.errorHandler);
        }
    }
};

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ["occurrences", "errors"],
    computed: {
        eventType: function eventType() {
            return this.$route.meta.eventType;
        }
    },
    methods: {
        addOccurrence: function addOccurrence() {
            this.occurrences.push({});
        }
    }
};

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(5);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(4);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = __webpack_require__(32);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _ListFilterComponent = __webpack_require__(7);

var _ListFilterComponent2 = _interopRequireDefault(_ListFilterComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            filters: {
                available: [{
                    name: this.$i18n.t('status'),
                    query_param: 'hide',
                    options: [{
                        label: this.$i18n.t('all'),
                        value: '',
                        icon: 'el-icon-star-on',
                        defaultSelected: true
                    }, {
                        label: this.$i18n.t('published'),
                        value: 'false',
                        icon: 'el-icon-star-on'
                    }, {
                        label: this.$i18n.t('unpublished'),
                        value: 'true',
                        icon: 'el-icon-star-off'
                    }]
                }, {
                    name: this.$i18n.t('year'),
                    query_param: 'edition',
                    options: []
                }],
                selected: {}
            },
            data: [],
            count: 0,
            page: 1,
            pageSize: 100,
            listLoading: false,
            service: null
        };
    },

    methods: {
        handlePageChange: function handlePageChange(val) {
            this.page = val;
            this.fetchData();
        },
        addTagsFilter: function addTagsFilter() {
            var _this = this;

            this.service.tags().then(function (response) {
                var listToObj = function listToObj(item) {
                    return { label: item.name, value: item.name };
                };
                var options = [{ label: 'Wszystkie', value: '' }].concat((0, _toConsumableArray3.default)(response.data.map(listToObj)));
                _this.filters.available.push({
                    name: 'Tag',
                    query_param: 'tags__name',
                    options: options
                });
                _this.setFilter({ query_param: 'tag', value: '' });
            });
        },
        addEventTypeFilter: function addEventTypeFilter() {
            var _this2 = this;

            this.service.eventTypes().then(function (response) {
                var listToObj = function listToObj(type) {
                    return { label: type, value: type };
                };
                var options = [{ label: 'Wszystkie', value: '' }].concat((0, _toConsumableArray3.default)(response.data.map(listToObj)));
                _this2.filters.available.push({
                    name: 'Typ wydarzenia',
                    query_param: 'event_type',
                    options: options
                });
                _this2.setFilter({ query_param: 'event_type', value: '' });
            });
        },
        setFilter: function setFilter(filter) {
            this.page = 1;
            var key = filter.query_param;
            var value = filter.value;
            this.$set(this.filters.selected, key, value);
            this.fetchData();
        },
        fetchData: function fetchData() {
            var _this3 = this;

            var params = (0, _extends3.default)({
                page: this.page
            }, this.filters.selected);
            this.listLoading = true;
            this.service.fetch({}, { params: params }).then(function (response) {
                _this3.count = response.data.count;
                _this3.pageSize = response.data.page_size;
                _this3.data = response.data.results;
                _this3.listLoading = false;
            });
        },
        handleDelete: function handleDelete(index, row) {
            var _this4 = this;

            return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this4.$confirm(_this4.$i18n.t('deleteConfirmation'), _this4.$i18n.t('delete'), {
                                    type: 'warning'
                                });

                            case 2:

                                _this4.listLoading = true;
                                _context.next = 5;
                                return _this4.service.delete(row.id);

                            case 5:

                                _this4.listLoading = false;
                                _this4.$message({
                                    message: 'Element został usunięty',
                                    type: 'success'
                                });

                                _this4.fetchData();

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this4);
            }))();
        }
    },
    beforeMount: function beforeMount() {
        this.service = this.eventDetails.service;
        this.addTagsFilter();
        if (this.$route.meta.eventType === 'others') {
            this.addEventTypeFilter();
        }
    },
    mounted: function mounted() {
        this.fetchData();

        this.$store.dispatch('fetchEditions');
    },

    watch: {
        '$store.state.editions': function $storeStateEditions(value) {
            var options = value.map(function (edition) {
                return { label: edition.year, value: edition.id, defaultSelected: edition.current };
            });
            options = [{ label: 'Wszystkie', value: '' }].concat((0, _toConsumableArray3.default)(options));
            var defaultFilter = options.find(function (option) {
                return option.defaultSelected;
            });
            this.setFilter({
                query_param: 'edition',
                value: defaultFilter.value
            });
            this.$set(this.filters.available[1], 'options', options);
        }
    },
    components: {
        ListFilterComponent: _ListFilterComponent2.default
    }
};

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _api = __webpack_require__(2);

var _ListFilterComponent = __webpack_require__(7);

var _ListFilterComponent2 = _interopRequireDefault(_ListFilterComponent);

var _vuedraggable = __webpack_require__(241);

var _vuedraggable2 = _interopRequireDefault(_vuedraggable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            filters: {
                available: [{
                    name: this.$i18n.t('year'),
                    query_param: 'edition',
                    options: []
                }],
                selected: {}
            },
            data: [],
            newOrder: false,
            listLoading: false,
            service: null
        };
    },

    methods: {
        getService: function getService() {
            var type = this.$route.meta.eventType;
            var services = {
                'theater': _api.Spectacle,
                'music': _api.Concert,
                'others': _api.OtherEvent,
                'cinema': _api.Film
            };
            return services[type];
        },
        submitOrder: function submitOrder() {
            var _this = this;

            var order = this.data.map(function (item) {
                return item.id;
            });
            var payload = {
                'edition': this.filters.selected.edition,
                'order[]': order
            };
            this.service.changeOrder(payload).then(function (response) {
                _this.newOrder = false;
                _this.$message({
                    message: 'Kolejność została zapisana',
                    type: 'success'
                });
                _this.fetchData();
            });
        },
        setFilter: function setFilter(filter) {
            var key = filter.query_param;
            var value = filter.value;
            this.$set(this.filters.selected, key, value);
            this.fetchData();
        },
        orderChanged: function orderChanged() {
            this.newOrder = true;
            this.drag = false;
        },
        updateEditions: function updateEditions() {
            var value = this.$store.state.editions;
            var options = value.map(function (edition) {
                return { label: edition.year, value: edition.id, defaultSelected: edition.current };
            });
            var defaultFilter = options.find(function (option) {
                return option.defaultSelected;
            });
            this.setFilter({
                query_param: 'edition',
                value: defaultFilter.value
            });
            this.$set(this.filters.available[0], 'options', options);
        },
        fetchData: function fetchData() {
            var _this2 = this;

            var params = (0, _extends3.default)({
                page: this.page
            }, this.filters.selected);
            this.listLoading = true;
            this.service.getOrder({ params: params }).then(function (response) {
                _this2.data = response.data;
                _this2.listLoading = false;
            });
        },
        sortAlphabetically: function sortAlphabetically() {
            var sortFn = function sortFn(a, b) {
                if (a.name_pl === a.name_en) {
                    return 0;
                }

                return a.name_pl > b.name_pl ? 1 : -1;
            };
            this.data.sort(sortFn);
            this.newOrder = true;
        }
    },
    beforeMount: function beforeMount() {
        this.service = this.getService();
    },
    mounted: function mounted() {
        var _this3 = this;

        this.$store.dispatch('fetchEditions').then(function (response) {
            _this3.updateEditions();
        });
    },

    components: {
        ListFilterComponent: _ListFilterComponent2.default,
        draggable: _vuedraggable2.default
    }
};

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = __webpack_require__(32);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _regenerator = __webpack_require__(5);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(4);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _api = __webpack_require__(2);

var _ListFilterComponent = __webpack_require__(7);

var _ListFilterComponent2 = _interopRequireDefault(_ListFilterComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            filters: {
                available: [{
                    name: 'Edycja',
                    query_param: 'edition',
                    options: []
                }],
                selected: {}
            },
            data: [],
            listLoading: false,
            service: _api.Folder,
            pageSize: 10,
            count: 0,
            page: 1,
            duringEditing: {}
        };
    },

    methods: {
        photoDuringEdition: function photoDuringEdition(photo) {
            return this.duringEditing[photo.id] !== undefined;
        },
        handlePageChange: function handlePageChange(val) {
            this.page = val;
            this.fetchData();
        },
        setFilter: function setFilter(filter) {
            this.page = 1;
            var key = filter.query_param;
            var value = filter.value;
            this.$set(this.filters.selected, key, value);
            this.fetchData();
        },
        getEditionLabel: function getEditionLabel(id) {
            var compareId = function compareId(edition) {
                return edition.id === id;
            };
            var edition = this.$store.state.editions.find(compareId);
            return edition && edition.year;
        },
        fetchData: function fetchData() {
            var _this = this;

            var params = (0, _extends3.default)({
                page: this.page
            }, this.filters.selected);
            this.listLoading = true;
            this.service.fetch({}, { params: params }).then(function (response) {
                _this.count = response.data.count;
                _this.pageSize = response.data.page_size;
                _this.data = response.data.results;
                _this.listLoading = false;
            });
        },
        handleDelete: function handleDelete(index, row) {
            var _this2 = this;

            return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this2.$confirm(_this2.$i18n.t('deleteConfirmation'), _this2.$i18n.t('delete'), {
                                    type: 'warning'
                                });

                            case 2:

                                _this2.listLoading = true;
                                _context.next = 5;
                                return _this2.service.delete(row.id);

                            case 5:

                                _this2.listLoading = false;
                                _this2.$message({
                                    message: 'Element został usunięty',
                                    type: 'success'
                                });

                                _this2.fetchData();

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        }
    },
    mounted: function mounted() {
        this.fetchData();
        this.$store.dispatch('fetchEditions');
    },

    components: {
        ListFilterComponent: _ListFilterComponent2.default
    },
    watch: {
        '$store.state.editions': function $storeStateEditions(value) {
            var options = value.map(function (edition) {
                return { label: edition.year, value: edition.id, defaultSelected: edition.current };
            });
            options = [{ label: 'Wszystkie', value: '' }].concat((0, _toConsumableArray3.default)(options));
            var defaultFilter = options.find(function (option) {
                return option.defaultSelected;
            });
            this.$set(this.filters.available[0], 'options', options);
        }
    }
};

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _api = __webpack_require__(2);

var _GalleryImages = __webpack_require__(672);

var _GalleryImages2 = _interopRequireDefault(_GalleryImages);

var _EditionInput = __webpack_require__(18);

var _EditionInput2 = _interopRequireDefault(_EditionInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            loading: false,
            redirectRoute: { name: 'Galleries List' },
            form: {
                images: []
            },
            errors: {},
            service: _api.Folder
        };
    },
    mounted: function mounted() {
        this.fetchData();
    },

    methods: {
        fetchData: function fetchData() {
            var _this = this;

            if (this.$route.params.id) {
                this.service.get(this.$route.params.id).then(function (response) {
                    _this.form = response.data;
                });
            }
        },
        onSubmit: function onSubmit() {
            this.loading = true;
            var id = this.$route.params.id;
            var service = id ? this.service.update(id, this.form) : this.service.save(this.form);
            service.then(this.successHandler).catch(this.errorHandler);
        }
    },
    components: {
        GalleryImages: _GalleryImages2.default,
        EditionInput: _EditionInput2.default
    }
};

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _api = __webpack_require__(2);

exports.default = {
    props: ['images'],
    data: function data() {
        return {
            filters: {
                available: [],
                selected: {}
            },
            data: [],
            service: _api.Image,
            duringEditing: {}
        };
    },

    methods: {
        imageDuringEdition: function imageDuringEdition(image) {
            return this.duringEditing[image.id] !== undefined;
        },
        editImage: function editImage(image) {
            this.$set(this.duringEditing, image.id, image);
        },
        submitEditedImage: function submitEditedImage(image) {
            var _this = this;

            _api.Image.update(image.id, this.duringEditing[image.id]).then(function (response) {
                _this.$message({
                    message: 'Element został zaaktualizowany',
                    type: 'success'
                });
                _this.duringEditing[image.id] = undefined;
            });
        },
        handleDelete: function handleDelete(index, row) {
            console.log('usun zdjecie');
        },
        uploadImage: function uploadImage(event) {
            this.sendFile(event.file);
        },
        sendFile: function sendFile(file) {
            var _this2 = this;

            var data = new FormData();
            data.append("raw_image", file, file.name);
            return _api.Image.save(data).then(function (response) {
                _this2.uploadSuccess(response);
            }).catch(function (error) {
                _this2.uploadError(error);
            });
        },
        uploadSuccess: function uploadSuccess(response) {
            this.images.unshift(response.data);
        },
        uploadError: function uploadError(error) {
            console.error(error, 'error while file uploading');
            this.$message({
                message: "Wystąpił problem podczas wysyłania pliku.",
                type: 'error'
            });
        }
    }
};

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(5);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(4);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _api = __webpack_require__(2);

var _ListFilterComponent = __webpack_require__(7);

var _ListFilterComponent2 = _interopRequireDefault(_ListFilterComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            filters: {
                available: [],
                selected: {}
            },
            data: [],
            listLoading: false,
            service: _api.Image,
            pageSize: 10,
            count: 0,
            page: 1,
            duringEditing: {}
        };
    },

    methods: {
        photoDuringEdition: function photoDuringEdition(photo) {
            return this.duringEditing[photo.id] !== undefined;
        },
        handlePageChange: function handlePageChange(val) {
            this.page = val;
            this.fetchData();
        },
        setFilter: function setFilter() {
            this.page = 1;
            this.fetchData();
        },
        editPhoto: function editPhoto(photo) {
            this.$set(this.duringEditing, photo.id, photo);
        },
        submitEditedPhoto: function submitEditedPhoto(photo) {
            var _this = this;

            _api.Image.update(photo.id, this.duringEditing[photo.id]).then(function (response) {
                _this.$message({
                    message: 'Element został zaaktualizowany',
                    type: 'success'
                });
                _this.duringEditing[photo.id] = undefined;
                _this.fetchData(true);
            });
        },
        fetchData: function fetchData(soft) {
            var _this2 = this;

            var params = (0, _extends3.default)({
                page: this.page
            }, this.filters.selected);
            if (soft === undefined) {
                this.listLoading = true;
            }
            this.service.fetch({}, { params: params }).then(function (response) {
                _this2.count = response.data.count;
                _this2.pageSize = response.data.page_size;
                _this2.data = response.data.results;
                _this2.listLoading = false;
            });
        },
        handleDelete: function handleDelete(index, row) {
            var _this3 = this;

            return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this3.$confirm(_this3.$i18n.t('deleteConfirmation'), _this3.$i18n.t('delete'), {
                                    type: 'warning'
                                });

                            case 2:

                                _this3.listLoading = true;
                                _context.next = 5;
                                return _this3.service.delete(row.id);

                            case 5:

                                _this3.listLoading = false;
                                _this3.$message({
                                    message: 'Element został usunięty',
                                    type: 'success'
                                });

                                _this3.fetchData();

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this3);
            }))();
        }
    },
    mounted: function mounted() {
        this.fetchData();
    },

    components: {
        ListFilterComponent: _ListFilterComponent2.default
    }
};

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _HeaderComponent = __webpack_require__(620);

var _HeaderComponent2 = _interopRequireDefault(_HeaderComponent);

var _SidebarComponent = __webpack_require__(621);

var _SidebarComponent2 = _interopRequireDefault(_SidebarComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            showBreadcrumbs: false
        };
    },
    created: function created() {
        this.$store.dispatch('fetchStages');
        this.$store.dispatch('fetchEditions');
    },

    methods: {},
    components: {
        HeaderComponent: _HeaderComponent2.default,
        SidebarComponent: _SidebarComponent2.default
    }
};

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _api = __webpack_require__(2);

var _PhotosPreview = __webpack_require__(677);

var _PhotosPreview2 = _interopRequireDefault(_PhotosPreview);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            loading: false,
            redirectRoute: { name: 'Folders List' },
            form: {
                photos: [],
                tags: []
            },
            errors: {},
            service: _api.InstagramFolder
        };
    },
    mounted: function mounted() {
        this.fetchData();
    },

    components: {
        PhotosPreview: _PhotosPreview2.default
    },
    methods: {
        fetchData: function fetchData() {
            var _this = this;

            if (this.$route.params.id) {
                this.service.get(this.$route.params.id).then(function (response) {
                    _this.form = response.data;
                });
            }
        },
        onSubmit: function onSubmit() {
            this.loading = true;
            var id = this.$route.params.id;
            var service = id ? this.service.update(id, this.form) : this.service.save(this.form);
            service.then(this.successHandler).catch(this.errorHandler);
        }
    }
};

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(5);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(4);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _api = __webpack_require__(2);

var _ListFilterComponent = __webpack_require__(7);

var _ListFilterComponent2 = _interopRequireDefault(_ListFilterComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            filters: {
                available: [],
                selected: {}
            },
            data: [],
            listLoading: false,
            service: _api.InstagramFolder,
            count: 0,
            page: 1,
            pageSize: 10
        };
    },

    methods: {
        handlePageChange: function handlePageChange(val) {
            this.page = val;
            this.fetchData();
        },
        setFilter: function setFilter(filter) {
            this.page = 1;
            var key = filter.query_param;
            var value = filter.value;
            this.$set(this.filters.selected, key, value);
            this.fetchData();
        },
        fetchData: function fetchData() {
            var _this = this;

            var params = (0, _extends3.default)({
                page: this.page
            }, this.filters.selected);
            this.listLoading = true;
            this.service.fetch({}, { params: params }).then(function (response) {
                _this.count = response.data.count;
                _this.pageSize = response.data.page_size;
                _this.data = response.data.results;
                _this.listLoading = false;
            });
        },
        handleDelete: function handleDelete(index, row) {
            var _this2 = this;

            return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this2.$confirm(_this2.$i18n.t('deleteConfirmation'), _this2.$i18n.t('delete'), {
                                    type: 'warning'
                                });

                            case 2:

                                _this2.listLoading = true;
                                _context.next = 5;
                                return _this2.service.delete(row.id);

                            case 5:

                                _this2.listLoading = false;
                                _this2.$message({
                                    message: 'Element został usunięty',
                                    type: 'success'
                                });

                                _this2.fetchData();

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        }
    },
    mounted: function mounted() {
        this.fetchData();
    },

    components: {
        ListFilterComponent: _ListFilterComponent2.default
    }
};

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _api = __webpack_require__(2);

exports.default = {
    props: ["form"],
    data: function data() {
        return {
            previewIsUpdating: false,
            showUnaccepted: false,
            showAccepted: false,
            instagramPhotos: []
        };
    },

    computed: {
        photosDict: function photosDict() {
            var photosDict = {};
            if (!this.form.photos) {
                return photosDict;
            }
            this.form.photos.forEach(function (photo) {
                photosDict[photo.instagram_id] = photo;
            });
            return photosDict;
        }
    },
    methods: {
        synchronizePhotos: function synchronizePhotos() {
            var _this = this;

            var photoInInstaResponse = function photoInInstaResponse(photo) {
                return _this.instagramPhotos.find(function (insta) {
                    return insta.id === photo.instagram_id;
                });
            };
            this.form.photos = this.form.photos.filter(photoInInstaResponse);
        },
        updatePreview: function updatePreview() {
            var _this2 = this;

            if (this.previewIsUpdating) return;
            this.previewIsUpdating = true;
            _api.InstagramFolder.remote({ params: { tags: this.form.tags } }).then(function (response) {
                _this2.previewIsUpdating = false;
                _this2.instagramPhotos = response.data;
                _this2.synchronizePhotos();
            }, function (error) {
                _this2.previewIsUpdating = false;
                console.error(error);
            });
        },
        tileVisible: function tileVisible(photo) {
            var confirmationObject = this.photosDict[photo.id];
            if (confirmationObject === undefined) {
                return true;
            }
            if (this.showAccepted && confirmationObject.accepted) {
                return true;
            }
            if (this.showUnaccepted && !confirmationObject.accepted) {
                return true;
            }
            return false;
        },
        changePhotoStatus: function changePhotoStatus(photo, accepted) {
            if (this.photosDict[photo.id] !== undefined) {
                this.photosDict[photo.id].accepted = accepted;
            } else {
                this.form.photos.push({
                    instagram_id: photo.id,
                    accepted: accepted,
                    link: photo.link,
                    thumbnail_image: photo.thumbnail_src,
                    standard_resolution_image: photo.thumbnail_src
                });
            }
        }
    },
    watch: {
        'form.tags': function formTags(value) {
            this.updatePreview();
        }
    }
};

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(5);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(4);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            loading: false,
            form: {},
            rules: {
                username: [{ required: true, message: 'To pole jest wymagane', trigger: 'blur' }],
                password: [{ required: true, message: 'To pole jest wymagane', trigger: 'blur' }]
            },
            checked: true
        };
    },

    methods: {
        submitLoginForm: function submitLoginForm() {
            var _this = this;

            return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                var payload, loginResponse;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.loading = true;
                                payload = { username: _this.form.username, password: _this.form.password };
                                loginResponse = _this.$store.dispatch('auth/login', payload).catch(function (error) {
                                    var message = 'Wystąpił błąd podczas logowania.';

                                    if (error.response.data.non_field_errors) {
                                        message = message + ' ' + error.response.data.non_field_errors;
                                    }

                                    _this.$message({
                                        message: message,
                                        type: 'error'
                                    });
                                });

                                _this.loading = false;
                                _this.redirectOnSuccess();

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        redirectOnSuccess: function redirectOnSuccess() {
            if (this.$route.query.next !== undefined) {
                this.$router.push(this.$route.query.next);
            } else {
                this.$router.push('/');
            }
        },
        onSubmit: function onSubmit(e) {
            this.submitLoginForm();
        }
    }
};

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _api = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      loungerTypes: [{
        "label": "Cabana (max 4 os.)",
        "value": "cabana"

      }, {
        "label": "Opener Fan Cabana (max 4 os.)",
        "value": "opener fan cabana"

      }, {
        "label": "Sunbed (minimum 2 w zestawie)",
        "value": "sunbed"

      }, {
        "label": "Opener Fan Sunbed (minimum 2 w zestawie)",
        "value": "opener fan sunbed"

      }],
      loading: false,
      form: {},
      errors: {},
      service: _api.Lounger
    };
  },
  mounted: function mounted() {
    this.fetchData();
  },

  methods: {
    fetchData: function fetchData() {
      var _this = this;

      if (this.$route.params.id) {
        this.service.get({ id: this.$route.params.id }).then(function (response) {
          _this.form = response.data;
          _this.form.price /= 100;
        });
      }
    },
    onSubmit: function onSubmit() {
      this.loading = true;
      var id = this.$route.params.id;
      var payload = (0, _extends3.default)({}, this.form);
      payload.price *= 100;
      var service = id ? this.service.update({ id: id }, payload) : this.service.save(payload);
      service.then(this.successHandler).catch(this.errorHandler);
    }
  }
};

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _regenerator = __webpack_require__(5);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(4);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _api = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			data: [],
			listLoading: false,
			service: _api.Lounger
		};
	},

	methods: {
		fetchData: function fetchData() {
			var _this = this;

			this.listLoading = true;
			this.service.fetch().then(function (response) {
				_this.data = response.data;
				_this.listLoading = false;
			});
		},
		handleDelete: function handleDelete(index, row) {
			var _this2 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.next = 2;
								return _this2.$confirm(_this2.$i18n.t('deleteConfirmation'), _this2.$i18n.t('delete'), {
									type: 'warning'
								});

							case 2:

								_this2.listLoading = true;
								_context.next = 5;
								return _this2.service.delete(row.id);

							case 5:

								_this2.listLoading = false;
								_this2.$message({
									message: 'Element został usunięty',
									type: 'success'
								});

								_this2.fetchData();

							case 8:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this2);
			}))();
		}
	},
	mounted: function mounted() {
		this.fetchData();
	}
};

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _regenerator = __webpack_require__(5);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(4);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _api = __webpack_require__(2);

var _axios = __webpack_require__(30);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			data: [],
			filters: {
				available: [],
				selected: {}
			},
			listLoading: false,
			service: _api.LoungerReservation
		};
	},

	methods: {
		fetchData: function fetchData() {
			var _this = this;

			this.listLoading = true;
			var params = (0, _extends3.default)({}, this.filters.selected);
			this.service.fetch({}, { params: params }).then(function (response) {
				_this.data = response.data;
				_this.listLoading = false;
			});
		},
		handleDelete: function handleDelete(index, row) {
			var _this2 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.next = 2;
								return _this2.$confirm(_this2.$i18n.t('deleteConfirmation'), _this2.$i18n.t('delete'), {
									type: 'warning'
								});

							case 2:

								_this2.listLoading = true;
								_context.next = 5;
								return _this2.service.delete(row.id);

							case 5:

								_this2.listLoading = false;
								_this2.$message({
									message: 'Element został usunięty',
									type: 'success'
								});

								_this2.fetchData();

							case 8:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this2);
			}))();
		},
		mark_as_paid: function mark_as_paid(id) {
			var _this3 = this;

			this.service.mark_as_paid(id).then(function (response) {
				_this3.fetchData();
			});
		},
		downloadCSV: function downloadCSV() {
			var url = this.service.exportUrl();
			(0, _axios2.default)({
				url: url,
				method: 'GET',
				responseType: 'blob' }).then(function (response) {
				var url = window.URL.createObjectURL(new Blob([response.data]));
				var link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', 'rezerwacje_le\u017Cak\xF3w.csv');
				document.body.appendChild(link);
				link.click();
			});
		}
	},
	mounted: function mounted() {
		this.fetchData();
	}
};

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _MenuItem = __webpack_require__(684);

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _api = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            loading: false,
            redirectRoute: { name: 'Menus List' },
            form: {},
            errors: {},
            service: _api.Menu
        };
    },
    mounted: function mounted() {
        this.fetchData();
    },

    components: {
        MenuItem: _MenuItem2.default
    },
    methods: {
        fetchData: function fetchData() {
            var _this = this;

            if (this.$route.params.id) {
                this.service.get(this.$route.params.id).then(function (response) {
                    _this.form = response.data;
                });
            }
        },
        onSubmit: function onSubmit() {
            this.loading = true;
            var id = this.$route.params.id;
            var service = id ? this.service.update(id, this.form) : this.service.save(this.form);
            service.then(this.successHandler).catch(this.errorHandler);
        },
        addMenuItem: function addMenuItem() {
            var blankObject = {
                link: {}
            };
            if (!Array.isArray(this.form.items)) {
                this.form['items'] = [blankObject];
            } else {
                this.form.items.push(blankObject);
            }
        }
    }
};

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _SubmenuItem = __webpack_require__(686);

var _SubmenuItem2 = _interopRequireDefault(_SubmenuItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ["item", "errors", "allow_submenu"],
    components: {
        SubmenuItem: _SubmenuItem2.default
    },
    methods: {
        changeMenuItemType: function changeMenuItemType(item) {
            if (item.link) {
                item.link = null;
                item.submenu = [{}];
            } else {
                item.submenu = null;
                item.link = {};
            }
            this.$forceUpdate();
        },
        addSubmenuItem: function addSubmenuItem() {
            var randomHash = Math.floor(Math.random() * (99999 - 10000 + 1)) + 10000;
            var blankObject = {
                randomHash: randomHash,
                link: {}
            };
            if (!Array.isArray(this.item.submenu)) {
                this.item.submenu = [blankObject];
            } else {
                this.item.submenu.push(blankObject);
            }
            this.$forceUpdate();
        }
    }
};

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _regenerator = __webpack_require__(5);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(4);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _api = __webpack_require__(2);

var _ListFilterComponent = __webpack_require__(7);

var _ListFilterComponent2 = _interopRequireDefault(_ListFilterComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			filters: {
				available: [],
				selected: {}
			},
			data: [],
			listLoading: false,
			service: _api.Menu
		};
	},

	methods: {
		handlePageChange: function handlePageChange(val) {
			this.page = val;
			this.fetchData();
		},
		setFilter: function setFilter(filter) {
			this.page = 1;
			var key = filter.query_param;
			var value = filter.value;
			this.$set(this.filters.selected, key, value);
			this.fetchData();
		},
		fetchData: function fetchData() {
			var _this = this;

			var params = (0, _extends3.default)({
				page: this.page
			}, this.filters.selected);
			this.listLoading = true;
			this.service.fetch({}, { params: params }).then(function (response) {
				_this.data = response.data;
				_this.listLoading = false;
			});
		},
		handleDelete: function handleDelete(index, row) {
			var _this2 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.next = 2;
								return _this2.$confirm(_this2.$i18n.t('deleteConfirmation'), _this2.$i18n.t('delete'), {
									type: 'warning'
								});

							case 2:

								_this2.listLoading = true;
								_context.next = 5;
								return _this2.service.delete(row.id);

							case 5:

								_this2.listLoading = false;
								_this2.$message({
									message: 'Element został usunięty',
									type: 'success'
								});

								_this2.fetchData();

							case 8:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this2);
			}))();
		}
	},
	mounted: function mounted() {
		this.fetchData();
	},

	components: {
		ListFilterComponent: _ListFilterComponent2.default
	}
};

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ["item", "errors", "itemKey"]
};

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _WidgetsInput = __webpack_require__(44);

var _WidgetsInput2 = _interopRequireDefault(_WidgetsInput);

var _PhotoCropper = __webpack_require__(69);

var _PhotoCropper2 = _interopRequireDefault(_PhotoCropper);

var _api = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            loading: false,
            form: {
                widgets: []
            },
            errors: {},
            loadingPopups: false,
            popups: [],
            service: _api.News,
            tags: [],
            redirectRoute: { name: 'News List' }
        };
    },
    mounted: function mounted() {
        this.fetchData();
    },

    computed: {
        croppers: {
            set: function set(updatedCroppers) {
                var _this = this;

                updatedCroppers.forEach(function (cropper) {
                    _this.$set(_this.form, cropper.photoFieldName, cropper.img);
                    _this.$set(_this.form, cropper.paramsFieldName, cropper.params);
                });
            },
            get: function get() {
                var _this2 = this;

                var croppers = [{
                    id: 'square',
                    aspect: 1,
                    photoFieldName: 'square_photo',
                    paramsFieldName: 'square_crop_params',
                    label: 'Kadr kwadratowy'
                }, {
                    id: 'horizontal',
                    aspect: 2,
                    photoFieldName: 'horizontal_photo',
                    paramsFieldName: 'horizontal_crop_params',
                    label: 'Kadr poziomy'
                }, {
                    id: 'vertical',
                    aspect: 260 / 378,
                    photoFieldName: 'vertical_photo',
                    paramsFieldName: 'vertical_crop_params',
                    label: 'Kadr pionowy'
                }];
                var mergeFieldNameWithValues = function mergeFieldNameWithValues(cropper) {
                    return (0, _extends3.default)({}, cropper, {
                        img: _this2.form[cropper.photoFieldName],
                        params: _this2.form[cropper.paramsFieldName]
                    });
                };
                return croppers.map(mergeFieldNameWithValues);
            }
        }
    },
    components: {
        WidgetsInput: _WidgetsInput2.default,
        PhotoCropper: _PhotoCropper2.default
    },
    methods: {
        fetchData: function fetchData() {
            var _this3 = this;

            if (this.$route.params.id) {
                this.service.get({ id: this.$route.params.id }).then(function (response) {
                    _this3.form = response.data;
                    _this3.form.tags = _this3.form.tags.map(function (tag) {
                        return tag.name;
                    });
                });
            }
            this.fetchPopups();
            this.fetchTags();
        },
        fetchTags: function fetchTags() {
            var _this4 = this;

            this.service.tags().then(function (response) {
                var listToObj = function listToObj(item) {
                    return { name: item.name, id: item.id };
                };

                _this4.tags = response.data.map(listToObj);
            });
        },
        fetchPopups: function fetchPopups() {
            var _this5 = this;

            _api.Popup.all().then(function (response) {
                _this5.popups = response.data;
            });
        },
        onSubmit: function onSubmit() {
            this.loading = true;
            var id = this.$route.params.id;
            var payload = (0, _extends3.default)({}, this.form);
            var prepareTags = function prepareTags(tag) {
                return typeof tag === 'string' ? { name: tag } : tag;
            };
            payload.tags = payload.tags.map(prepareTags);
            var service = id ? this.service.update({ id: id }, payload) : this.service.save(payload);
            service.then(this.successHandler).catch(this.errorHandler);
        }
    }
};

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(5);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(4);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _ListFilterComponent = __webpack_require__(7);

var _ListFilterComponent2 = _interopRequireDefault(_ListFilterComponent);

var _api = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            filters: {
                available: [],
                selected: {}
            },
            data: [],
            count: 0,
            page: 1,
            pageSize: 100,
            listLoading: false,
            service: _api.News
        };
    },

    methods: {
        handleNewsChange: function handleNewsChange(val) {
            this.page = val;
            this.fetchData();
        },
        setFilter: function setFilter(filter) {
            this.page = 1;
            var key = filter.query_param;
            var value = filter.value;
            this.$set(this.filters.selected, key, value);
            this.fetchData();
        },
        fetchData: function fetchData() {
            var _this = this;

            var params = (0, _extends3.default)({
                page: this.page
            }, this.filters.selected);
            this.listLoading = true;
            this.service.fetch({}, { params: params }).then(function (response) {
                _this.count = response.data.count;
                _this.pageSize = response.data.page_size;
                _this.data = response.data.results;
                _this.listLoading = false;
            });
        },
        handleDelete: function handleDelete(index, row) {
            var _this2 = this;

            return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this2.$confirm(_this2.$i18n.t('deleteConfirmation'), _this2.$i18n.t('delete'), {
                                    type: 'warning'
                                });

                            case 2:

                                _this2.listLoading = true;
                                _context.prev = 3;
                                _context.next = 6;
                                return _this2.service.delete({ id: row.id });

                            case 6:
                                _this2.$message({
                                    message: 'Element został usunięty',
                                    type: 'success'
                                });
                                _context.next = 12;
                                break;

                            case 9:
                                _context.prev = 9;
                                _context.t0 = _context['catch'](3);

                                _this2.$message({
                                    message: 'Wystąpił bład podczas usuwania elementu.',
                                    type: 'error'
                                });

                            case 12:

                                _this2.listLoading = false;
                                _this2.fetchData();

                            case 14:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2, [[3, 9]]);
            }))();
        }
    },
    mounted: function mounted() {
        this.fetchData();
    },

    components: {
        ListFilterComponent: _ListFilterComponent2.default
    }
};

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _WidgetsInput = __webpack_require__(44);

var _WidgetsInput2 = _interopRequireDefault(_WidgetsInput);

var _api = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            loading: false,
            form: {
                widgets: []
            },
            errors: {},
            loadingPopups: false,
            popups: [],
            service: _api.Page,
            redirectRoute: { name: 'Pages List' }
        };
    },
    mounted: function mounted() {
        this.fetchData();
    },

    components: {
        WidgetsInput: _WidgetsInput2.default
    },
    methods: {
        fetchData: function fetchData() {
            var _this = this;

            if (this.$route.params.slug) {
                this.service.get({ slug: this.$route.params.slug }).then(function (response) {
                    _this.form = response.data;
                });
            }
            this.fetchPopups();
        },
        fetchPopups: function fetchPopups() {
            var _this2 = this;

            _api.Popup.all().then(function (response) {
                _this2.popups = response.data;
            });
        },
        onSubmit: function onSubmit() {
            this.loading = true;
            var slug = this.$route.params.slug;
            var payload = (0, _extends3.default)({}, this.form);
            var service = slug ? this.service.update({ slug: slug }, payload) : this.service.save(payload);
            service.then(this.successHandler).catch(this.errorHandler);
        }
    }
};

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(31);

var _keys2 = _interopRequireDefault(_keys);

var _regenerator = __webpack_require__(5);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(4);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _ListFilterComponent = __webpack_require__(7);

var _ListFilterComponent2 = _interopRequireDefault(_ListFilterComponent);

var _api = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            filters: {
                available: [],
                selected: {}
            },
            data: [],
            count: 0,
            page: 1,
            pageSize: 100,
            listLoading: false,
            service: _api.Page
        };
    },

    methods: {
        handlePageChange: function handlePageChange(val) {
            this.page = val;
            this.fetchData();
        },
        setFilter: function setFilter(filter) {
            this.page = 1;
            var key = filter.query_param;
            var value = filter.value;
            this.$set(this.filters.selected, key, value);
            this.fetchData();
        },
        fetchData: function fetchData() {
            var _this = this;

            var params = (0, _extends3.default)({
                page: this.page
            }, this.filters.selected);
            this.listLoading = true;
            this.service.fetch({}, { params: params }).then(function (response) {
                _this.count = response.data.count;
                _this.pageSize = response.data.page_size;
                _this.data = response.data.results;
                _this.listLoading = false;
            });
        },
        handleDelete: function handleDelete(index, row) {
            var _this2 = this;

            return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this2.$confirm(_this2.$i18n.t('deleteConfirmation'), _this2.$i18n.t('delete'), {
                                    type: 'warning'
                                });

                            case 2:

                                _this2.listLoading = true;
                                _context.prev = 3;
                                _context.next = 6;
                                return _this2.service.delete({ slug: row.slug });

                            case 6:
                                _this2.$message({
                                    message: 'Element został usunięty',
                                    type: 'success'
                                });
                                _context.next = 12;
                                break;

                            case 9:
                                _context.prev = 9;
                                _context.t0 = _context['catch'](3);

                                _this2.$message({
                                    message: 'Wystąpił bład podczas usuwania elementu.',
                                    type: 'error'
                                });

                            case 12:

                                _this2.listLoading = false;
                                _this2.fetchData();

                            case 14:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2, [[3, 9]]);
            }))();
        },
        editSlug: function editSlug(page, lang) {
            var _this3 = this;

            var slugField = lang === 'en' ? 'slug_en' : 'slug';
            var slug = page[slugField];

            this.$prompt('Edycja sluga', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Anuluj',
                inputValue: slug,
                beforeClose: function beforeClose(action, instance, done) {
                    if (action === 'confirm') {
                        _this3.processConfirmedSlugDialog(instance, done, page, slugField);
                    } else {
                        done();
                    }
                }
            }).then(function (value) {
                _this3.$message({
                    type: 'success',
                    message: 'Zmieniono slug'
                });
                _this3.fetchData();
            }).catch(function () {});
        },
        processConfirmedSlugDialog: function processConfirmedSlugDialog(instance, done, page, slugField) {
            var _this4 = this;

            instance.confirmButtonLoading = true;
            this.updateSlug(page, slugField, instance.inputValue).then(function (response) {
                done();
            }).catch(function (error) {
                console.error(error);
                var errors = error.response.data;
                var flattenedErrors = (0, _keys2.default)(errors).map(function (key) {
                    return errors[key];
                }).join(', ');
                _this4.$message({
                    type: 'error',
                    message: flattenedErrors
                });
            });
            setTimeout(function () {
                instance.confirmButtonLoading = false;
            }, 300);
        },
        updateSlug: function updateSlug(page, slugField, newSlug) {
            var payload = {};
            payload[slugField] = newSlug;
            return _api.Page.slug(page.id, payload);
        }
    },
    mounted: function mounted() {
        this.fetchData();
    },

    components: {
        ListFilterComponent: _ListFilterComponent2.default
    }
};

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _api = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            loading: false,
            redirectRoute: { name: 'Popups List' },
            form: {
                slides: []
            },
            errors: {},
            service: _api.Popup
        };
    },
    mounted: function mounted() {
        this.fetchData();
    },

    methods: {
        fetchData: function fetchData() {
            var _this = this;

            if (this.$route.params.id) {
                this.service.get(this.$route.params.id).then(function (response) {
                    _this.form = response.data;
                });
            }
        },
        toggleLink: function toggleLink(slide) {
            slide.button_link = slide.button_link == null ? {} : null;
        },
        onSubmit: function onSubmit() {
            this.loading = true;
            var payload = (0, _extends3.default)({}, this.form);

            var fields_to_delete = ['title_pl', 'subtitle_pl', 'title_en', 'subtitle_en', 'hide_button', 'button_title_pl', 'button_title_en', 'button_link'];

            payload.slides.forEach(function (slide) {
                if (slide.media_on_whole_slide) {
                    fields_to_delete.forEach(function (field) {
                        delete slide[field];
                    });
                }
            });

            var id = this.$route.params.id;
            var service = id ? this.service.update(id, payload) : this.service.save(payload);
            service.then(this.successHandler).catch(this.errorHandler);
        },
        addSlide: function addSlide() {
            var blankObject = {};
            if (!Array.isArray(this.form.slides)) {
                this.form.slides = [blankObject];
            } else {
                this.form.slides.push(blankObject);
            }
        }
    }
};

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(5);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(4);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _api = __webpack_require__(2);

var _ListFilterComponent = __webpack_require__(7);

var _ListFilterComponent2 = _interopRequireDefault(_ListFilterComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            filters: {
                available: [],
                selected: {}
            },
            data: [],
            listLoading: false,
            service: _api.Popup,
            count: 0,
            page: 1,
            pageSize: 10
        };
    },

    methods: {
        handlePageChange: function handlePageChange(val) {
            this.page = val;
            this.fetchData();
        },
        setFilter: function setFilter(filter) {
            this.page = 1;
            var key = filter.query_param;
            var value = filter.value;
            this.$set(this.filters.selected, key, value);
            this.fetchData();
        },
        fetchData: function fetchData() {
            var _this = this;

            var params = (0, _extends3.default)({
                page: this.page
            }, this.filters.selected);
            this.listLoading = true;
            this.service.fetch({}, { params: params }).then(function (response) {
                _this.count = response.data.count;
                _this.pageSize = response.data.page_size;
                _this.data = response.data.results;
                _this.listLoading = false;
            });
        },
        handleDelete: function handleDelete(index, row) {
            var _this2 = this;

            return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this2.$confirm(_this2.$i18n.t('deleteConfirmation'), _this2.$i18n.t('delete'), {
                                    type: 'warning'
                                });

                            case 2:

                                _this2.listLoading = true;
                                _context.next = 5;
                                return _this2.service.delete(row.id);

                            case 5:

                                _this2.listLoading = false;
                                _this2.$message({
                                    message: 'Element został usunięty',
                                    type: 'success'
                                });

                                _this2.fetchData();

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        }
    },
    mounted: function mounted() {
        this.fetchData();
    },

    components: {
        ListFilterComponent: _ListFilterComponent2.default
    }
};

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _api = __webpack_require__(2);

exports.default = {
    data: function data() {
        return {
            loading: false,
            form: {},
            errors: {},
            service: _api.SiteSettings
        };
    },
    mounted: function mounted() {
        this.fetchData();
    },

    methods: {
        fetchData: function fetchData() {
            var _this = this;

            this.service.get().then(function (response) {
                _this.form = response.data;
            });
        },
        onSubmit: function onSubmit() {
            this.loading = true;
            var service = this.service.update(this.form);
            service.then(this.successHandler).catch(this.errorHandler);
        }
    }
};

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _api = __webpack_require__(2);

exports.default = {
    data: function data() {
        return {
            loading: false,
            form: {},
            errors: {},
            service: _api.SiteSettings
        };
    },
    mounted: function mounted() {
        this.fetchData();
    },

    methods: {
        fetchData: function fetchData() {
            var _this = this;

            this.service.get().then(function (response) {
                _this.form = response.data;
            });
        },
        onSubmit: function onSubmit() {
            this.loading = true;
            var service = this.service.update(this.form);
            service.then(this.successHandler).catch(this.errorHandler);
        }
    }
};

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(5);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(4);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _api = __webpack_require__(2);

var _ListFilterComponent = __webpack_require__(7);

var _ListFilterComponent2 = _interopRequireDefault(_ListFilterComponent);

var _axios = __webpack_require__(30);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      filters: {
        available: [],
        selected: {}
      },
      data: [],
      listLoading: false,
      service: _api.Occurrence,
      count: 0,
      pageSize: 0
    };
  },

  methods: {
    handleDelete: function handleDelete(index, row, registrations) {
      var _this = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$confirm(_this.$i18n.t('deleteConfirmation'), _this.$i18n.t('delete'), {
                  type: 'warning'
                });

              case 2:

                _this.listLoading = true;
                _context.next = 5;
                return _api.Registration.delete(row.id);

              case 5:

                _this.listLoading = false;
                _this.$message({
                  message: 'Element został usunięty',
                  type: 'success'
                });

                registrations.splice(index, 1);

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    handlePageChange: function handlePageChange(val) {
      this.page = val;
      this.fetchData();
    },
    downloadCSV: function downloadCSV(obj) {
      var url = this.service.exportUrl(obj.id);
      (0, _axios2.default)({
        url: url,
        method: 'GET',
        responseType: 'blob' }).then(function (response) {
        var url = window.URL.createObjectURL(new Blob([response.data]));
        var link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', obj.event + '_' + obj.date + '.csv');
        document.body.appendChild(link);
        link.click();
      });
    },
    setFilter: function setFilter(filter) {
      this.page = 1;
      var key = filter.query_param;
      var value = filter.value;
      this.$set(this.filters.selected, key, value);
      this.fetchData();
    },
    fetchData: function fetchData() {
      var _this2 = this;

      var params = (0, _extends3.default)({
        page: this.page
      }, this.filters.selected);
      this.listLoading = true;
      this.service.fetch({}, { params: params }).then(function (response) {
        _this2.count = response.data.count;
        _this2.pageSize = response.data.page_size;
        _this2.data = response.data.results;
        _this2.listLoading = false;
      });
    }
  },
  mounted: function mounted() {
    this.fetchData();
  },

  components: {
    ListFilterComponent: _ListFilterComponent2.default
  }
};

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _api = __webpack_require__(2);

exports.default = {
	data: function data() {
		return {
			loading: false,
			redirectRoute: { name: 'Stages List' },
			form: {},
			errors: {},
			service: _api.Stage
		};
	},
	mounted: function mounted() {
		this.fetchData();
	},

	methods: {
		fetchData: function fetchData() {
			var _this = this;

			if (this.$route.params.id) {
				this.service.get(this.$route.params.id).then(function (response) {
					_this.form = response.data;
				});
			}
		},
		onSubmit: function onSubmit() {
			this.loading = true;
			var id = this.$route.params.id;
			var service = id ? this.service.update(id, this.form) : this.service.save(this.form);
			service.then(this.successHandler).catch(this.errorHandler);
		}
	}
};

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(5);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(4);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _api = __webpack_require__(2);

var _ListFilterComponent = __webpack_require__(7);

var _ListFilterComponent2 = _interopRequireDefault(_ListFilterComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            filters: {
                available: [],
                selected: {}
            },
            data: [],
            listLoading: false,
            service: _api.Stage
        };
    },

    methods: {
        handlePageChange: function handlePageChange(val) {
            this.page = val;
            this.fetchData();
        },
        setFilter: function setFilter(filter) {
            this.page = 1;
            var key = filter.query_param;
            var value = filter.value;
            this.$set(this.filters.selected, key, value);
            this.fetchData();
        },
        fetchData: function fetchData() {
            var _this = this;

            var params = (0, _extends3.default)({
                page: this.page
            }, this.filters.selected);
            this.listLoading = true;
            this.service.fetch({}, { params: params }).then(function (response) {
                _this.data = response.data;
                _this.listLoading = false;
            });
        },
        handleDelete: function handleDelete(index, row) {
            var _this2 = this;

            return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this2.$confirm(_this2.$i18n.t('deleteConfirmation'), _this2.$i18n.t('delete'), {
                                    type: 'warning'
                                });

                            case 2:

                                _this2.listLoading = true;
                                _context.next = 5;
                                return _this2.service.delete(row.id);

                            case 5:

                                _this2.listLoading = false;
                                _this2.$message({
                                    message: 'Element został usunięty',
                                    type: 'success'
                                });

                                _this2.fetchData();

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        updateOrder: function updateOrder(arr, i, direction) {
            var _this3 = this;

            this.changeOrder(arr, i, direction);
            var newOrder = this.data.map(function (stage) {
                return stage.id;
            });
            this.service.changeOrder({ 'order[]': newOrder }).then(function (response) {
                _this3.$message({
                    message: 'Kolejność została zapisana',
                    type: 'success'
                });
                _this3.fetchData();
            });
        }
    },
    mounted: function mounted() {
        this.fetchData();
    },

    components: {
        ListFilterComponent: _ListFilterComponent2.default
    }
};

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(5);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(4);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _api = __webpack_require__(2);

var _ListFilterComponent = __webpack_require__(7);

var _ListFilterComponent2 = _interopRequireDefault(_ListFilterComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            filters: {
                available: [],
                selected: {}
            },
            data: [],
            listLoading: false,
            service: _api.StandCategory
        };
    },

    methods: {
        handlePageChange: function handlePageChange(val) {
            this.page = val;
            this.fetchData();
        },
        setFilter: function setFilter(filter) {
            this.page = 1;
            var key = filter.query_param;
            var value = filter.value;
            this.$set(this.filters.selected, key, value);
            this.fetchData();
        },
        fetchData: function fetchData() {
            var _this = this;

            var params = (0, _extends3.default)({
                page: this.page
            }, this.filters.selected);
            this.listLoading = true;
            this.service.fetch({}, { params: params }).then(function (response) {
                _this.data = response.data;
                _this.listLoading = false;
            });
        },
        handleDelete: function handleDelete(index, row) {
            var _this2 = this;

            return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this2.$confirm(_this2.$i18n.t('deleteConfirmation'), _this2.$i18n.t('delete'), {
                                    type: 'warning'
                                });

                            case 2:

                                _this2.listLoading = true;
                                _context.next = 5;
                                return _this2.service.delete(row.id);

                            case 5:

                                _this2.listLoading = false;
                                _this2.$message({
                                    message: 'Element został usunięty',
                                    type: 'success'
                                });

                                _this2.fetchData();

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        }
    },
    mounted: function mounted() {
        this.fetchData();
    },

    components: {
        ListFilterComponent: _ListFilterComponent2.default
    }
};

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _api = __webpack_require__(2);

exports.default = {
	data: function data() {
		return {
			loading: false,
			redirectRoute: { name: 'StandCategories List' },
			form: {},
			errors: {},
			service: _api.StandCategory
		};
	},
	mounted: function mounted() {
		this.fetchData();
	},

	methods: {
		fetchData: function fetchData() {
			var _this = this;

			if (this.$route.params.id) {
				this.service.get(this.$route.params.id).then(function (response) {
					_this.form = response.data;
				});
			}
		},
		onSubmit: function onSubmit() {
			this.loading = true;
			var id = this.$route.params.id;
			var service = id ? this.service.update(id, this.form) : this.service.save(this.form);
			service.then(this.successHandler).catch(this.errorHandler);
		}
	}
};

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _api = __webpack_require__(2);

var _PhotoCropper = __webpack_require__(69);

var _PhotoCropper2 = _interopRequireDefault(_PhotoCropper);

var _WidgetsInput = __webpack_require__(44);

var _WidgetsInput2 = _interopRequireDefault(_WidgetsInput);

var _api2 = __webpack_require__(2);

var _EditionInput = __webpack_require__(18);

var _EditionInput2 = _interopRequireDefault(_EditionInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            loading: false,
            redirectRoute: { name: 'Stands List' },
            form: {
                widgets: []
            },
            errors: {},
            service: _api.Stand,
            availableTags: [],
            popups: [],
            categories: []
        };
    },
    mounted: function mounted() {
        this.fetchData();
    },

    components: {
        PhotoCropper: _PhotoCropper2.default,
        WidgetsInput: _WidgetsInput2.default,
        EditionInput: _EditionInput2.default
    },
    computed: {
        croppers: {
            set: function set(updatedCroppers) {
                var _this = this;

                updatedCroppers.forEach(function (cropper) {
                    _this.$set(_this.form, cropper.photoFieldName, cropper.img);
                    _this.$set(_this.form, cropper.paramsFieldName, cropper.params);
                });
            },
            get: function get() {
                var _this2 = this;

                var croppers = [{
                    id: 'square',
                    aspect: 1,
                    photoFieldName: 'square_photo',
                    paramsFieldName: 'square_crop_params',
                    label: 'Kadr kwadratowy'
                }, {
                    id: 'horizontal',
                    aspect: 2,
                    photoFieldName: 'horizontal_photo',
                    paramsFieldName: 'horizontal_crop_params',
                    label: 'Kadr poziomy'
                }, {
                    id: 'vertical',
                    aspect: 1 / 2,
                    photoFieldName: 'vertical_photo',
                    paramsFieldName: 'vertical_crop_params',
                    label: 'Kadr pionowy'
                }];
                var mergeFieldNameWithValues = function mergeFieldNameWithValues(cropper) {
                    return (0, _extends3.default)({}, cropper, {
                        img: _this2.form[cropper.photoFieldName],
                        params: _this2.form[cropper.paramsFieldName]
                    });
                };
                return croppers.map(mergeFieldNameWithValues);
            }
        }
    },
    methods: {
        fetchData: function fetchData() {
            var _this3 = this;

            this.fetchCategories();
            this.fetchPopups();
            this.$store.dispatch('fetchStages');
            this.$store.dispatch('fetchEditions');
            if (this.$route.params.id) {
                this.service.get(this.$route.params.id).then(function (response) {
                    _this3.form = response.data;
                    _this3.form.tags = _this3.form.tags.map(function (tag) {
                        return tag.name;
                    });
                });
            }
            this.service.tags().then(function (response) {
                var listToObj = function listToObj(item) {
                    return { name: item.name, id: item.id };
                };

                _this3.availableTags = response.data.map(listToObj);
            });
        },
        fetchPopups: function fetchPopups() {
            var _this4 = this;

            _api2.Popup.all().then(function (response) {
                _this4.popups = response.data;
            });
        },
        fetchCategories: function fetchCategories() {
            var _this5 = this;

            _api.StandCategory.fetch().then(function (response) {
                _this5.categories = response.data;
            });
        },
        onSubmit: function onSubmit() {
            this.loading = true;
            var id = this.$route.params.id;
            var payload = (0, _extends3.default)({}, this.form);
            var prepareTags = function prepareTags(tag) {
                return typeof tag === 'string' ? { name: tag } : tag;
            };
            payload.tags = payload.tags.map(prepareTags);
            var service = id ? this.service.update(id, payload) : this.service.save(payload);
            service.then(this.successHandler).catch(this.errorHandler);
        }
    }
};

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(5);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(4);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _toConsumableArray2 = __webpack_require__(32);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _api = __webpack_require__(2);

var _ListFilterComponent = __webpack_require__(7);

var _ListFilterComponent2 = _interopRequireDefault(_ListFilterComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            filters: {
                available: [],
                selected: {}
            },
            data: [],
            listLoading: false,
            service: _api.Stand,
            pageSize: 10,
            page: 1,
            count: 0,
            categories: []
        };
    },

    methods: {
        handlePageChange: function handlePageChange(val) {
            this.page = val;
            this.fetchData();
        },
        setFilter: function setFilter(filter) {
            this.page = 1;
            var key = filter.query_param;
            var value = filter.value;
            this.$set(this.filters.selected, key, value);
            this.fetchData();
        },
        fetchData: function fetchData() {
            var _this = this;

            var params = (0, _extends3.default)({
                page: this.page
            }, this.filters.selected);
            this.listLoading = true;
            this.service.fetch({}, { params: params }).then(function (response) {
                _this.count = response.data.count;
                _this.pageSize = response.data.page_size;
                _this.data = response.data.results;
                _this.listLoading = false;
            });
        },
        fetchCategories: function fetchCategories() {
            var _this2 = this;

            _api.StandCategory.fetch().then(function (response) {
                _this2.categories = response.data;
                var options = [{ label: 'Wszystkie', value: '' }].concat((0, _toConsumableArray3.default)(_this2.categories.map(function (category) {
                    return { value: category.id, label: category.name_pl };
                })));
                _this2.filters.available.push({
                    name: 'Kategoria',
                    query_param: 'category',
                    options: options
                });
            });
        },
        handleDelete: function handleDelete(index, row) {
            var _this3 = this;

            return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this3.$confirm(_this3.$i18n.t('deleteConfirmation'), _this3.$i18n.t('delete'), {
                                    type: 'warning'
                                });

                            case 2:

                                _this3.listLoading = true;
                                _context.next = 5;
                                return _this3.service.delete(row.id);

                            case 5:

                                _this3.listLoading = false;
                                _this3.$message({
                                    message: 'Element został usunięty',
                                    type: 'success'
                                });

                                _this3.fetchData();

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this3);
            }))();
        }
    },
    mounted: function mounted() {
        this.fetchData();
        this.fetchCategories();
    },

    components: {
        ListFilterComponent: _ListFilterComponent2.default
    }
};

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _api = __webpack_require__(2);

exports.default = {
    data: function data() {
        return {
            loading: false,
            redirectRoute: { name: 'Periods List' },
            form: {},
            errors: {},
            service: _api.Period
        };
    },
    mounted: function mounted() {
        this.fetchData();
    },

    methods: {
        fetchData: function fetchData() {
            var _this = this;

            if (this.$route.params.id) {
                this.service.get(this.$route.params.id).then(function (response) {
                    _this.form = response.data;
                });
            }
        },
        onSubmit: function onSubmit() {
            this.loading = true;
            var id = this.$route.params.id;
            var service = id ? this.service.update(id, this.form) : this.service.save(this.form);
            service.then(this.successHandler).catch(this.errorHandler);
        }
    }
};

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(5);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(4);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _api = __webpack_require__(2);

var _ListFilterComponent = __webpack_require__(7);

var _ListFilterComponent2 = _interopRequireDefault(_ListFilterComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            filters: {
                available: [],
                selected: {}
            },
            data: [],
            listLoading: false,
            service: _api.Period
        };
    },

    methods: {
        setFilter: function setFilter(filter) {
            var key = filter.query_param;
            var value = filter.value;
            this.$set(this.filters.selected, key, value);
            this.fetchData();
        },
        fetchData: function fetchData() {
            var _this = this;

            var params = (0, _extends3.default)({}, this.filters.selected);
            this.listLoading = true;
            this.service.fetch({}, { params: params }).then(function (response) {
                _this.data = response.data;
                _this.listLoading = false;
            });
        },
        handleDelete: function handleDelete(index, row) {
            var _this2 = this;

            return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this2.$confirm(_this2.$i18n.t('deleteConfirmation'), _this2.$i18n.t('delete'), {
                                    type: 'warning'
                                });

                            case 2:

                                _this2.listLoading = true;
                                _context.next = 5;
                                return _this2.service.delete(row.id);

                            case 5:

                                _this2.listLoading = false;
                                _this2.$message({
                                    message: 'Element został usunięty',
                                    type: 'success'
                                });

                                _this2.fetchData();

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        }
    },
    mounted: function mounted() {
        this.fetchData();
    },

    components: {
        ListFilterComponent: _ListFilterComponent2.default
    }
};

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _api = __webpack_require__(2);

exports.default = {
    data: function data() {
        return {
            loading: false,
            redirectRoute: { name: 'Tickets List' },
            form: {
                periods: []
            },
            errors: {},
            service: _api.Ticket,
            periods: []
        };
    },
    mounted: function mounted() {
        this.fetchData();
    },

    methods: {
        addPeriod: function addPeriod() {
            if (this.form.periods === undefined) this.form.periods = [];
            this.form.periods.push({});
        },
        fetchData: function fetchData() {
            var _this = this;

            if (this.$route.params.id) {
                this.service.get(this.$route.params.id).then(function (response) {
                    _this.form = response.data;
                });
            }
            _api.Period.fetch().then(function (response) {
                _this.periods = response.data;
            });
        },
        onSubmit: function onSubmit() {
            this.loading = true;
            var id = this.$route.params.id;
            var service = id ? this.service.update(id, this.form) : this.service.save(this.form);
            service.then(this.successHandler).catch(this.errorHandler);
        }
    }
};

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(5);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(4);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _api = __webpack_require__(2);

var _ListFilterComponent = __webpack_require__(7);

var _ListFilterComponent2 = _interopRequireDefault(_ListFilterComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            filters: {
                available: [],
                selected: {}
            },
            data: [],
            listLoading: false,
            service: _api.Ticket
        };
    },

    methods: {
        handlePageChange: function handlePageChange(val) {
            this.page = val;
            this.fetchData();
        },
        setFilter: function setFilter(filter) {
            this.page = 1;
            var key = filter.query_param;
            var value = filter.value;
            this.$set(this.filters.selected, key, value);
            this.fetchData();
        },
        fetchData: function fetchData() {
            var _this = this;

            var params = (0, _extends3.default)({
                page: this.page
            }, this.filters.selected);
            this.listLoading = true;
            this.service.fetch({}, { params: params }).then(function (response) {
                _this.data = response.data;
                _this.listLoading = false;
            });
        },
        handleDelete: function handleDelete(index, row) {
            var _this2 = this;

            return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this2.$confirm(_this2.$i18n.t('deleteConfirmation'), _this2.$i18n.t('delete'), {
                                    type: 'warning'
                                });

                            case 2:

                                _this2.listLoading = true;
                                _context.next = 5;
                                return _this2.service.delete(row.id);

                            case 5:

                                _this2.listLoading = false;
                                _this2.$message({
                                    message: 'Element został usunięty',
                                    type: 'success'
                                });

                                _this2.fetchData();

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        }
    },
    mounted: function mounted() {
        this.fetchData();
    },

    components: {
        ListFilterComponent: _ListFilterComponent2.default
    }
};

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _api = __webpack_require__(2);

var _BaseWidget = __webpack_require__(240);

var _BaseWidget2 = _interopRequireDefault(_BaseWidget);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            loading: false,
            redirectRoute: { name: 'Widgets List' },
            form: {},
            errors: {},
            widgetComponent: null,
            service: _api.Widget,
            types: {}
        };
    },
    mounted: function mounted() {
        this.fetchData();
    },

    components: {
        BaseWidget: _BaseWidget2.default
    },
    methods: {
        fetchData: function fetchData() {
            var _this = this;

            if (this.$route.params.id) {
                this.service.get(this.$route.params.id).then(function (response) {
                    _this.form = response.data;
                    _this.widgetComponent = _this.getWidgetComponent(_this.form.resourcetype);
                });
            } else {
                this.$set(this.form, 'resourcetype', this.$route.params.type);
                this.widgetComponent = this.getWidgetComponent(this.form.resourcetype);
            }
            this.service.types().then(function (response) {
                _this.types = response.data;
            });
        },
        onSubmit: function onSubmit() {
            this.loading = true;
            var id = this.$route.params.id;
            var service = id ? this.service.update(id, this.form) : this.service.save(this.form);
            service.then(this.successHandler).catch(this.errorHandler);
        }
    }
};

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(5);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(4);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _keys = __webpack_require__(31);

var _keys2 = _interopRequireDefault(_keys);

var _api = __webpack_require__(2);

var _ListFilterComponent = __webpack_require__(7);

var _ListFilterComponent2 = _interopRequireDefault(_ListFilterComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            filters: {
                available: [],
                selected: {}
            },
            pageSize: 0,
            count: 0,
            types: {},
            data: [],
            listLoading: false,
            service: _api.Widget
        };
    },

    methods: {
        handlePageChange: function handlePageChange(val) {
            this.page = val;
            this.fetchData();
        },
        setFilter: function setFilter(filter) {
            this.page = 1;
            var key = filter.query_param;
            var value = filter.value;
            this.$set(this.filters.selected, key, value);
            this.fetchData();
        },
        addTypesFilter: function addTypesFilter() {
            var _this = this;

            this.service.types({ global: true }).then(function (response) {
                _this.types = response.data;
                var typesFilters = [];
                (0, _keys2.default)(_this.types).forEach(function (key) {
                    typesFilters.push({
                        'label': _this.types[key].label,
                        'value': _this.types[key].polymorphic_ctype
                    });
                });
                var options = [{ label: 'Wszystkie', value: '' }].concat(typesFilters);
                _this.filters.available.push({
                    name: 'Typ widgetu',
                    query_param: 'polymorphic_ctype',
                    options: options
                });
                _this.setFilter({ query_param: 'polymorphic_ctype', value: '' });
            });
        },
        fetchData: function fetchData() {
            var _this2 = this;

            var params = (0, _extends3.default)({
                page: this.page
            }, this.filters.selected, {
                global_scope: true
            });
            this.listLoading = true;
            this.service.fetch({}, { params: params }).then(function (response) {
                _this2.data = response.data.results;
                _this2.count = response.data.count;
                _this2.pageSize = response.data.page_size;
                _this2.listLoading = false;
            });
        },
        handleDelete: function handleDelete(index, row) {
            var _this3 = this;

            return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this3.$confirm(_this3.$i18n.t('deleteConfirmation'), _this3.$i18n.t('delete'), {
                                    type: 'warning'
                                });

                            case 2:

                                _this3.listLoading = true;
                                _context.next = 5;
                                return _this3.service.delete(row.id);

                            case 5:

                                _this3.listLoading = false;
                                _this3.$message({
                                    message: 'Element został usunięty',
                                    type: 'success'
                                });

                                _this3.fetchData();

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this3);
            }))();
        }
    },
    mounted: function mounted() {
        this.fetchData();
        this.addTypesFilter();
    },

    components: {
        ListFilterComponent: _ListFilterComponent2.default
    }
};

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = __webpack_require__(26);

var _typeof3 = _interopRequireDefault(_typeof2);

var _promise = __webpack_require__(47);

var _promise2 = _interopRequireDefault(_promise);

exports.default = function (url) {
    var prepareURL = function prepareURL(urlParams) {
        urlParams = urlParams || {};
        if ((typeof urlParams === 'undefined' ? 'undefined' : (0, _typeof3.default)(urlParams)) !== 'object') {
            urlParams = {
                id: urlParams
            };
        }

        var convertURLFragment = function convertURLFragment(fragment) {
            return fragment.startsWith(':') ? urlParams[fragment.slice(1)] : fragment;
        };
        return url.split('/').map(convertURLFragment).join('/').replace('//', '/');
    };

    return {
        fetch: function fetch(urlParams, payload) {
            return _axios2.default.get(prepareURL(urlParams), payload);
        },
        update: function update(urlParams, payload) {
            return _axios2.default.put(prepareURL(urlParams), payload);
        },
        get: function get(urlParams, payload) {
            return _axios2.default.get(prepareURL(urlParams), payload);
        },
        save: function save(payload) {
            return _axios2.default.post(prepareURL(), payload);
        },
        delete: function _delete(urlParams) {
            return _axios2.default.delete(prepareURL(urlParams));
        }
    };
};

var _axios = __webpack_require__(30);

var _axios2 = _interopRequireDefault(_axios);

var _router = __webpack_require__(70);

var _router2 = _interopRequireDefault(_router);

var _index = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_axios2.default.interceptors.request.use(function (config) {
    config.headers['Authorization'] = window.localStorage.getItem('token');
    if (window.localStorage.getItem('lang')) {
        config.headers['Accept-Language'] = window.localStorage.getItem('lang');
    }
    return config;
}, function (error) {
    return _promise2.default.reject(error);
});

_axios2.default.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    var errorResponse = error.response;
    if (errorResponse.status === 401) {
        var tokenSplitted = window.localStorage.token.split(" ");
        tokenSplitted = tokenSplitted[tokenSplitted.length - 1];
        return _index.Auth.tokenRefresh({
            'token': tokenSplitted
        }).then(function (response) {
            window.localStorage.setItem('token', 'JWT ' + response.data.token);
            return (0, _axios2.default)(errorResponse.config);
        }).catch(function (error) {
            window.localStorage.removeItem('token');
            _router2.default.push({ name: 'Login' });
            return _promise2.default.reject(error);
        });
    }
    return _promise2.default.reject(error);
});

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _CharField = __webpack_require__(625);

var _CharField2 = _interopRequireDefault(_CharField);

var _ChoiceField = __webpack_require__(626);

var _ChoiceField2 = _interopRequireDefault(_ChoiceField);

var _TextField = __webpack_require__(628);

var _TextField2 = _interopRequireDefault(_TextField);

var _FileField = __webpack_require__(627);

var _FileField2 = _interopRequireDefault(_FileField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    CharField: _CharField2.default,
    ChoiceField: _ChoiceField2.default,
    TextField: _TextField2.default,
    FileField: _FileField2.default
};

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _TextWidget = __webpack_require__(652);

var _TextWidget2 = _interopRequireDefault(_TextWidget);

var _HTMLWidget = __webpack_require__(640);

var _HTMLWidget2 = _interopRequireDefault(_HTMLWidget);

var _LineupWidget = __webpack_require__(643);

var _LineupWidget2 = _interopRequireDefault(_LineupWidget);

var _LogotypesWidget = __webpack_require__(644);

var _LogotypesWidget2 = _interopRequireDefault(_LogotypesWidget);

var _SlidesWidget = __webpack_require__(650);

var _SlidesWidget2 = _interopRequireDefault(_SlidesWidget);

var _NewsletterWidget = __webpack_require__(647);

var _NewsletterWidget2 = _interopRequireDefault(_NewsletterWidget);

var _BoxesWidget = __webpack_require__(632);

var _BoxesWidget2 = _interopRequireDefault(_BoxesWidget);

var _InformationTilesWidget = __webpack_require__(641);

var _InformationTilesWidget2 = _interopRequireDefault(_InformationTilesWidget);

var _FoodVendorsWidget = __webpack_require__(637);

var _FoodVendorsWidget2 = _interopRequireDefault(_FoodVendorsWidget);

var _ArtistsListWidget = __webpack_require__(630);

var _ArtistsListWidget2 = _interopRequireDefault(_ArtistsListWidget);

var _MobileAppWidget = __webpack_require__(645);

var _MobileAppWidget2 = _interopRequireDefault(_MobileAppWidget);

var _EventsListWidget = __webpack_require__(635);

var _EventsListWidget2 = _interopRequireDefault(_EventsListWidget);

var _InstagramWidget = __webpack_require__(642);

var _InstagramWidget2 = _interopRequireDefault(_InstagramWidget);

var _TicketsWidget = __webpack_require__(653);

var _TicketsWidget2 = _interopRequireDefault(_TicketsWidget);

var _ColumnsWidget = __webpack_require__(634);

var _ColumnsWidget2 = _interopRequireDefault(_ColumnsWidget);

var _StandsWidget = __webpack_require__(651);

var _StandsWidget2 = _interopRequireDefault(_StandsWidget);

var _GalleriesListWidget = __webpack_require__(639);

var _GalleriesListWidget2 = _interopRequireDefault(_GalleriesListWidget);

var _WhatWePlayWidget = __webpack_require__(654);

var _WhatWePlayWidget2 = _interopRequireDefault(_WhatWePlayWidget);

var _FormWidget = __webpack_require__(638);

var _FormWidget2 = _interopRequireDefault(_FormWidget);

var _PhotoWithTextWidget = __webpack_require__(648);

var _PhotoWithTextWidget2 = _interopRequireDefault(_PhotoWithTextWidget);

var _RepertoireWidget = __webpack_require__(649);

var _RepertoireWidget2 = _interopRequireDefault(_RepertoireWidget);

var _NewsWidget = __webpack_require__(646);

var _NewsWidget2 = _interopRequireDefault(_NewsWidget);

var _FAQWidget = __webpack_require__(636);

var _FAQWidget2 = _interopRequireDefault(_FAQWidget);

var _BreadcrumbsWidget = __webpack_require__(633);

var _BreadcrumbsWidget2 = _interopRequireDefault(_BreadcrumbsWidget);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    PhotoWithTextWidget: _PhotoWithTextWidget2.default,
    TextWidget: _TextWidget2.default,
    LogotypesWidget: _LogotypesWidget2.default,
    LineupWidget: _LineupWidget2.default,
    SlidesWidget: _SlidesWidget2.default,
    NewsletterWidget: _NewsletterWidget2.default,
    HTMLWidget: _HTMLWidget2.default,
    BoxesWidget: _BoxesWidget2.default,
    InformationTilesWidget: _InformationTilesWidget2.default,
    FoodVendorsWidget: _FoodVendorsWidget2.default,
    ArtistsListWidget: _ArtistsListWidget2.default,
    MobileAppWidget: _MobileAppWidget2.default,
    EventsListWidget: _EventsListWidget2.default,
    InstagramWidget: _InstagramWidget2.default,
    TicketsWidget: _TicketsWidget2.default,
    ColumnsWidget: _ColumnsWidget2.default,
    StandsWidget: _StandsWidget2.default,
    GalleriesListWidget: _GalleriesListWidget2.default,
    WhatWePlayWidget: _WhatWePlayWidget2.default,
    FormWidget: _FormWidget2.default,
    RepertoireWidget: _RepertoireWidget2.default,
    NewsWidget: _NewsWidget2.default,
    FAQWidget: _FAQWidget2.default,
    BreadcrumbsWidget: _BreadcrumbsWidget2.default
};

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	'logout': 'Logout',
	'search': 'Search',
	'query': 'Query',
	'cancel': 'Cancel',
	'submit': 'Submit',
	'manage': 'Manage',
	'add': 'Add',
	'edit': 'Edit',
	'delete': 'Delete',
	'all': 'All',
	'published': 'Published',
	'unpublished': 'Unpublished',
	'status': 'Status',
	'year': 'Year',
	'areYouSure': 'Are you sure?',
	'deleteConfirmation': 'Are you sure to delete item?'
};

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	'logout': 'Wyloguj',
	'search': 'Szukaj',
	'query': 'Fraza do wyszukania',
	'cancel': 'Anuluj',
	'submit': 'Zatwierdź',
	'manage': 'Zarządzaj',
	'add': 'Dodaj',
	'edit': 'Edytuj',
	'delete': 'Usuń',
	'all': 'Wszystkie',
	'published': 'Opublikowane',
	'unpublished': 'Nieopublikowane',
	'status': 'Status',
	'year': 'Rok',
	'areYouSure': 'Na pewno?',
	'deleteConfirmation': 'Element zostanie bezpowrotnie usunięty.'
};

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(8);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(250);

var _App2 = _interopRequireDefault(_App);

var _elementUi = __webpack_require__(71);

var _elementUi2 = _interopRequireDefault(_elementUi);

var _vueRouter = __webpack_require__(72);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _vueI18n = __webpack_require__(249);

var _vueI18n2 = _interopRequireDefault(_vueI18n);

var _en = __webpack_require__(246);

var _en2 = _interopRequireDefault(_en);

var _store = __webpack_require__(245);

var _store2 = _interopRequireDefault(_store);

var _vuex = __webpack_require__(73);

var _vuex2 = _interopRequireDefault(_vuex);

var _router = __webpack_require__(70);

var _router2 = _interopRequireDefault(_router);

var _i18n = __webpack_require__(243);

var _i18n2 = _interopRequireDefault(_i18n);

var _WyswigInput = __webpack_require__(258);

var _WyswigInput2 = _interopRequireDefault(_WyswigInput);

var _FormLanguageSwitcher = __webpack_require__(253);

var _FormLanguageSwitcher2 = _interopRequireDefault(_FormLanguageSwitcher);

var _ImageInputComponent = __webpack_require__(255);

var _ImageInputComponent2 = _interopRequireDefault(_ImageInputComponent);

var _FileInputComponent = __webpack_require__(252);

var _FileInputComponent2 = _interopRequireDefault(_FileInputComponent);

var _LinkComponent = __webpack_require__(256);

var _LinkComponent2 = _interopRequireDefault(_LinkComponent);

var _FormsetHeader = __webpack_require__(254);

var _FormsetHeader2 = _interopRequireDefault(_FormsetHeader);

__webpack_require__(244);

var _tinymceVue = __webpack_require__(242);

var _tinymceVue2 = _interopRequireDefault(_tinymceVue);

var _ColorPicker = __webpack_require__(251);

var _ColorPicker2 = _interopRequireDefault(_ColorPicker);

var _SearchListForm = __webpack_require__(257);

var _SearchListForm2 = _interopRequireDefault(_SearchListForm);

__webpack_require__(248);

__webpack_require__(247);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_elementUi2.default, { locale: _en2.default });
_vue2.default.use(_vueRouter2.default);
_vue2.default.use(_vuex2.default);
_vue2.default.use(_vueI18n2.default);

_vue2.default.use(_tinymceVue2.default);

var i18n = new _vueI18n2.default({
	locale: 'pl',
	fallbackLocale: 'pl',
	messages: _i18n2.default });

_vue2.default.component('editor', _tinymceVue2.default);
_vue2.default.component('wyswig-input', _WyswigInput2.default);
_vue2.default.component('form-language-switcher', _FormLanguageSwitcher2.default);
_vue2.default.component('image-input-component', _ImageInputComponent2.default);
_vue2.default.component('file-input-component', _FileInputComponent2.default);
_vue2.default.component('link-component', _LinkComponent2.default);
_vue2.default.component('formset-header', _FormsetHeader2.default);
_vue2.default.component('el-color-picker', _ColorPicker2.default);
_vue2.default.component('search-list-form', _SearchListForm2.default);

new _vue2.default({
	router: _router2.default,
	store: _store2.default,
	i18n: i18n,
	render: function render(h) {
		return h(_App2.default);
	}
}).$mount('#app');

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(5);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(4);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _api = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {};
var mutations = {};
var actions = {
    register: function register(_ref, user) {
        var _this = this;

        var commit = _ref.commit;
        return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
            var data;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _api.Auth.register(user);

                        case 2:
                            data = _context.sent;
                            return _context.abrupt('return', data);

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },
    login: function login(_ref2, user) {
        var _this2 = this;

        var commit = _ref2.commit;
        return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
            var response;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return _api.Auth.login(user);

                        case 2:
                            response = _context2.sent;

                            if (response.status === 200) {
                                window.localStorage.setItem('token', 'JWT ' + response.data.token);
                            }
                            return _context2.abrupt('return', response);

                        case 5:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }))();
    },
    logout: function logout(_ref3) {
        var _this3 = this;

        var commit = _ref3.commit;
        return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.next = 2;
                            return _api.Auth.logout();

                        case 2:
                            window.localStorage.removeItem('token');

                        case 3:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3);
        }))();
    }
};

exports.default = {
    namespaced: true,
    mutations: mutations,
    state: state,
    actions: actions
};

/***/ }),
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 481 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 482 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 483 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 484 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 485 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 486 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 487 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 488 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 489 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 490 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 491 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 492 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 493 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 494 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 495 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 496 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 497 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 498 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 499 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 500 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 501 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 502 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 503 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 504 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 505 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 506 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 507 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 508 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 509 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 510 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 511 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 512 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 513 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 514 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 515 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 516 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 517 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 518 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 519 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 520 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 521 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 522 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 523 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 524 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 525 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 526 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 527 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 528 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 529 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 530 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 531 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 532 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 533 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 534 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 535 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 536 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 537 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 538 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 539 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 540 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 541 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 542 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 543 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 544 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 545 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 546 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 547 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 548 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 549 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 550 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 551 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 552 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 553 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 554 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 555 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 556 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 557 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 558 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 559 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 560 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 561 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 562 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 563 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 564 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 565 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 566 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 567 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 568 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 569 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 570 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 571 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 572 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 573 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 574 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 575 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 576 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 577 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 578 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 579 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 580 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 581 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 582 */,
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 109,
	"./af.js": 109,
	"./ar": 116,
	"./ar-dz": 110,
	"./ar-dz.js": 110,
	"./ar-kw": 111,
	"./ar-kw.js": 111,
	"./ar-ly": 112,
	"./ar-ly.js": 112,
	"./ar-ma": 113,
	"./ar-ma.js": 113,
	"./ar-sa": 114,
	"./ar-sa.js": 114,
	"./ar-tn": 115,
	"./ar-tn.js": 115,
	"./ar.js": 116,
	"./az": 117,
	"./az.js": 117,
	"./be": 118,
	"./be.js": 118,
	"./bg": 119,
	"./bg.js": 119,
	"./bm": 120,
	"./bm.js": 120,
	"./bn": 121,
	"./bn.js": 121,
	"./bo": 122,
	"./bo.js": 122,
	"./br": 123,
	"./br.js": 123,
	"./bs": 124,
	"./bs.js": 124,
	"./ca": 125,
	"./ca.js": 125,
	"./cs": 126,
	"./cs.js": 126,
	"./cv": 127,
	"./cv.js": 127,
	"./cy": 128,
	"./cy.js": 128,
	"./da": 129,
	"./da.js": 129,
	"./de": 132,
	"./de-at": 130,
	"./de-at.js": 130,
	"./de-ch": 131,
	"./de-ch.js": 131,
	"./de.js": 132,
	"./dv": 133,
	"./dv.js": 133,
	"./el": 134,
	"./el.js": 134,
	"./en-SG": 135,
	"./en-SG.js": 135,
	"./en-au": 136,
	"./en-au.js": 136,
	"./en-ca": 137,
	"./en-ca.js": 137,
	"./en-gb": 138,
	"./en-gb.js": 138,
	"./en-ie": 139,
	"./en-ie.js": 139,
	"./en-il": 140,
	"./en-il.js": 140,
	"./en-nz": 141,
	"./en-nz.js": 141,
	"./eo": 142,
	"./eo.js": 142,
	"./es": 145,
	"./es-do": 143,
	"./es-do.js": 143,
	"./es-us": 144,
	"./es-us.js": 144,
	"./es.js": 145,
	"./et": 146,
	"./et.js": 146,
	"./eu": 147,
	"./eu.js": 147,
	"./fa": 148,
	"./fa.js": 148,
	"./fi": 149,
	"./fi.js": 149,
	"./fo": 150,
	"./fo.js": 150,
	"./fr": 153,
	"./fr-ca": 151,
	"./fr-ca.js": 151,
	"./fr-ch": 152,
	"./fr-ch.js": 152,
	"./fr.js": 153,
	"./fy": 154,
	"./fy.js": 154,
	"./ga": 155,
	"./ga.js": 155,
	"./gd": 156,
	"./gd.js": 156,
	"./gl": 157,
	"./gl.js": 157,
	"./gom-latn": 158,
	"./gom-latn.js": 158,
	"./gu": 159,
	"./gu.js": 159,
	"./he": 160,
	"./he.js": 160,
	"./hi": 161,
	"./hi.js": 161,
	"./hr": 162,
	"./hr.js": 162,
	"./hu": 163,
	"./hu.js": 163,
	"./hy-am": 164,
	"./hy-am.js": 164,
	"./id": 165,
	"./id.js": 165,
	"./is": 166,
	"./is.js": 166,
	"./it": 168,
	"./it-ch": 167,
	"./it-ch.js": 167,
	"./it.js": 168,
	"./ja": 169,
	"./ja.js": 169,
	"./jv": 170,
	"./jv.js": 170,
	"./ka": 171,
	"./ka.js": 171,
	"./kk": 172,
	"./kk.js": 172,
	"./km": 173,
	"./km.js": 173,
	"./kn": 174,
	"./kn.js": 174,
	"./ko": 175,
	"./ko.js": 175,
	"./ku": 176,
	"./ku.js": 176,
	"./ky": 177,
	"./ky.js": 177,
	"./lb": 178,
	"./lb.js": 178,
	"./lo": 179,
	"./lo.js": 179,
	"./lt": 180,
	"./lt.js": 180,
	"./lv": 181,
	"./lv.js": 181,
	"./me": 182,
	"./me.js": 182,
	"./mi": 183,
	"./mi.js": 183,
	"./mk": 184,
	"./mk.js": 184,
	"./ml": 185,
	"./ml.js": 185,
	"./mn": 186,
	"./mn.js": 186,
	"./mr": 187,
	"./mr.js": 187,
	"./ms": 189,
	"./ms-my": 188,
	"./ms-my.js": 188,
	"./ms.js": 189,
	"./mt": 190,
	"./mt.js": 190,
	"./my": 191,
	"./my.js": 191,
	"./nb": 192,
	"./nb.js": 192,
	"./ne": 193,
	"./ne.js": 193,
	"./nl": 195,
	"./nl-be": 194,
	"./nl-be.js": 194,
	"./nl.js": 195,
	"./nn": 196,
	"./nn.js": 196,
	"./pa-in": 197,
	"./pa-in.js": 197,
	"./pl": 198,
	"./pl.js": 198,
	"./pt": 200,
	"./pt-br": 199,
	"./pt-br.js": 199,
	"./pt.js": 200,
	"./ro": 201,
	"./ro.js": 201,
	"./ru": 202,
	"./ru.js": 202,
	"./sd": 203,
	"./sd.js": 203,
	"./se": 204,
	"./se.js": 204,
	"./si": 205,
	"./si.js": 205,
	"./sk": 206,
	"./sk.js": 206,
	"./sl": 207,
	"./sl.js": 207,
	"./sq": 208,
	"./sq.js": 208,
	"./sr": 210,
	"./sr-cyrl": 209,
	"./sr-cyrl.js": 209,
	"./sr.js": 210,
	"./ss": 211,
	"./ss.js": 211,
	"./sv": 212,
	"./sv.js": 212,
	"./sw": 213,
	"./sw.js": 213,
	"./ta": 214,
	"./ta.js": 214,
	"./te": 215,
	"./te.js": 215,
	"./tet": 216,
	"./tet.js": 216,
	"./tg": 217,
	"./tg.js": 217,
	"./th": 218,
	"./th.js": 218,
	"./tl-ph": 219,
	"./tl-ph.js": 219,
	"./tlh": 220,
	"./tlh.js": 220,
	"./tr": 221,
	"./tr.js": 221,
	"./tzl": 222,
	"./tzl.js": 222,
	"./tzm": 224,
	"./tzm-latn": 223,
	"./tzm-latn.js": 223,
	"./tzm.js": 224,
	"./ug-cn": 225,
	"./ug-cn.js": 225,
	"./uk": 226,
	"./uk.js": 226,
	"./ur": 227,
	"./ur.js": 227,
	"./uz": 229,
	"./uz-latn": 228,
	"./uz-latn.js": 228,
	"./uz.js": 229,
	"./vi": 230,
	"./vi.js": 230,
	"./x-pseudo": 231,
	"./x-pseudo.js": 231,
	"./yo": 232,
	"./yo.js": 232,
	"./zh-cn": 233,
	"./zh-cn.js": 233,
	"./zh-hk": 234,
	"./zh-hk.js": 234,
	"./zh-tw": 235,
	"./zh-tw.js": 235
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 583;

/***/ }),
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(497)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(309),
  /* template */
  __webpack_require__(724),
  /* scopeId */
  "data-v-22c761b4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(498)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(316),
  /* template */
  __webpack_require__(725),
  /* scopeId */
  "data-v-28684b3b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(511)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(318),
  /* template */
  __webpack_require__(738),
  /* scopeId */
  "data-v-34aa56f4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(535)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(319),
  /* template */
  __webpack_require__(762),
  /* scopeId */
  "data-v-5b9532b5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(503)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(320),
  /* template */
  __webpack_require__(730),
  /* scopeId */
  "data-v-2df70aed",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(517)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(321),
  /* template */
  __webpack_require__(744),
  /* scopeId */
  "data-v-41fbc408",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(488)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(322),
  /* template */
  __webpack_require__(714),
  /* scopeId */
  "data-v-131df9c6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(489)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(323),
  /* template */
  __webpack_require__(715),
  /* scopeId */
  "data-v-134f6ca2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(522)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(324),
  /* template */
  __webpack_require__(749),
  /* scopeId */
  "data-v-4ab93411",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(531)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(325),
  /* template */
  __webpack_require__(758),
  /* scopeId */
  "data-v-579da874",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(485)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(327),
  /* template */
  __webpack_require__(711),
  /* scopeId */
  "data-v-04c9db3a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(519)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(328),
  /* template */
  __webpack_require__(746),
  /* scopeId */
  "data-v-45ded292",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(529)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(330),
  /* template */
  __webpack_require__(756),
  /* scopeId */
  "data-v-555cdc53",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(484)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(331),
  /* template */
  __webpack_require__(710),
  /* scopeId */
  "data-v-0372cbac",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(571)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(332),
  /* template */
  __webpack_require__(800),
  /* scopeId */
  "data-v-c8fcd812",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(543)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(333),
  /* template */
  __webpack_require__(770),
  /* scopeId */
  "data-v-62ddcd75",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(558)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(334),
  /* template */
  __webpack_require__(787),
  /* scopeId */
  "data-v-978c2220",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(514)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(335),
  /* template */
  __webpack_require__(741),
  /* scopeId */
  "data-v-3e9f8269",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(524)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(336),
  /* template */
  __webpack_require__(751),
  /* scopeId */
  "data-v-4c92f622",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(538)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(337),
  /* template */
  __webpack_require__(765),
  /* scopeId */
  "data-v-5f753488",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(572)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(338),
  /* template */
  __webpack_require__(801),
  /* scopeId */
  "data-v-cb562fae",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(502)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(339),
  /* template */
  __webpack_require__(729),
  /* scopeId */
  "data-v-2de1f1d7",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(550)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(340),
  /* template */
  __webpack_require__(778),
  /* scopeId */
  "data-v-776d1e0c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(567)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(341),
  /* template */
  __webpack_require__(796),
  /* scopeId */
  "data-v-b35c2ea6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(553)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(342),
  /* template */
  __webpack_require__(781),
  /* scopeId */
  "data-v-7da79df0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(486)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(343),
  /* template */
  __webpack_require__(712),
  /* scopeId */
  "data-v-09d0c839",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(562)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(344),
  /* template */
  __webpack_require__(791),
  /* scopeId */
  "data-v-a391251e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(518)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(345),
  /* template */
  __webpack_require__(745),
  /* scopeId */
  "data-v-430aae57",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(505)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(346),
  /* template */
  __webpack_require__(732),
  /* scopeId */
  "data-v-2f731aff",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(536)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(347),
  /* template */
  __webpack_require__(763),
  /* scopeId */
  "data-v-5df98756",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(546)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(348),
  /* template */
  __webpack_require__(773),
  /* scopeId */
  "data-v-6ac5f780",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(532)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(349),
  /* template */
  __webpack_require__(759),
  /* scopeId */
  "data-v-5812b60a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(574)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(350),
  /* template */
  __webpack_require__(803),
  /* scopeId */
  "data-v-d3ff016a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(547)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(351),
  /* template */
  __webpack_require__(775),
  /* scopeId */
  "data-v-6c0f2e81",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(551)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(352),
  /* template */
  __webpack_require__(779),
  /* scopeId */
  "data-v-78155864",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(527)

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(754),
  /* scopeId */
  "data-v-5372cc18",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(520)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(353),
  /* template */
  __webpack_require__(747),
  /* scopeId */
  "data-v-47c1e72f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(559)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(354),
  /* template */
  __webpack_require__(788),
  /* scopeId */
  "data-v-9fd6af90",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(539)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(355),
  /* template */
  __webpack_require__(766),
  /* scopeId */
  "data-v-609d768d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(487)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(356),
  /* template */
  __webpack_require__(713),
  /* scopeId */
  "data-v-1163fc54",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(493)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(357),
  /* template */
  __webpack_require__(720),
  /* scopeId */
  "data-v-1a8aad4b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(555)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(358),
  /* template */
  __webpack_require__(783),
  /* scopeId */
  "data-v-85863182",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(499)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(359),
  /* template */
  __webpack_require__(726),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(525)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(360),
  /* template */
  __webpack_require__(752),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(491)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(361),
  /* template */
  __webpack_require__(717),
  /* scopeId */
  "data-v-1672b658",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(549)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(362),
  /* template */
  __webpack_require__(777),
  /* scopeId */
  "data-v-73fda726",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(544)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(363),
  /* template */
  __webpack_require__(771),
  /* scopeId */
  "data-v-665dcc58",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(545)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(364),
  /* template */
  __webpack_require__(772),
  /* scopeId */
  "data-v-68682fde",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(548)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(365),
  /* template */
  __webpack_require__(776),
  /* scopeId */
  "data-v-7378d66d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(506)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(366),
  /* template */
  __webpack_require__(733),
  /* scopeId */
  "data-v-2fe1378f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(528)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(367),
  /* template */
  __webpack_require__(755),
  /* scopeId */
  "data-v-54270cdc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(542)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(368),
  /* template */
  __webpack_require__(769),
  /* scopeId */
  "data-v-620a0f9a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(490)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(369),
  /* template */
  __webpack_require__(716),
  /* scopeId */
  "data-v-13621864",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(560)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(370),
  /* template */
  __webpack_require__(789),
  /* scopeId */
  "data-v-a0331320",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(569)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(371),
  /* template */
  __webpack_require__(798),
  /* scopeId */
  "data-v-bd5d3e62",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(577)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(372),
  /* template */
  __webpack_require__(806),
  /* scopeId */
  "data-v-dd5ba642",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(565)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(373),
  /* template */
  __webpack_require__(794),
  /* scopeId */
  "data-v-b1def274",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(580)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(374),
  /* template */
  __webpack_require__(809),
  /* scopeId */
  "data-v-e9f2ebec",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(566)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(375),
  /* template */
  __webpack_require__(795),
  /* scopeId */
  "data-v-b280c0ae",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(501)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(376),
  /* template */
  __webpack_require__(728),
  /* scopeId */
  "data-v-2d962798",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(541)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(377),
  /* template */
  __webpack_require__(768),
  /* scopeId */
  "data-v-618f4e72",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(526)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(378),
  /* template */
  __webpack_require__(753),
  /* scopeId */
  "data-v-50fe51c6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(554)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(379),
  /* template */
  __webpack_require__(782),
  /* scopeId */
  "data-v-846916ae",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(563)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(380),
  /* template */
  __webpack_require__(792),
  /* scopeId */
  "data-v-ade353e4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(533)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(381),
  /* template */
  __webpack_require__(760),
  /* scopeId */
  "data-v-59fbf646",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(581)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(382),
  /* template */
  __webpack_require__(810),
  /* scopeId */
  "data-v-f24cf912",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(573)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(383),
  /* template */
  __webpack_require__(802),
  /* scopeId */
  "data-v-d2d61452",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(570)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(384),
  /* template */
  __webpack_require__(799),
  /* scopeId */
  "data-v-be08755a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(530)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(385),
  /* template */
  __webpack_require__(757),
  /* scopeId */
  "data-v-561627a6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(556)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(386),
  /* template */
  __webpack_require__(784),
  /* scopeId */
  "data-v-86bc2724",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(510)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(387),
  /* template */
  __webpack_require__(737),
  /* scopeId */
  "data-v-348e8dd2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(564)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(388),
  /* template */
  __webpack_require__(793),
  /* scopeId */
  "data-v-b05517d0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(540)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(389),
  /* template */
  __webpack_require__(767),
  /* scopeId */
  "data-v-60f626ad",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(576)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(390),
  /* template */
  __webpack_require__(805),
  /* scopeId */
  "data-v-da096d5a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(504)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(391),
  /* template */
  __webpack_require__(731),
  /* scopeId */
  "data-v-2e32d6ac",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(509)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(392),
  /* template */
  __webpack_require__(736),
  /* scopeId */
  "data-v-3145b218",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(516)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(393),
  /* template */
  __webpack_require__(743),
  /* scopeId */
  "data-v-4199d3d8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(482)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(394),
  /* template */
  __webpack_require__(708),
  /* scopeId */
  "data-v-00848226",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(552)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(395),
  /* template */
  __webpack_require__(780),
  /* scopeId */
  "data-v-7924b4ac",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(494)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(396),
  /* template */
  __webpack_require__(721),
  /* scopeId */
  "data-v-1c6a4934",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(561)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(397),
  /* template */
  __webpack_require__(790),
  /* scopeId */
  "data-v-a32a9e50",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(500)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(398),
  /* template */
  __webpack_require__(727),
  /* scopeId */
  "data-v-2d0881ed",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(515)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(399),
  /* template */
  __webpack_require__(742),
  /* scopeId */
  "data-v-3f48f95d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(557)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(400),
  /* template */
  __webpack_require__(786),
  /* scopeId */
  "data-v-90196bf0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(496)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(401),
  /* template */
  __webpack_require__(723),
  /* scopeId */
  "data-v-1ed518b0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(507)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(402),
  /* template */
  __webpack_require__(734),
  /* scopeId */
  "data-v-3036191d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(578)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(403),
  /* template */
  __webpack_require__(807),
  /* scopeId */
  "data-v-e251abd0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(534)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(404),
  /* template */
  __webpack_require__(761),
  /* scopeId */
  "data-v-5a2b30ad",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 708 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    staticClass: "sidebar",
    attrs: {
      "span": 6
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Add Stage'
      }
    }
  }, [_c('el-button', {
    staticClass: "fluid",
    attrs: {
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('add')) + " Scenę "), _c('i', {
    staticClass: "el-icon-plus"
  })])], 1), _vm._v(" "), _c('ListFilterComponent', {
    attrs: {
      "selectedFilters": _vm.filters.selected,
      "listFilters": _vm.filters.available
    },
    on: {
      "setFilter": _vm.setFilter
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "box",
    attrs: {
      "span": 18
    }
  }, [_c('div', {
    staticClass: "list__header"
  }, [_c('p', {
    staticClass: "list__title"
  }, [_vm._v("\n                    " + _vm._s(_vm.getRouteName(_vm.$route)) + "\n                ")]), _vm._v(" "), _c('search-list-form', {
    on: {
      "submit": _vm.fetchData
    },
    model: {
      value: (_vm.filters.selected.search),
      callback: function($$v) {
        _vm.$set(_vm.filters.selected, "search", $$v)
      },
      expression: "filters.selected.search"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticClass: "list__table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.data,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "id",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name_pl",
      "label": "nazwa (pl)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name_en",
      "label": "nazwa (en)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "pull-right",
    attrs: {
      "label": "opcje",
      "width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'Edit Stage',
              params: {
                id: scope.row.id
              }
            }
          }
        }, [_c('el-button', {
          attrs: {
            "size": "small",
            "title": _vm.$t('edit')
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        })])], 1), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small",
            "title": _vm.$t('delete')
          },
          on: {
            "click": function($event) {
              return _vm.handleDelete(scope.$index, scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        })]), _vm._v(" "), (scope.$index !== _vm.data.length - 1) ? _c('el-button', {
          attrs: {
            "size": "small",
            "title": "Przesuń w dół"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.updateOrder(_vm.data, scope.$index, 1)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-arrow-down"
        })]) : _vm._e(), _vm._v(" "), (scope.$index !== 0) ? _c('el-button', {
          attrs: {
            "size": "small",
            "title": "Przesuń do góry"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.updateOrder(_vm.data, scope.$index, -1)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-arrow-up"
        })]) : _vm._e()]
      }
    }])
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 709 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    staticClass: "photos-dialog",
    attrs: {
      "title": "Zdjęcia",
      "append-to-body": "",
      "before-close": _vm.handleClose,
      "width": "80vw",
      "visible": _vm.dialogFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.searchData($event)
      }
    }
  }, [_c('el-form-item', {
    staticClass: "list__search-wrapper"
  }, [_c('el-input', {
    staticClass: "list__search",
    attrs: {
      "placeholder": "Nazwa"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "list__search-wrapper"
  }, [_c('el-button', {
    on: {
      "click": _vm.searchData
    }
  }, [_vm._v(_vm._s(_vm.$t('search')))])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "list"
  }, _vm._l((_vm.photos), function(photo) {
    return _c('el-card', {
      key: ((photo.photo) + "_" + (photo.name_pl) + "_" + (photo.title_pl)),
      staticClass: "item",
      attrs: {
        "shadow": "hover",
        "body-style": {
          padding: '0px'
        }
      }
    }, [_c('div', {
      on: {
        "click": function($event) {
          return _vm.submitPhoto(photo.photo)
        }
      }
    }, [_c('img', {
      staticClass: "item__img",
      attrs: {
        "src": photo.photo,
        "alt": ""
      }
    }), _vm._v(" "), (photo.name_pl || photo.title_pl) ? _c('p', {
      staticClass: "item__text"
    }, [_vm._v("\n                        " + _vm._s(_vm.truncate(photo.name_pl || photo.title_pl)) + "\n                    ")]) : _vm._e()])])
  }), 1), _vm._v(" "), _c('el-col', {
    staticClass: "list__pagination",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "disabled": _vm.loading,
      "page-size": _vm.pageSize,
      "total": _vm.count
    },
    on: {
      "current-change": _vm.handlePageChange
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.cancelForm()
      }
    }
  }, [_vm._v("Anuluj")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 710 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "items"
  }, [_c('el-collapse', {
    staticClass: "formset__list"
  }, _vm._l((_vm.form.items), function(item, i) {
    return _c('div', {
      staticClass: "formset__item"
    }, [_c('el-collapse-item', {
      attrs: {
        "name": i
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('formset-header', {
      attrs: {
        "label": _vm.getHeaderLabel(item),
        "items": _vm.form.items,
        "errors": _vm.checkForErrors(_vm.errors.items, [i]),
        "index": i
      },
      on: {
        "update:items": function($event) {
          return _vm.$set(_vm.form, "items", $event)
        }
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Typ",
        "error": _vm.errors.items && _vm.errors.items[i] && _vm.errors.items[i].item_type
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": "Wybierz typ breadcrumba"
      },
      on: {
        "change": function($event) {
          return _vm.typeChanged(item)
        }
      },
      model: {
        value: (item.item_type),
        callback: function($$v) {
          _vm.$set(item, "item_type", $$v)
        },
        expression: "item.item_type"
      }
    }, _vm._l((_vm.types), function(item) {
      return _c('el-option', {
        key: item.value,
        attrs: {
          "label": item.label,
          "value": item.value
        }
      })
    }), 1)], 1), _vm._v(" "), (item.item_type) ? _c('el-form-item', {
      attrs: {
        "label": "Tytuł",
        "error": _vm.errors.items && _vm.errors.items[i] && _vm.errors.items[i][_vm.addLanguageSuffix('title')]
      }
    }, [_c('el-input', {
      model: {
        value: (item[_vm.addLanguageSuffix('title')]),
        callback: function($$v) {
          _vm.$set(item, _vm.addLanguageSuffix('title'), $$v)
        },
        expression: "item[addLanguageSuffix('title')]"
      }
    })], 1) : _vm._e(), _vm._v(" "), (item.item_type === 'link') ? _c('link-component', {
      key: item.key || item.id,
      attrs: {
        "errors": _vm.errors.items && _vm.errors.items[i] && _vm.errors.items[i]['link']
      },
      model: {
        value: (item.link),
        callback: function($$v) {
          _vm.$set(item, "link", $$v)
        },
        expression: "item.link"
      }
    }) : _vm._e()], 2)], 1)
  }), 0), _vm._v(" "), _c('el-button', {
    staticClass: "fluid",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addSection
    }
  }, [_vm._v("\n            Dodaj breadcrumb\n        ")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 711 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top",
      "effect": "light"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('img', {
    attrs: {
      "src": "/static/help/artistslist.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "info",
      "size": "mini"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  }), _vm._v(" Pomocnicze informacje dotyczące grafik\n            ")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tło (motyw)",
      "error": _vm.errors.image
    }
  }, [_c('image-input-component', {
    model: {
      value: (_vm.form.image),
      callback: function($$v) {
        _vm.$set(_vm.form, "image", $$v)
      },
      expression: "form.image"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Film w tle",
      "error": _vm.errors.background_video
    }
  }, [_c('file-input-component', {
    model: {
      value: (_vm.form.background_video),
      callback: function($$v) {
        _vm.$set(_vm.form, "background_video", $$v)
      },
      expression: "form.background_video"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "inline-form-group"
  }, [_c('edition-input', {
    attrs: {
      "errors": _vm.errors.edition,
      "required": true
    },
    model: {
      value: (_vm.form.edition),
      callback: function($$v) {
        _vm.$set(_vm.form, "edition", $$v)
      },
      expression: "form.edition"
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tagi",
      "error": _vm.errors.tags
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "multiple": "",
      "placeholder": "Tagi"
    },
    model: {
      value: (_vm.form.tags),
      callback: function($$v) {
        _vm.$set(_vm.form, "tags", $$v)
      },
      expression: "form.tags"
    }
  }, _vm._l((_vm.availableTags), function(tag) {
    return _c('el-option', {
      key: tag.id,
      attrs: {
        "label": tag.name,
        "value": tag.id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "inline-form-group"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Sortowanie alfabetyczne"
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.form.alphabetical_order),
      callback: function($$v) {
        _vm.$set(_vm.form, "alphabetical_order", $$v)
      },
      expression: "form.alphabetical_order"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Doładowuj"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "Limit na start"
    },
    model: {
      value: (_vm.form.page_size),
      callback: function($$v) {
        _vm.$set(_vm.form, "page_size", $$v)
      },
      expression: "form.page_size"
    }
  }), _vm._v(" "), _c('small', [_vm._v("Doładowywanie każdorazowo tyle elementów ile wynosi \"limit na start\"")])], 1)], 1), _vm._v(" "), _c('artists-preview', {
    attrs: {
      "form": _vm.form
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 712 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top",
      "effect": "light"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('img', {
    attrs: {
      "src": "/static/help/mobileapp.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "info",
      "size": "mini"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  }), _vm._v(" Pomocnicze informacje dotyczące grafik\n            ")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Kolor tła",
      "error": _vm.errors['bg_color']
    }
  }, [_c('el-color-picker', {
    model: {
      value: (_vm.form.bg_color),
      callback: function($$v) {
        _vm.$set(_vm.form, "bg_color", $$v)
      },
      expression: "form.bg_color"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Treść",
      "error": _vm.errors[_vm.addLanguageSuffix('content')]
    }
  }, [_c('wyswig-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('content')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('content'), $$v)
      },
      expression: "form[addLanguageSuffix('content')]"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Link iOS"
    }
  }, [_c('link-component', {
    attrs: {
      "errors": _vm.errors.ios_link
    },
    model: {
      value: (_vm.form.ios_link),
      callback: function($$v) {
        _vm.$set(_vm.form, "ios_link", $$v)
      },
      expression: "form.ios_link"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Link Android"
    }
  }, [_c('link-component', {
    attrs: {
      "errors": _vm.errors.android_link
    },
    model: {
      value: (_vm.form.android_link),
      callback: function($$v) {
        _vm.$set(_vm.form, "android_link", $$v)
      },
      expression: "form.android_link"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Lewe tło",
      "error": _vm.errors['left_image']
    }
  }, [_c('image-input-component', {
    model: {
      value: (_vm.form.left_image),
      callback: function($$v) {
        _vm.$set(_vm.form, "left_image", $$v)
      },
      expression: "form.left_image"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Prawe tło",
      "error": _vm.errors['right_image']
    }
  }, [_c('image-input-component', {
    model: {
      value: (_vm.form.right_image),
      callback: function($$v) {
        _vm.$set(_vm.form, "right_image", $$v)
      },
      expression: "form.right_image"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Zdjęcie telefonu",
      "error": _vm.errors['phone_image']
    }
  }, [_c('image-input-component', {
    model: {
      value: (_vm.form.phone_image),
      callback: function($$v) {
        _vm.$set(_vm.form, "phone_image", $$v)
      },
      expression: "form.phone_image"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 713 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "120px"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_c('span', {
    staticClass: "box__header--text"
  }, [_vm._v(_vm._s(_vm.getRouteName(_vm.$route)))]), _vm._v(" "), _c('form-language-switcher')], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nazwa formularza",
      "error": _vm.errors[_vm.addLanguageSuffix('name')],
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('name')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('name'), $$v)
      },
      expression: "form[addLanguageSuffix('name')]"
    }
  })], 1), _vm._v(" "), _c('edition-input', {
    attrs: {
      "errors": _vm.errors.edition
    },
    model: {
      value: (_vm.form.edition),
      callback: function($$v) {
        _vm.$set(_vm.form, "edition", $$v)
      },
      expression: "form.edition"
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Opis formularza",
      "error": _vm.errors[_vm.addLanguageSuffix('description')]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('description')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('description'), $$v)
      },
      expression: "form[addLanguageSuffix('description')]"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tekst podziękowania",
      "error": _vm.errors[_vm.addLanguageSuffix('thanks')]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('thanks')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('thanks'), $$v)
      },
      expression: "form[addLanguageSuffix('thanks')]"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Adres email, na który będą wysyłane powiadomienia",
      "error": _vm.errors.notifications_email
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.notifications_email),
      callback: function($$v) {
        _vm.$set(_vm.form, "notifications_email", $$v)
      },
      expression: "form.notifications_email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tekst na przycisku zatwierdzenia",
      "error": _vm.errors[_vm.addLanguageSuffix('button_text')]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('button_text')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('button_text'), $$v)
      },
      expression: "form[addLanguageSuffix('button_text')]"
    }
  })], 1), _vm._v(" "), (!_vm.form.id || _vm.form.formdata_set.length === 0) ? _c('div', [_c('sections', {
    attrs: {
      "sections": _vm.form.sections,
      "fieldTypes": _vm.fieldTypes,
      "errors": _vm.errors.sections || []
    },
    on: {
      "update:sections": function($event) {
        return _vm.$set(_vm.form, "sections", $event)
      }
    }
  })], 1) : _c('el-alert', {
    attrs: {
      "title": "Brak możliwości edycji sekcji",
      "type": "warning",
      "show-icon": ""
    }
  }, [_vm._v("\n                      Jeżeli formularz posiada już zgłoszenia nie można edytować jego pól.\n                    ")])], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('manage')) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form__buttons",
    attrs: {
      "label-width": "0"
    }
  }, [_c('router-link', {
    attrs: {
      "to": _vm.redirectRoute
    }
  }, [_c('el-button', {
    staticClass: "fluid form__button"
  }, [_vm._v(_vm._s(_vm.$t('cancel')))])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "fluid form__button",
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('submit')) + "\n                        ")])], 1)], 1)])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 714 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Zaznaczanie wielu",
      "error": _vm.errors['multiple']
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.form['multiple']),
      callback: function($$v) {
        _vm.$set(_vm.form, 'multiple', $$v)
      },
      expression: "form['multiple']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Opcje do wyboru",
      "required": ""
    }
  }, [_c('el-collapse', {
    staticClass: "formset__list"
  }, _vm._l((_vm.form.choices), function(choice, index) {
    return _c('div', [_c('div', {
      staticClass: "formset__header"
    }, [_c('span', [_c('el-form-item', {
      attrs: {
        "label": "",
        "error": _vm.errors.choices && _vm.errors.choices[index][_vm.addLanguageSuffix('label')],
        "required": ""
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "Nazwa opcji"
      },
      on: {
        "input": function($event) {
          return _vm.$forceUpdate()
        }
      },
      model: {
        value: (choice[_vm.addLanguageSuffix('label')]),
        callback: function($$v) {
          _vm.$set(choice, _vm.addLanguageSuffix('label'), $$v)
        },
        expression: "choice[addLanguageSuffix('label')]"
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "formset__header__buttons"
    }, [_c('el-button', {
      attrs: {
        "type": "danger",
        "size": "small",
        "title": "Usuń element"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.removeChoice(choice)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-remove"
    })])], 1)])])
  }), 0), _vm._v(" "), _c('el-button', {
    staticClass: "fluid",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addChoice
    }
  }, [_vm._v("\n            Dodaj opcję\n        ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 715 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),
/* 716 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', [_c('el-col', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "list__header"
  }, [_c('p', {
    staticClass: "list__title"
  }, [_vm._v("\n                    Zdjęcia w galerii\n                ")])]), _vm._v(" "), _c('el-upload', {
    staticClass: "upload",
    attrs: {
      "drag": "",
      "http-request": _vm.uploadImage,
      "action": "",
      "multiple": ""
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v("Przeciągnij plik tutaj lub "), _c('em', [_vm._v("kliknij aby dodać")])])]), _vm._v(" "), _c('el-table', {
    staticClass: "list__table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.images,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "id",
      "width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "zdjęcie"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "thumbnail",
          attrs: {
            "src": scope.row.thumbnail,
            "alt": scope.row.alt_pl
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "autor"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.imageDuringEdition(scope.row)) ? _c('el-input', {
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.duringEditing[scope.row.id].author),
            callback: function($$v) {
              _vm.$set(_vm.duringEditing[scope.row.id], "author", $$v)
            },
            expression: "duringEditing[scope.row.id].author"
          }
        }) : _vm._e(), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.imageDuringEdition(scope.row)),
            expression: "!imageDuringEdition(scope.row)"
          }]
        }, [_vm._v(_vm._s(scope.row.author))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "alt (pl)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.imageDuringEdition(scope.row)) ? _c('el-input', {
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.duringEditing[scope.row.id].alt_pl),
            callback: function($$v) {
              _vm.$set(_vm.duringEditing[scope.row.id], "alt_pl", $$v)
            },
            expression: "duringEditing[scope.row.id].alt_pl"
          }
        }) : _vm._e(), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.imageDuringEdition(scope.row)),
            expression: "!imageDuringEdition(scope.row)"
          }]
        }, [_vm._v(_vm._s(scope.row.alt_pl))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "alt (en)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.imageDuringEdition(scope.row)) ? _c('el-input', {
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.duringEditing[scope.row.id].alt_en),
            callback: function($$v) {
              _vm.$set(_vm.duringEditing[scope.row.id], "alt_en", $$v)
            },
            expression: "duringEditing[scope.row.id].alt_en"
          }
        }) : _vm._e(), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.imageDuringEdition(scope.row)),
            expression: "!imageDuringEdition(scope.row)"
          }]
        }, [_vm._v(_vm._s(scope.row.alt_en))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "pull-right",
    attrs: {
      "label": "opcje",
      "width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.imageDuringEdition(scope.row)),
            expression: "!imageDuringEdition(scope.row)"
          }],
          attrs: {
            "title": "Edytuj szczegóły zdjęcia",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.editImage(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        })]), _vm._v(" "), _c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.imageDuringEdition(scope.row)),
            expression: "imageDuringEdition(scope.row)"
          }],
          attrs: {
            "title": "Zatwierdź edycję",
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.submitEditedImage(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-check"
        })]), _vm._v(" "), (scope.$index !== _vm.images.length - 1) ? _c('el-button', {
          attrs: {
            "size": "small",
            "title": "Przesuń w dół"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.changeOrder(_vm.images, scope.$index, 1)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-arrow-down"
        })]) : _vm._e(), _vm._v(" "), _c('el-button', {
          style: ({
            opacity: scope.$index !== 0 ? 1 : 0
          }),
          attrs: {
            "size": "small",
            "title": "Przesuń do góry"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.changeOrder(_vm.images, scope.$index, -1)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-arrow-up"
        })]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small",
            "title": _vm.$t('delete')
          },
          on: {
            "click": function($event) {
              return _vm.removeItemFromFormset(_vm.images, scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        })])]
      }
    }])
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 717 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "120px"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_c('span', {
    staticClass: "box__header--text"
  }, [_vm._v(_vm._s(_vm.getRouteName(_vm.$route)))]), _vm._v(" "), _c('form-language-switcher')], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Rok",
      "error": _vm.errors['year'],
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form['year']),
      callback: function($$v) {
        _vm.$set(_vm.form, 'year', $$v)
      },
      expression: "form['year']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Obecna edycja"
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.form.current),
      callback: function($$v) {
        _vm.$set(_vm.form, "current", $$v)
      },
      expression: "form.current"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('manage')) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form__buttons",
    attrs: {
      "label-width": "0"
    }
  }, [_c('router-link', {
    attrs: {
      "to": _vm.redirectRoute
    }
  }, [_c('el-button', {
    staticClass: "fluid form__button"
  }, [_vm._v(_vm._s(_vm.$t('cancel')))])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "fluid form__button",
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('submit')) + "\n                        ")])], 1)], 1)])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 718 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formset__header",
    class: {
      'formset__header--errors': this.errors
    }
  }, [_c('span', [(_vm.errors) ? _c('i', {
    staticClass: "fa fa-warning"
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.label))]), _vm._v(" "), _c('div', {
    staticClass: "formset__header__buttons"
  }, [(_vm.index !== _vm.items.length - 1) ? _c('el-button', {
    attrs: {
      "size": "small",
      "title": "Przesuń w dół"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeOrder(_vm.items, _vm.index, 1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-down"
  })]) : _vm._e(), _vm._v(" "), _c('el-button', {
    style: ({
      opacity: _vm.index !== 0 ? 1 : 0
    }),
    attrs: {
      "size": "small",
      "title": "Przesuń do góry"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeOrder(_vm.items, _vm.index, -1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-up"
  })]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "size": "small",
      "title": "Usuń element"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.removeItemFromFormset(_vm.items, _vm.item)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  })])], 1)])
},staticRenderFns: []}

/***/ }),
/* 719 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "inline-form-group"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Wyświetlaj nazwę",
      "error": _vm.errors['display_name']
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.form['display_name']),
      callback: function($$v) {
        _vm.$set(_vm.form, 'display_name', $$v)
      },
      expression: "form['display_name']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nazwa",
      "error": _vm.errors[_vm.addLanguageSuffix('name')],
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Nazwa widgetu"
    },
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('name')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('name'), $$v)
      },
      expression: "form[addLanguageSuffix('name')]"
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 720 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    staticClass: "sidebar",
    attrs: {
      "span": 6
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Add CustomForm'
      }
    }
  }, [_c('el-button', {
    staticClass: "fluid",
    attrs: {
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('add')) + " Formularz "), _c('i', {
    staticClass: "el-icon-plus"
  })])], 1), _vm._v(" "), _c('ListFilterComponent', {
    attrs: {
      "selectedFilters": _vm.filters.selected,
      "listFilters": _vm.filters.available
    },
    on: {
      "setFilter": _vm.setFilter
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "box",
    attrs: {
      "span": 18
    }
  }, [_c('div', {
    staticClass: "list__header"
  }, [_c('p', {
    staticClass: "list__title"
  }, [_vm._v("\n          " + _vm._s(_vm.getRouteName(_vm.$route)) + "\n          "), _c('span', [_c('br'), _vm._v("Usunięcie formularza i edycja są możliwe tylko, jeśli nie ma żadnego wypełnionego formularza.")])]), _vm._v(" "), _c('search-list-form', {
    on: {
      "submit": _vm.fetchData
    },
    model: {
      value: (_vm.filters.selected.search),
      callback: function($$v) {
        _vm.$set(_vm.filters.selected, "search", $$v)
      },
      expression: "filters.selected.search"
    }
  })], 1), _vm._v(" "), _c('preview-dialog', {
    attrs: {
      "bus": _vm.bus
    },
    on: {
      "nextPreview": _vm.nextPreview,
      "previousPreview": _vm.previousPreview,
      "cancel": _vm.dialogCancelled,
      "submit": _vm.dialogSubmitted
    }
  }), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticClass: "list__table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.data,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return _vm._l((props.row.formdata_set), function(data, i) {
          return _c('p', [_c('span', {
            staticClass: "formdata-entry"
          }, [_vm._v("\n                                  " + _vm._s(i + 1) + ". " + _vm._s(data.timestamp) + "\n                              ")]), _vm._v(" "), _c('el-button', {
            attrs: {
              "size": "mini",
              "title": "Podgląd"
            },
            on: {
              "click": function($event) {
                return _vm.openDialog(data, props.row)
              }
            }
          }, [_vm._v("\n                Podgląd\n              ")])], 1)
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "id",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name_pl",
      "label": "nazwa (pl)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name_en",
      "label": "nazwa (en)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "liczba zgłoszeń"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.formdata_set.length) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "pull-right",
    attrs: {
      "label": "opcje",
      "width": "240"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.hasAnswers(scope.row)) ? _c('el-button', {
          attrs: {
            "size": "small",
            "loading": _vm.exportLoading,
            "title": "Eksportuj"
          },
          on: {
            "click": function($event) {
              return _vm.exportFormDataDialog(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-download"
        })]) : _vm._e(), _vm._v(" "), _c('router-link', {
          attrs: {
            "to": {
              name: 'Edit CustomForm',
              params: {
                id: scope.row.id
              }
            }
          }
        }, [_c('el-button', {
          attrs: {
            "size": "small",
            "title": _vm.$t('edit')
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        })])], 1), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "title": "Klonuj"
          },
          on: {
            "click": function($event) {
              return _vm.handleClone(scope.$index, scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-files-o"
        })]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small",
            "title": _vm.$t('delete')
          },
          on: {
            "click": function($event) {
              return _vm.handleDelete(scope.$index, scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        })])]
      }
    }])
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 721 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "120px"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_c('span', {
    staticClass: "box__header--text"
  }, [_vm._v(_vm._s(_vm.getRouteName(_vm.$route)))]), _vm._v(" "), _c('form-language-switcher')], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nazwa",
      "error": _vm.errors[_vm.addLanguageSuffix('name')],
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('name')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('name'), $$v)
      },
      expression: "form[addLanguageSuffix('name')]"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.$t('manage')) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form__buttons",
    attrs: {
      "label-width": "0"
    }
  }, [_c('router-link', {
    attrs: {
      "to": _vm.redirectRoute
    }
  }, [_c('el-button', {
    staticClass: "fluid form__button"
  }, [_vm._v(_vm._s(_vm.$t('cancel')))])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "fluid form__button",
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.$t('submit')) + "\n\t\t\t\t\t\t")])], 1)], 1)])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 722 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "list"
  }, _vm._l((_vm.availableLanguages), function(language) {
    return _c('li', {
      staticClass: "item",
      class: {
        'item--current': _vm.$store.state.currentFormLanguage === language.code
      },
      on: {
        "click": function($event) {
          return _vm.changeLanguage(language.code)
        }
      }
    }, [_c('img', {
      staticClass: "item__flag",
      attrs: {
        "src": language.flag,
        "alt": ""
      }
    }), _vm._v(" " + _vm._s(language.label) + "\n\t")])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 723 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "120px"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_c('span', {
    staticClass: "box__header--text"
  }, [_vm._v(_vm._s(_vm.getRouteName(_vm.$route)))]), _vm._v(" "), _c('form-language-switcher')], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nazwa",
      "error": _vm.errors[_vm.addLanguageSuffix('name')],
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('name')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('name'), $$v)
      },
      expression: "form[addLanguageSuffix('name')]"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Opis",
      "error": _vm.errors[_vm.addLanguageSuffix('description')]
    }
  }, [_c('wyswig-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('description')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('description'), $$v)
      },
      expression: "form[addLanguageSuffix('description')]"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Opis po rozwinięciu",
      "error": _vm.errors[_vm.addLanguageSuffix('details')]
    }
  }, [_c('wyswig-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('details')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('details'), $$v)
      },
      expression: "form[addLanguageSuffix('details')]"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Kolor tła",
      "error": _vm.errors['bg_color']
    }
  }, [_c('el-color-picker', {
    model: {
      value: (_vm.form.bg_color),
      callback: function($$v) {
        _vm.$set(_vm.form, "bg_color", $$v)
      },
      expression: "form.bg_color"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Kolor tekstu",
      "error": _vm.errors['text_color']
    }
  }, [_c('el-color-picker', {
    model: {
      value: (_vm.form.text_color),
      callback: function($$v) {
        _vm.$set(_vm.form, "text_color", $$v)
      },
      expression: "form.text_color"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_c('span', {
    staticClass: "box__header--text"
  }, [_vm._v("Bilety dostępne w")])]), _vm._v(" "), _vm._l((_vm.form.periods), function(period, i) {
    return _c('div', {
      staticClass: "ticket-in-periods"
    }, [_c('div', {
      staticClass: "inline-form-group"
    }, [_c('el-form-item', {
      attrs: {
        "label": "Okres sprzedaży",
        "error": _vm.errors.periods && _vm.errors.periods[i]['period_id']
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": "Wybierz okres"
      },
      model: {
        value: (period.period_id),
        callback: function($$v) {
          _vm.$set(period, "period_id", $$v)
        },
        expression: "period.period_id"
      }
    }, _vm._l((_vm.periods), function(option) {
      return _c('el-option', {
        key: option.id,
        attrs: {
          "label": option.name_pl,
          "value": option.id
        }
      })
    }), 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "ID w sklepie alter",
        "error": _vm.errors.periods && _vm.errors.periods[i]['external_id']
      }
    }, [_c('el-input', {
      model: {
        value: (period.external_id),
        callback: function($$v) {
          _vm.$set(period, "external_id", $$v)
        },
        expression: "period.external_id"
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "inline-form-group"
    }, [_c('el-form-item', {
      attrs: {
        "label": "Cena",
        "error": _vm.errors.periods && _vm.errors.periods[i]['price']
      }
    }, [_c('el-input', {
      attrs: {
        "type": "number"
      },
      model: {
        value: (period.price),
        callback: function($$v) {
          _vm.$set(period, "price", $$v)
        },
        expression: "period.price"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Limit jednorazowo",
        "error": _vm.errors.periods && _vm.errors.periods[i]['limit']
      }
    }, [_c('el-input', {
      attrs: {
        "type": "number"
      },
      model: {
        value: (period.limit),
        callback: function($$v) {
          _vm.$set(period, "limit", $$v)
        },
        expression: "period.limit"
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "inline-form-group"
    }, [_c('el-form-item', {
      attrs: {
        "label": "Kolejność (rosnąco)",
        "error": _vm.errors.periods && _vm.errors.periods[i]['order']
      }
    }, [_c('el-input', {
      attrs: {
        "type": "number"
      },
      model: {
        value: (period.order),
        callback: function($$v) {
          _vm.$set(period, "order", $$v)
        },
        expression: "period.order"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "sold-out-input",
      attrs: {
        "label": "Wyprzedany",
        "error": _vm.errors.periods && _vm.errors.periods[i]['sold_out']
      }
    }, [_c('el-switch', {
      model: {
        value: (period.sold_out),
        callback: function($$v) {
          _vm.$set(period, "sold_out", $$v)
        },
        expression: "period.sold_out"
      }
    })], 1)], 1), _vm._v(" "), _c('el-button', {
      staticClass: "remove-button",
      attrs: {
        "size": "mini",
        "icon": "el-icon-close",
        "type": "danger",
        "title": "Usuń"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.removeItemFromFormset(_vm.form.periods, period)
        }
      }
    })], 1)
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addPeriod
    }
  }, [_vm._v("\n                        Dodaj\n                    ")])], 2)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('manage')) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form__buttons",
    attrs: {
      "label-width": "0"
    }
  }, [_c('router-link', {
    attrs: {
      "to": _vm.redirectRoute
    }
  }, [_c('el-button', {
    staticClass: "fluid form__button"
  }, [_vm._v(_vm._s(_vm.$t('cancel')))])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "fluid form__button",
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('submit')) + "\n                        ")])], 1)], 1)])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 724 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-col', {
    staticClass: "header",
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    staticClass: "logo logo-width",
    attrs: {
      "span": 20
    }
  }), _vm._v(" "), _c('el-col', {
    staticClass: "userinfo",
    attrs: {
      "span": 4
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [(_vm.multiLanguage) ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.setLang()
      }
    }
  }, [_vm._v(_vm._s(_vm.langToChange))]) : _vm._e(), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.logout
    }
  }, [_vm._v(_vm._s(_vm.$t('logout')))])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 725 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "menu-expanded"
  }, [_c('el-menu', {
    attrs: {
      "default-active": _vm.$route.path,
      "unique-opened": "",
      "router": ""
    },
    on: {
      "open": _vm.handleOpen,
      "close": _vm.handleClose,
      "select": _vm.handleSelect
    }
  }, [_c('el-menu-item', {
    staticClass: "refresh-frontend",
    attrs: {
      "index": ""
    },
    on: {
      "click": _vm.refreshFrontend
    }
  }, [_c('i', {
    staticClass: "fa fa-save white"
  }), _vm._v(" Wprowadź zmiany\n        ")]), _vm._v(" "), _vm._l((_vm.availableRoutes), function(item, index) {
    return [(!item.leaf) ? _c('el-submenu', {
      attrs: {
        "index": index + ''
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: item.iconCls
    }), _vm._v(" "), _c('span', {
      staticClass: "menu__item"
    }, [_vm._v(_vm._s(_vm.getRouteName(item)))])]), _vm._v(" "), _vm._l((item.children), function(child) {
      return (!child.hidden) ? _c('el-menu-item', {
        key: _vm.getChildPath(item.path, child.path),
        staticClass: "menu__item",
        attrs: {
          "index": _vm.getChildPath(item.path, child.path)
        }
      }, [_vm._v("\n                    " + _vm._s(_vm.getRouteName(child)) + "\n                ")]) : _vm._e()
    })], 2) : _vm._e(), _vm._v(" "), (item.leaf && item.children.length > 0) ? _c('el-menu-item', {
      attrs: {
        "index": item.children[0].path
      }
    }, [_c('i', {
      class: item.iconCls
    }), _vm._v(_vm._s(item.children[0].name) + "\n            ")]) : _vm._e()]
  }), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": ""
    },
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "fa fa-unlock"
  }), _vm._v(" Wyloguj\n        ")])], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 726 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Nazwa sekcji",
      "error": _vm.errors[_vm.addLanguageSuffix('name')],
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.section[_vm.addLanguageSuffix('name')]),
      callback: function($$v) {
        _vm.$set(_vm.section, _vm.addLanguageSuffix('name'), $$v)
      },
      expression: "section[addLanguageSuffix('name')]"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "inline-form-group"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Nazwa widoczna dla użytkowników",
      "error": _vm.errors.display_name
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.section.display_name),
      callback: function($$v) {
        _vm.$set(_vm.section, "display_name", $$v)
      },
      expression: "section.display_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Zwielokrotniaj sekcję",
      "error": _vm.errors.multiply
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.section.multiply),
      callback: function($$v) {
        _vm.$set(_vm.section, "multiply", $$v)
      },
      expression: "section.multiply"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Odpowiedzi nie moga się powtarzać",
      "error": _vm.errors.unique_answers
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.section.unique_answers),
      callback: function($$v) {
        _vm.$set(_vm.section, "unique_answers", $$v)
      },
      expression: "section.unique_answers"
    }
  })], 1)], 1), _vm._v(" "), _c('fields-input', {
    attrs: {
      "fields": _vm.section.fields,
      "errors": _vm.errors.fields || []
    },
    on: {
      "update:fields": function($event) {
        return _vm.$set(_vm.section, "fields", $event)
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 727 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    staticClass: "sidebar",
    attrs: {
      "span": 6
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Add Stand'
      }
    }
  }, [_c('el-button', {
    staticClass: "fluid",
    attrs: {
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('add')) + " Stoisko "), _c('i', {
    staticClass: "el-icon-plus"
  })])], 1), _vm._v(" "), _c('ListFilterComponent', {
    attrs: {
      "selectedFilters": _vm.filters.selected,
      "listFilters": _vm.filters.available
    },
    on: {
      "setFilter": _vm.setFilter
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "box",
    attrs: {
      "span": 18
    }
  }, [_c('div', {
    staticClass: "list__header"
  }, [_c('p', {
    staticClass: "list__title"
  }, [_vm._v("\n                    " + _vm._s(_vm.getRouteName(_vm.$route)) + "\n                ")]), _vm._v(" "), _c('search-list-form', {
    on: {
      "submit": _vm.fetchData
    },
    model: {
      value: (_vm.filters.selected.search),
      callback: function($$v) {
        _vm.$set(_vm.filters.selected, "search", $$v)
      },
      expression: "filters.selected.search"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticClass: "list__table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.data,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "id",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name_pl",
      "label": "nazwa (pl)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name_en",
      "label": "nazwa (en)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "hide",
      "label": "ukryte"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.hide) ? _c('i', {
          staticClass: "el-icon-check"
        }) : _c('i', {
          staticClass: "el-icon-close"
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "pull-right",
    attrs: {
      "label": "opcje",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'Edit Stand',
              params: {
                id: scope.row.id
              }
            }
          }
        }, [_c('el-button', {
          attrs: {
            "size": "small",
            "title": _vm.$t('edit')
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        })])], 1), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small",
            "title": _vm.$t('delete')
          },
          on: {
            "click": function($event) {
              return _vm.handleDelete(scope.$index, scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        })])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "list__pagination",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.count
    },
    on: {
      "current-change": _vm.handlePageChange
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 728 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "120px"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_c('span', {
    staticClass: "box__header--text"
  }, [_vm._v(_vm._s(_vm.getRouteName(_vm.$route)))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Cena (zł)",
      "error": _vm.errors.price
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.form.price),
      callback: function($$v) {
        _vm.$set(_vm.form, "price", $$v)
      },
      expression: "form.price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Ilość dostępnych leżaków",
      "error": _vm.errors.quantity
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.form.quantity),
      callback: function($$v) {
        _vm.$set(_vm.form, "quantity", $$v)
      },
      expression: "form.quantity"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Minimalna ilość przy rezerwacji",
      "error": _vm.errors.min_to_book
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.form.min_to_book),
      callback: function($$v) {
        _vm.$set(_vm.form, "min_to_book", $$v)
      },
      expression: "form.min_to_book"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Maksymalna ilość przy rezerwacji",
      "error": _vm.errors.max_to_book
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.form.max_to_book),
      callback: function($$v) {
        _vm.$set(_vm.form, "max_to_book", $$v)
      },
      expression: "form.max_to_book"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Typ leżaka",
      "error": _vm.errors.type
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Typ leżaka",
      "clearable": ""
    },
    model: {
      value: (_vm.form.type),
      callback: function($$v) {
        _vm.$set(_vm.form, "type", $$v)
      },
      expression: "form.type"
    }
  }, _vm._l((_vm.loungerTypes), function(loungerType) {
    return _c('el-option', {
      key: loungerType.value,
      attrs: {
        "label": loungerType.label,
        "value": loungerType.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Data",
      "error": _vm.errors.date
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy/MM/dd",
      "value-format": "yyyy-MM-dd",
      "placeholder": "Data"
    },
    model: {
      value: (_vm.form.date),
      callback: function($$v) {
        _vm.$set(_vm.form, "date", $$v)
      },
      expression: "form.date"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('manage')) + "\n          ")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form__buttons",
    attrs: {
      "label-width": "0"
    }
  }, [_c('el-button', {
    staticClass: "fluid form__button",
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('submit')) + "\n            ")])], 1)], 1)])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 729 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tiles"
  }, [_c('el-collapse', {
    staticClass: "formset__list"
  }, _vm._l((_vm.form.tiles), function(tile, i) {
    return _c('div', {
      staticClass: "formset__item"
    }, [_c('el-collapse-item', {
      attrs: {
        "name": i
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('formset-header', {
      attrs: {
        "label": ("" + (tile.title_pl || 'Nowy kafel')),
        "items": _vm.form.tiles,
        "errors": _vm.checkForErrors(_vm.errors.tiles, [i]),
        "index": i
      },
      on: {
        "update:items": function($event) {
          return _vm.$set(_vm.form, "tiles", $event)
        }
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": ""
      }
    }, [_c('el-tooltip', {
      attrs: {
        "placement": "top",
        "effect": "light"
      }
    }, [_c('div', {
      attrs: {
        "slot": "content"
      },
      slot: "content"
    }, [_c('img', {
      attrs: {
        "src": "/static/help/tile.png",
        "alt": ""
      }
    })]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "info",
        "size": "mini"
      }
    }, [_c('i', {
      staticClass: "fa fa-question-circle"
    }), _vm._v(" Pomocnicze informacje dotyczące grafik\n                            ")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Tytuł",
        "error": _vm.errors.tiles && _vm.errors.tiles[i] && _vm.errors.tiles[i][_vm.addLanguageSuffix('title')]
      }
    }, [_c('el-input', {
      model: {
        value: (tile[_vm.addLanguageSuffix('title')]),
        callback: function($$v) {
          _vm.$set(tile, _vm.addLanguageSuffix('title'), $$v)
        },
        expression: "tile[addLanguageSuffix('title')]"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Kolor tła",
        "error": _vm.errors.tiles && _vm.errors.tiles[i] && _vm.errors.tiles[i]['bg_color']
      }
    }, [_c('el-color-picker', {
      model: {
        value: (tile.bg_color),
        callback: function($$v) {
          _vm.$set(tile, "bg_color", $$v)
        },
        expression: "tile.bg_color"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Kolor tekstu",
        "error": _vm.errors.tiles && _vm.errors.tiles[i] && _vm.errors.tiles[i]['text_color']
      }
    }, [_c('el-color-picker', {
      model: {
        value: (tile.text_color),
        callback: function($$v) {
          _vm.$set(tile, "text_color", $$v)
        },
        expression: "tile.text_color"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Zdjęcie",
        "error": _vm.errors.tiles && _vm.errors.tiles[i] && _vm.errors.tiles[i]['image']
      }
    }, [_c('image-input-component', {
      model: {
        value: (tile.image),
        callback: function($$v) {
          _vm.$set(tile, "image", $$v)
        },
        expression: "tile.image"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Przycisk"
      }
    }, [_c('link-component', {
      key: tile.key || tile.id,
      attrs: {
        "errors": _vm.errors.tiles && _vm.errors.tiles[i] && _vm.errors.tiles[i]['link']
      },
      model: {
        value: (tile.link),
        callback: function($$v) {
          _vm.$set(tile, "link", $$v)
        },
        expression: "tile.link"
      }
    })], 1)], 2)], 1)
  }), 0), _vm._v(" "), _c('el-button', {
    staticClass: "fluid",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addSection
    }
  }, [_vm._v("\n            Dodaj kafel\n        ")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 730 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "inline-form-group"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Wymagane",
      "error": _vm.errors['required']
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.form['required']),
      callback: function($$v) {
        _vm.$set(_vm.form, 'required', $$v)
      },
      expression: "form['required']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Pole od krawędzi do krawędzi",
      "error": _vm.errors.full_width
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.form.full_width),
      callback: function($$v) {
        _vm.$set(_vm.form, "full_width", $$v)
      },
      expression: "form.full_width"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "inline-form-group"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Nazwa pola",
      "error": _vm.errors[_vm.addLanguageSuffix('label')],
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "Nazwa pola"
    },
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('label')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('label'), $$v)
      },
      expression: "form[addLanguageSuffix('label')]"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Placeholder",
      "error": _vm.errors[_vm.addLanguageSuffix('placeholder')]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Placeholder"
    },
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('placeholder')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('placeholder'), $$v)
      },
      expression: "form[addLanguageSuffix('placeholder')]"
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 731 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "120px"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_c('span', {
    staticClass: "box__header--text"
  }, [_vm._v(_vm._s(_vm.getRouteName(_vm.$route)))]), _vm._v(" "), _c('form-language-switcher')], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Maksymalnie zapisów na jeden adres email",
      "error": _vm.errors['registration_per_email_limit']
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.form['registration_per_email_limit']),
      callback: function($$v) {
        _vm.$set(_vm.form, 'registration_per_email_limit', $$v)
      },
      expression: "form['registration_per_email_limit']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Zapisy otwarte"
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.form.registration_open),
      callback: function($$v) {
        _vm.$set(_vm.form, "registration_open", $$v)
      },
      expression: "form.registration_open"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nagłowek w wiadomości email"
    }
  }, [_c('image-input-component', {
    model: {
      value: (_vm.form.email_header_image),
      callback: function($$v) {
        _vm.$set(_vm.form, "email_header_image", $$v)
      },
      expression: "form.email_header_image"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('manage')) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form__buttons",
    attrs: {
      "label-width": "0"
    }
  }, [_c('el-button', {
    staticClass: "fluid form__button",
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('submit')) + "\n                        ")])], 1)], 1)])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 732 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Tekst",
      "required": "",
      "error": _vm.errors[_vm.addLanguageSuffix('text')]
    }
  }, [_c('wyswig-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('text')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('text'), $$v)
      },
      expression: "form[addLanguageSuffix('text')]"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "slides"
  }, [_c('el-collapse', {
    staticClass: "formset__list"
  }, _vm._l((_vm.form.slides), function(slide, i) {
    return _c('div', {
      staticClass: "formset__item"
    }, [_c('el-collapse-item', {
      attrs: {
        "name": i
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('formset-header', {
      attrs: {
        "label": ("" + (slide.title_pl || 'Slajd')),
        "errors": _vm.checkForErrors(_vm.errors.slides, [i]),
        "items": _vm.form.slides,
        "index": i
      },
      on: {
        "update:items": function($event) {
          return _vm.$set(_vm.form, "slides", $event)
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "inline-form-group"
    }, [_c('el-form-item', {
      attrs: {
        "label": "Zdjęcie",
        "error": _vm.errors.slides && _vm.errors.slides[i] && _vm.errors.slides[i]['photo']
      }
    }, [_c('image-input-component', {
      model: {
        value: (slide.photo),
        callback: function($$v) {
          _vm.$set(slide, "photo", $$v)
        },
        expression: "slide.photo"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Kolor tekstu",
        "error": _vm.errors.slides && _vm.errors.slides[i] && _vm.errors.slides[i]['text_color']
      }
    }, [_c('el-color-picker', {
      model: {
        value: (slide.text_color),
        callback: function($$v) {
          _vm.$set(slide, "text_color", $$v)
        },
        expression: "slide.text_color"
      }
    })], 1)], 1)], 2)], 1)
  }), 0), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.addSection
    }
  }, [_vm._v("Dodaj slajd")]), _vm._v(" "), (typeof _vm.errors.slides === 'string') ? _c('div', {
    staticClass: "el-form-item__error"
  }, [_vm._v("\n            " + _vm._s(_vm.errors.slides) + "\n        ")]) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 733 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    staticClass: "sidebar",
    attrs: {
      "span": 6
    }
  }, [_c('ListFilterComponent', {
    attrs: {
      "allowDeselect": false,
      "selectedFilters": _vm.filters.selected,
      "listFilters": _vm.filters.available
    },
    on: {
      "setFilter": _vm.setFilter
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "box",
    attrs: {
      "span": 18
    }
  }, [_c('div', {
    staticClass: "list__header"
  }, [_c('p', {
    staticClass: "list__title"
  }, [_vm._v("\n                    " + _vm._s(_vm.getRouteName(_vm.$route)) + "\n                    "), _c('br'), _vm._v(" "), _c('small', [_vm._v("Złap i przeciągnij")]), _vm._v(" "), _c('el-button', {
    staticClass: "alphabetically-sort-button",
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.sortAlphabetically
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-alpha-asc"
  }), _vm._v(" Przesortuj alfabetycznie\n                    ")])], 1)]), _vm._v(" "), _c('el-card', {
    staticClass: "box-card new-order-box",
    class: {
      'new-order-box--visible': _vm.newOrder
    }
  }, [_c('p', [_vm._v("Kolejność została zmieniona")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.submitOrder
    }
  }, [_vm._v("Zapisz nową kolejność")])], 1), _vm._v(" "), _c('ul', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticClass: "list"
  }, [_c('draggable', {
    attrs: {
      "options": {}
    },
    on: {
      "start": function($event) {
        _vm.drag = true
      },
      "end": _vm.orderChanged
    },
    model: {
      value: (_vm.data),
      callback: function($$v) {
        _vm.data = $$v
      },
      expression: "data"
    }
  }, [_c('transition-group', _vm._l((_vm.data), function(item) {
    return _c('li', {
      key: item.id,
      staticClass: "item"
    }, [_c('span', {
      staticClass: "item__name"
    }, [_vm._v(_vm._s(item.name_pl))]), _vm._v(" "), _c('span', {
      staticClass: "item__icon"
    }, [_c('i', {
      staticClass: "fa fa-align-justify"
    })])])
  }), 0)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 734 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    staticClass: "sidebar",
    attrs: {
      "span": 6
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Add Ticket'
      }
    }
  }, [_c('el-button', {
    staticClass: "fluid",
    attrs: {
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('add')) + " Bilet "), _c('i', {
    staticClass: "el-icon-plus"
  })])], 1), _vm._v(" "), _c('ListFilterComponent', {
    attrs: {
      "selectedFilters": _vm.filters.selected,
      "listFilters": _vm.filters.available
    },
    on: {
      "setFilter": _vm.setFilter
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "box",
    attrs: {
      "span": 18
    }
  }, [_c('div', {
    staticClass: "list__header"
  }, [_c('p', {
    staticClass: "list__title"
  }, [_vm._v("\n                    " + _vm._s(_vm.getRouteName(_vm.$route)) + "\n                ")]), _vm._v(" "), _c('search-list-form', {
    on: {
      "submit": _vm.fetchData
    },
    model: {
      value: (_vm.filters.selected.search),
      callback: function($$v) {
        _vm.$set(_vm.filters.selected, "search", $$v)
      },
      expression: "filters.selected.search"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticClass: "list__table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.data,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "id",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name_pl",
      "label": "nazwa (pl)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name_en",
      "label": "nazwa (en)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "pull-right",
    attrs: {
      "label": "opcje",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'Edit Ticket',
              params: {
                id: scope.row.id
              }
            }
          }
        }, [_c('el-button', {
          attrs: {
            "size": "small",
            "title": _vm.$t('edit')
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        })])], 1), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small",
            "title": _vm.$t('delete')
          },
          on: {
            "click": function($event) {
              return _vm.handleDelete(scope.$index, scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        })])]
      }
    }])
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 735 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "clickoutside",
      rawName: "v-clickoutside",
      value: (_vm.hide),
      expression: "hide"
    }],
    class: [
      'el-color-picker',
      _vm.colorDisabled ? 'is-disabled' : '',
      _vm.colorSize ? ("el-color-picker--" + _vm.colorSize) : ''
    ]
  }, [(_vm.colorDisabled) ? _c('div', {
    staticClass: "el-color-picker__mask"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "el-color-picker__trigger",
    on: {
      "click": _vm.handleTrigger
    }
  }, [_c('span', {
    staticClass: "el-color-picker__color",
    class: {
      'is-alpha': _vm.showAlpha
    }
  }, [_c('span', {
    staticClass: "el-color-picker__color-inner",
    style: ({
      backgroundColor: _vm.displayedColor
    })
  }), _vm._v(" "), (!_vm.value && !_vm.showPanelColor) ? _c('span', {
    staticClass: "el-color-picker__empty el-icon-close"
  }) : _vm._e()]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value || _vm.showPanelColor),
      expression: "value || showPanelColor"
    }],
    staticClass: "el-color-picker__icon el-icon-arrow-down"
  })]), _vm._v(" "), _c('picker-dropdown', {
    ref: "dropdown",
    class: ['el-color-picker__panel', _vm.popperClass || ''],
    attrs: {
      "color": _vm.color,
      "show-alpha": _vm.showAlpha,
      "predefine": _vm.predefine
    },
    on: {
      "pick": _vm.confirmValue,
      "clear": _vm.clearValue
    },
    model: {
      value: (_vm.showPicker),
      callback: function($$v) {
        _vm.showPicker = $$v
      },
      expression: "showPicker"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "picker"
  }, [_c('strong', [_vm._v("\n            Przekopiuj bazowy kolor:\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "samples"
  }, _vm._l((_vm.$store.state.colors), function(color) {
    return _c('div', {
      staticClass: "sample",
      on: {
        "click": function($event) {
          return _vm.copyColor(color.color)
        }
      }
    }, [_c('span', {
      staticClass: "sample__box",
      style: ({
        background: color.color
      })
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(color.name))])])
  }), 0)])])
},staticRenderFns: []}

/***/ }),
/* 736 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    staticClass: "box",
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "list__header"
  }, [_c('p', {
    staticClass: "list__title"
  }, [_vm._v("\n          " + _vm._s(_vm.getRouteName(_vm.$route)) + "\n        ")]), _vm._v(" "), _c('search-list-form', {
    on: {
      "submit": _vm.fetchData
    },
    model: {
      value: (_vm.filters.selected.search),
      callback: function($$v) {
        _vm.$set(_vm.filters.selected, "search", $$v)
      },
      expression: "filters.selected.search"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticClass: "list__table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.data,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-table', {
          staticClass: "list__table",
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": props.row.registrations
          }
        }, [_c('el-table-column', {
          attrs: {
            "prop": "id",
            "label": "id",
            "width": "80"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "email",
            "label": "email"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "imię i nazwisko"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "date_of_birth",
            "label": "data ur.",
            "width": "100"
          }
        }), _vm._v(" "), _c('el-table-column', {
          staticClass: "pull-right",
          attrs: {
            "label": "akcje",
            "width": "150"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('el-button', {
                attrs: {
                  "type": "danger",
                  "size": "small",
                  "title": "Usuń tę rezerwację"
                },
                on: {
                  "click": function($event) {
                    return _vm.handleDelete(scope.$index, scope.row, props.row.registrations)
                  }
                }
              }, [_c('i', {
                staticClass: "el-icon-delete"
              })])]
            }
          }], null, true)
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "id",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "event",
      "label": "wydarzenie"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "date",
      "label": "data"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "hour_from",
      "label": "godzina"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "registered_number",
      "label": "zapisanych"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "number_of_seats",
      "label": "liczba miejsc"
    }
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "pull-right",
    attrs: {
      "label": "opcje",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "title": "Eksportuj"
          },
          on: {
            "click": function($event) {
              return _vm.downloadCSV(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-download"
        })])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "list__pagination",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.count
    },
    on: {
      "current-change": _vm.handlePageChange
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 737 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    staticClass: "sidebar",
    attrs: {
      "span": 6
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Add Page'
      }
    }
  }, [_c('el-button', {
    staticClass: "fluid",
    attrs: {
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('add')) + " Podstronę "), _c('i', {
    staticClass: "el-icon-plus"
  })])], 1), _vm._v(" "), _c('ListFilterComponent', {
    attrs: {
      "selectedFilters": _vm.filters.selected,
      "listFilters": _vm.filters.available
    },
    on: {
      "setFilter": _vm.setFilter
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "box",
    attrs: {
      "span": 18
    }
  }, [_c('div', {
    staticClass: "list__header"
  }, [_c('p', {
    staticClass: "list__title"
  }, [_vm._v("\n                    " + _vm._s(_vm.getRouteName(_vm.$route)) + "\n                ")]), _vm._v(" "), _c('search-list-form', {
    on: {
      "submit": _vm.fetchData
    },
    model: {
      value: (_vm.filters.selected.search),
      callback: function($$v) {
        _vm.$set(_vm.filters.selected, "search", $$v)
      },
      expression: "filters.selected.search"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticClass: "list__table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.data,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "id",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name_pl",
      "label": "nazwa (pl)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name_en",
      "label": "nazwa (en)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "hide",
      "label": "ukryte"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.hide) ? _c('i', {
          staticClass: "el-icon-check"
        }) : _c('i', {
          staticClass: "el-icon-close"
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "slug",
      "label": "slug"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(scope.row.slug) + "\n                        "), _c('i', {
          staticClass: "edit-slug el-icon-edit",
          on: {
            "click": function($event) {
              return _vm.editSlug(scope.row, 'pl')
            }
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "slug",
      "label": "slug (en)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(scope.row.slug_en) + "\n                        "), _c('i', {
          staticClass: "edit-slug el-icon-edit",
          on: {
            "click": function($event) {
              return _vm.editSlug(scope.row, 'en')
            }
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "pull-right",
    attrs: {
      "label": "akcje",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'Edit Page',
              params: {
                slug: scope.row.slug
              }
            }
          }
        }, [_c('el-button', {
          attrs: {
            "size": "small",
            "title": _vm.$t('edit')
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        })])], 1), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small",
            "title": _vm.$t('delete')
          },
          on: {
            "click": function($event) {
              return _vm.handleDelete(scope.$index, scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        })])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "list__pagination",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.count
    },
    on: {
      "current-change": _vm.handlePageChange
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 738 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": "Szczegóły pola",
      "before-close": _vm.handleClose,
      "visible": _vm.dialogFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "language-switcher"
  }, [_c('form-language-switcher')], 1), _vm._v(" "), _c('el-form', {
    attrs: {
      "model": _vm.formCopy,
      "label-width": "100px"
    }
  }, [(_vm.formCopy.resourcetype !== 'TextField') ? _c('base-field', {
    attrs: {
      "form": _vm.formCopy,
      "errors": _vm.errors
    },
    on: {
      "update:form": function($event) {
        _vm.formCopy = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), _c(_vm.fieldComponent, {
    tag: "component",
    attrs: {
      "form": _vm.formCopy,
      "errors": _vm.errors
    },
    on: {
      "update:form": function($event) {
        _vm.formCopy = $event
      }
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.cancelForm()
      }
    }
  }, [_vm._v("Anuluj")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  }, [_vm._v("Zatwierdź\n            ")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 739 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "drop",
    on: {
      "dragover": function($event) {
        $event.preventDefault();
      },
      "drop": _vm.onDrop
    }
  }, [(!_vm.value) ? _c('label', {
    staticClass: "btn display-inline"
  }, [_vm._v("\n            PRZECIĄGNIJ I UPUŚĆ, LUB\n            "), _c('input', {
    attrs: {
      "type": "file",
      "name": "value"
    },
    on: {
      "change": _vm.onChange
    }
  })]) : _c('div', {
    staticClass: "hidden",
    class: {
      'value': true
    }
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.value
    }
  }, [_vm._v(_vm._s(_vm.value) + "\n            ")]), _vm._v(" "), (_vm.value) ? _c('el-button', {
    staticClass: "remove-button",
    attrs: {
      "size": "mini",
      "icon": "el-icon-delete",
      "type": "danger",
      "title": "Usuń plik"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.removeFile($event)
      }
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: []}

/***/ }),
/* 740 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('photos-dialog', {
    attrs: {
      "bus": _vm.bus
    },
    on: {
      "submit": _vm.dialogSubmitted
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "drop",
    on: {
      "dragover": function($event) {
        $event.preventDefault();
      },
      "drop": _vm.onDrop
    }
  }, [(!_vm.value) ? _c('label', {
    staticClass: "btn display-inline"
  }, [_vm._v("\n            PRZECIĄGNIJ I UPUŚĆ, LUB\n            "), _c('input', {
    attrs: {
      "type": "file",
      "name": "value"
    },
    on: {
      "change": _vm.onChange
    }
  })]) : _c('div', {
    staticClass: "hidden",
    class: {
      'value': true
    }
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": _vm.value,
      "alt": ""
    }
  }), _vm._v(" "), (_vm.value) ? _c('el-button', {
    staticClass: "remove-button",
    attrs: {
      "size": "mini",
      "icon": "el-icon-delete",
      "type": "danger",
      "title": "Usuń zdjęcie"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.removeImage($event)
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('el-button', {
    staticClass: "open-dialog-button",
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.openDialog
    }
  }, [_c('i', {
    staticClass: "fa fa-file-image-o"
  }), _vm._v(" Wybierz z istniejących\n    ")])], 1)
},staticRenderFns: []}

/***/ }),
/* 741 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('edition-input', {
    attrs: {
      "errors": _vm.errors.edition,
      "required": true
    },
    model: {
      value: (_vm.form.edition),
      callback: function($$v) {
        _vm.$set(_vm.form, "edition", $$v)
      },
      expression: "form.edition"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "images"
  }, [_vm._m(0), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tytuł",
      "error": _vm.errors[_vm.addLanguageSuffix('left_title')]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('left_title')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('left_title'), $$v)
      },
      expression: "form[addLanguageSuffix('left_title')]"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Kategoria",
      "error": _vm.errors['left_category']
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Kategoria"
    },
    model: {
      value: (_vm.form.left_category),
      callback: function($$v) {
        _vm.$set(_vm.form, "left_category", $$v)
      },
      expression: "form.left_category"
    }
  }, _vm._l((_vm.categories), function(category) {
    return _c('el-option', {
      key: category.id,
      attrs: {
        "label": category.name_pl,
        "value": category.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nazwa przycisku",
      "error": _vm.errors[_vm.addLanguageSuffix('left_button_title')]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('left_button_title')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('left_button_title'), $$v)
      },
      expression: "form[addLanguageSuffix('left_button_title')]"
    }
  })], 1), _vm._v(" "), _c('link-component', {
    attrs: {
      "errors": _vm.errors.left_link
    },
    model: {
      value: (_vm.form.left_link),
      callback: function($$v) {
        _vm.$set(_vm.form, "left_link", $$v)
      },
      expression: "form.left_link"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "images"
  }, [_vm._m(1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tytuł",
      "error": _vm.errors[_vm.addLanguageSuffix('right_title')]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('right_title')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('right_title'), $$v)
      },
      expression: "form[addLanguageSuffix('right_title')]"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Kategoria",
      "error": _vm.errors['right_category']
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Kategoria"
    },
    model: {
      value: (_vm.form.right_category),
      callback: function($$v) {
        _vm.$set(_vm.form, "right_category", $$v)
      },
      expression: "form.right_category"
    }
  }, _vm._l((_vm.categories), function(category) {
    return _c('el-option', {
      key: category.id,
      attrs: {
        "label": category.name_pl,
        "value": category.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nazwa przycisku",
      "error": _vm.errors[_vm.addLanguageSuffix('right_button_title')]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('right_button_title')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('right_button_title'), $$v)
      },
      expression: "form[addLanguageSuffix('right_button_title')]"
    }
  })], 1), _vm._v(" "), _c('link-component', {
    attrs: {
      "errors": _vm.errors.right_link
    },
    model: {
      value: (_vm.form.right_link),
      callback: function($$v) {
        _vm.$set(_vm.form, "right_link", $$v)
      },
      expression: "form.right_link"
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box__header"
  }, [_c('span', {
    staticClass: "box__header--text"
  }, [_vm._v("Lewa kolumna")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box__header"
  }, [_c('span', {
    staticClass: "box__header--text"
  }, [_vm._v("Prawa kolumna")])])
}]}

/***/ }),
/* 742 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "120px"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_c('span', {
    staticClass: "box__header--text"
  }, [_vm._v(_vm._s(_vm.getRouteName(_vm.$route)))]), _vm._v(" "), _c('form-language-switcher')], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nazwa",
      "error": _vm.errors[_vm.addLanguageSuffix('name')],
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('name')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('name'), $$v)
      },
      expression: "form[addLanguageSuffix('name')]"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Opis",
      "error": _vm.errors[_vm.addLanguageSuffix('description')]
    }
  }, [_c('wyswig-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('description')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('description'), $$v)
      },
      expression: "form[addLanguageSuffix('description')]"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Data rozpoczęcia",
      "error": _vm.errors.start_date
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy/MM/dd",
      "value-format": "yyyy-MM-dd",
      "placeholder": "Data rozpoczecia sprzedaży"
    },
    model: {
      value: (_vm.form.start_date),
      callback: function($$v) {
        _vm.$set(_vm.form, "start_date", $$v)
      },
      expression: "form.start_date"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Data zakończenia",
      "error": _vm.errors.end_date
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy/MM/dd",
      "value-format": "yyyy-MM-dd",
      "placeholder": "Data rozpoczecia sprzedaży"
    },
    model: {
      value: (_vm.form.end_date),
      callback: function($$v) {
        _vm.$set(_vm.form, "end_date", $$v)
      },
      expression: "form.end_date"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Sold out"
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.form.sold_out),
      callback: function($$v) {
        _vm.$set(_vm.form, "sold_out", $$v)
      },
      expression: "form.sold_out"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('manage')) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form__buttons",
    attrs: {
      "label-width": "0"
    }
  }, [_c('router-link', {
    attrs: {
      "to": _vm.redirectRoute
    }
  }, [_c('el-button', {
    staticClass: "fluid form__button"
  }, [_vm._v(_vm._s(_vm.$t('cancel')))])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "fluid form__button",
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('submit')) + "\n                        ")])], 1)], 1)])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 743 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "120px"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_c('span', {
    staticClass: "box__header--text"
  }, [_vm._v(_vm._s(_vm.getRouteName(_vm.$route)))]), _vm._v(" "), _c('form-language-switcher')], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nazwa sceny",
      "error": _vm.errors[_vm.addLanguageSuffix('name')],
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('name')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('name'), $$v)
      },
      expression: "form[addLanguageSuffix('name')]"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.$t('manage')) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form__buttons",
    attrs: {
      "label-width": "0"
    }
  }, [_c('router-link', {
    attrs: {
      "to": _vm.redirectRoute
    }
  }, [_c('el-button', {
    staticClass: "fluid form__button"
  }, [_vm._v(_vm._s(_vm.$t('cancel')))])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "fluid form__button",
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.$t('submit')) + "\n\t\t\t\t\t\t")])], 1)], 1)])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 744 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Typ pola"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "Wybierz pole"
    },
    model: {
      value: (_vm.form.field_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "field_type", $$v)
      },
      expression: "form.field_type"
    }
  }, _vm._l((_vm.charFieldTypes), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 745 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top",
      "effect": "light"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('img', {
    attrs: {
      "src": "/static/help/newsletter.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "info",
      "size": "mini"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  }), _vm._v(" Pomocnicze informacje dotyczące grafik\n            ")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Kolor tła",
      "error": _vm.errors['bg_color']
    }
  }, [_c('el-color-picker', {
    model: {
      value: (_vm.form.bg_color),
      callback: function($$v) {
        _vm.$set(_vm.form, "bg_color", $$v)
      },
      expression: "form.bg_color"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Kolor tekstu",
      "error": _vm.errors['text_color']
    }
  }, [_c('el-color-picker', {
    model: {
      value: (_vm.form.text_color),
      callback: function($$v) {
        _vm.$set(_vm.form, "text_color", $$v)
      },
      expression: "form.text_color"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Lewy obrazek",
      "error": _vm.errors['left_image']
    }
  }, [_c('image-input-component', {
    model: {
      value: (_vm.form.left_image),
      callback: function($$v) {
        _vm.$set(_vm.form, "left_image", $$v)
      },
      expression: "form.left_image"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Prawy obrazek",
      "error": _vm.errors['right_image']
    }
  }, [_c('image-input-component', {
    model: {
      value: (_vm.form.right_image),
      callback: function($$v) {
        _vm.$set(_vm.form, "right_image", $$v)
      },
      expression: "form.right_image"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Opis",
      "error": _vm.errors[_vm.addLanguageSuffix('description')]
    }
  }, [_c('wyswig-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('description')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('description'), $$v)
      },
      expression: "form[addLanguageSuffix('description')]"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 746 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Podgląd")]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, _vm._l((_vm.data.artists), function(artist) {
    return _c('li', {
      staticClass: "item"
    }, [_vm._v("\n            " + _vm._s(artist.name) + "\n        ")])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 747 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    staticClass: "box",
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "list__header"
  }, [_c('p', {
    staticClass: "list__title"
  }, [_vm._v("\n                    " + _vm._s(_vm.getRouteName(_vm.$route)) + "\n                ")]), _vm._v(" "), _c('search-list-form', {
    on: {
      "submit": _vm.fetchData
    },
    model: {
      value: (_vm.filters.selected.search),
      callback: function($$v) {
        _vm.$set(_vm.filters.selected, "search", $$v)
      },
      expression: "filters.selected.search"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticClass: "list__table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.data,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "file",
      "label": "url"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "180",
      "label": "data"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm.formatDate(scope.row.timestamp)) + "\n                    ")]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "list__pagination",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.count
    },
    on: {
      "current-change": _vm.handlePageChange
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 748 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('widget-dialog', {
    attrs: {
      "bus": _vm.bus
    },
    on: {
      "cancel": _vm.dialogCancelled,
      "submit": _vm.dialogSubmitted
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "widgets"
  }, [_c('ul', {
    staticClass: "widgets__list"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.widgets.length === 0),
      expression: "widgets.length === 0"
    }],
    staticClass: "widgets__list--empty"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.lessDetails),
      expression: "!lessDetails"
    }]
  }, [_vm._v("\n                        Zawsze w szczegółach wyświetla się zdjęcie i opis. Wykorzystaj widgety, by dodać więcej informacji."), _c('br')]), _vm._v("\n                    Wybierz widget z listy po prawej stronie.\n                ")]), _vm._v(" "), _vm._l((_vm.widgets), function(widget, i) {
    return _c('li', {
      staticClass: "widget",
      class: {
        'widget--error': _vm.errors[i] && Object.keys(_vm.errors[i]).length > 0
      },
      on: {
        "click": function($event) {
          return _vm.editWidget(widget, _vm.errors[i])
        }
      }
    }, [_c('div', {
      staticClass: "buttons"
    }, [(i !== _vm.widgets.length - 1) ? _c('el-button', {
      attrs: {
        "size": "small",
        "title": "Przesuń w dół"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.changeOrder(_vm.widgets, i, 1)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-arrow-down"
    })]) : _vm._e(), _vm._v(" "), _c('el-button', {
      style: ({
        opacity: i !== 0 ? 1 : 0
      }),
      attrs: {
        "size": "small",
        "title": "Przesuń do góry"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.changeOrder(_vm.widgets, i, -1)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-arrow-up"
    })]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "danger",
        "size": "small"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.removeWidget(widget, i)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-remove"
    })])], 1), _vm._v(" "), _c('strong', [_vm._v(_vm._s(widget.name_pl || 'Widget bez nazwy'))]), _c('br'), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.getLabel(widget.resourcetype)))])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "types"
  }, [_c('ul', {
    staticClass: "types__list"
  }, _vm._l((_vm.$store.state.idBasedWidgetTypes), function(type, key) {
    return _c('li', {
      staticClass: "type",
      on: {
        "click": function($event) {
          return _vm.addWidget(type)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus-circle"
    }), _vm._v("\n                    " + _vm._s(type.label) + "\n                    "), _c('div', [_c('img', {
      staticClass: "widget__icon",
      attrs: {
        "src": ("/static/widgets/icons/" + (type.resourcetype) + ".png"),
        "alt": ""
      },
      on: {
        "error": function($event) {
          return _vm.iconLoadError(type.resourcetype)
        }
      }
    })])])
  }), 0)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 749 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Tekst",
      "error": _vm.errors[_vm.addLanguageSuffix('text')]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('text')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('text'), $$v)
      },
      expression: "form[addLanguageSuffix('text')]"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 750 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('strong', [_vm._v("Oryginalne zdjęcie")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "file-upload-form"
  }, [_c('image-input-component', {
    attrs: {
      "value": _vm.photo
    },
    on: {
      "input": _vm.onImageChange
    }
  })], 1)]), _vm._v(" "), _vm._l((_vm.croppers), function(cropper) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.photo),
        expression: "photo"
      }],
      staticClass: "cropper-wrapper"
    }, [_c('strong', [_vm._v(_vm._s(cropper.label))]), _vm._v(" "), (_vm.errors && _vm.errors[cropper.paramsFieldName]) ? _c('p', {
      staticClass: "errors"
    }, [_vm._v("\n            " + _vm._s(_vm.errors[cropper.paramsFieldName]) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('img', {
      attrs: {
        "id": cropper.id,
        "src": _vm.photo,
        "alt": ""
      }
    })])
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 751 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Formularz",
      "required": "",
      "error": _vm.errors['form']
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Wybierz formularz"
    },
    model: {
      value: (_vm.form.form),
      callback: function($$v) {
        _vm.$set(_vm.form, "form", $$v)
      },
      expression: "form.form"
    }
  }, _vm._l((_vm.forms), function(folder) {
    return _c('el-option', {
      key: folder.id,
      attrs: {
        "label": folder.name_pl,
        "value": folder.id
      }
    })
  }), 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 752 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('el-collapse', {
    staticClass: "formset__list"
  }, _vm._l((_vm.sections), function(section, i) {
    return _c('div', {
      staticClass: "formset__item"
    }, [_c('el-collapse-item', {
      attrs: {
        "name": i
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('formset-header', {
      attrs: {
        "label": ("" + (section.name_pl || 'Nowa sekcja')),
        "items": _vm.sections,
        "errors": _vm.checkForErrors(_vm.errors, [i]),
        "index": i
      },
      on: {
        "update:items": function($event) {
          _vm.sections = $event
        }
      }
    })], 1), _vm._v(" "), _c('section-form', {
      attrs: {
        "section": section,
        "fieldTypes": _vm.fieldTypes,
        "errors": _vm.errors[i] || {}
      },
      on: {
        "update:section": function($event) {
          section = $event
        }
      }
    })], 2)], 1)
  }), 0), _vm._v(" "), _c('el-button', {
    staticClass: "fluid",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addSection
    }
  }, [_vm._v("\n        dodaj sekcję\n    ")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box__header"
  }, [_c('span', {
    staticClass: "box__header--text"
  }, [_vm._v("\n            Sekcje formularza\n        ")])])
}]}

/***/ }),
/* 753 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    staticClass: "box",
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "list__header"
  }, [_c('p', {
    staticClass: "list__title"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.getRouteName(_vm.$route)) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('div', [_c('search-list-form', {
    on: {
      "submit": _vm.fetchData
    },
    model: {
      value: (_vm.filters.selected.search),
      callback: function($$v) {
        _vm.$set(_vm.filters.selected, "search", $$v)
      },
      expression: "filters.selected.search"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "title": "Oznacz jako opłacone"
    },
    on: {
      "click": _vm.downloadCSV
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }, [_vm._v(" Export CSV")])])], 1)]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticClass: "list__table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.data,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "Id",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "lounger.type_display",
      "label": "Typ"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "lounger.date",
      "label": "Data"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price_display",
      "label": "Cena (zł)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "buyer.first_name",
      "label": "Imię"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "buyer.last_name",
      "label": "Nazwisko"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "buyer.phone",
      "label": "Telefon"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "buyer.email",
      "label": "Email"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "payment_status",
      "label": "Status płatności"
    }
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "pull-right",
    attrs: {
      "label": "opcje",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "title": "Oznacz jako opłacone"
          },
          on: {
            "click": function($event) {
              return _vm.mark_as_paid(scope.row.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-check"
        }, [_vm._v(" Opłacone")])])]
      }
    }])
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 754 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "page-container"
  }, [_vm._v("404 page not found")])
},staticRenderFns: []}

/***/ }),
/* 755 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    staticClass: "sidebar",
    attrs: {
      "span": 6
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Add Gallery'
      }
    }
  }, [_c('el-button', {
    staticClass: "fluid",
    attrs: {
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('add')) + " Galerię "), _c('i', {
    staticClass: "el-icon-plus"
  })])], 1), _vm._v(" "), _c('ListFilterComponent', {
    attrs: {
      "selectedFilters": _vm.filters.selected,
      "listFilters": _vm.filters.available
    },
    on: {
      "setFilter": _vm.setFilter
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "box",
    attrs: {
      "span": 18
    }
  }, [_c('div', {
    staticClass: "list__header"
  }, [_c('p', {
    staticClass: "list__title"
  }, [_vm._v("\n                    " + _vm._s(_vm.getRouteName(_vm.$route)) + "\n                ")]), _vm._v(" "), _c('search-list-form', {
    on: {
      "submit": _vm.fetchData
    },
    model: {
      value: (_vm.filters.selected.search),
      callback: function($$v) {
        _vm.$set(_vm.filters.selected, "search", $$v)
      },
      expression: "filters.selected.search"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticClass: "list__table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.data,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "id",
      "width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "nazwa (pl)",
      "prop": "name_pl"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "edycja"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm.getEditionLabel(scope.row.edition)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "podgląd",
      "width": "340"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.images.slice(0, 3)), function(image) {
          return _c('img', {
            staticClass: "thumbnail",
            attrs: {
              "src": image.thumbnail,
              "alt": image.alt_pl
            }
          })
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "pull-right",
    attrs: {
      "label": "opcje",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'Edit Gallery',
              params: {
                id: scope.row.id
              }
            }
          }
        }, [_c('el-button', {
          attrs: {
            "size": "small",
            "title": _vm.$t('edit')
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        })])], 1), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small",
            "title": _vm.$t('delete')
          },
          on: {
            "click": function($event) {
              return _vm.handleDelete(scope.$index, scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        })])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "list__pagination",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.count
    },
    on: {
      "current-change": _vm.handlePageChange
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 756 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "boxes"
  }, [_c('el-collapse', {
    staticClass: "formset__list"
  }, _vm._l((_vm.form.boxes), function(box, i) {
    return _c('div', {
      staticClass: "formset__item"
    }, [_c('el-collapse-item', {
      attrs: {
        "name": i
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('formset-header', {
      attrs: {
        "label": ("" + (box.title_pl || 'Nowy box')),
        "errors": _vm.checkForErrors(_vm.errors.boxes, [i]),
        "items": _vm.form.boxes,
        "index": i
      },
      on: {
        "update:items": function($event) {
          return _vm.$set(_vm.form, "boxes", $event)
        }
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Tytuł",
        "error": _vm.errors.boxes && _vm.errors.boxes[i] && _vm.errors.boxes[i]['title']
      }
    }, [_c('el-input', {
      model: {
        value: (box[_vm.addLanguageSuffix('title')]),
        callback: function($$v) {
          _vm.$set(box, _vm.addLanguageSuffix('title'), $$v)
        },
        expression: "box[addLanguageSuffix('title')]"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Opis",
        "error": _vm.errors.boxes && _vm.errors.boxes[i] && _vm.errors.boxes[i]['description']
      }
    }, [_c('wyswig-input', {
      attrs: {
        "simple": ""
      },
      model: {
        value: (box[_vm.addLanguageSuffix('description')]),
        callback: function($$v) {
          _vm.$set(box, _vm.addLanguageSuffix('description'), $$v)
        },
        expression: "box[addLanguageSuffix('description')]"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": ""
      }
    }, [_c('el-tooltip', {
      attrs: {
        "placement": "top",
        "effect": "light"
      }
    }, [_c('div', {
      attrs: {
        "slot": "content"
      },
      slot: "content"
    }, [_c('img', {
      attrs: {
        "src": "/static/help/boxes.png",
        "alt": ""
      }
    })]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "info",
        "size": "mini"
      }
    }, [_c('i', {
      staticClass: "fa fa-question-circle"
    }), _vm._v(" Pomocnicze informacje dotyczące grafik\n                            ")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Grafika (motyw)",
        "error": _vm.errors.boxes && _vm.errors.boxes[i] && _vm.errors.boxes[i]['image']
      }
    }, [_c('image-input-component', {
      model: {
        value: (box.image),
        callback: function($$v) {
          _vm.$set(box, "image", $$v)
        },
        expression: "box.image"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Zdjęcie",
        "error": _vm.errors.boxes && _vm.errors.boxes[i] && _vm.errors.boxes[i]['photo']
      }
    }, [_c('image-input-component', {
      model: {
        value: (box.photo),
        callback: function($$v) {
          _vm.$set(box, "photo", $$v)
        },
        expression: "box.photo"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Kolor tła",
        "error": _vm.errors.boxes && _vm.errors.boxes[i] && _vm.errors.boxes[i]['bg_color']
      }
    }, [_c('el-color-picker', {
      model: {
        value: (box.bg_color),
        callback: function($$v) {
          _vm.$set(box, "bg_color", $$v)
        },
        expression: "box.bg_color"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Kolor tekstu",
        "error": _vm.errors.boxes && _vm.errors.boxes[i] && _vm.errors.boxes[i]['text_color']
      }
    }, [_c('el-color-picker', {
      model: {
        value: (box.text_color),
        callback: function($$v) {
          _vm.$set(box, "text_color", $$v)
        },
        expression: "box.text_color"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Przycisk"
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "Nazwa",
        "error": _vm.errors.boxes && _vm.errors.boxes[i] && _vm.errors.boxes[i]['button_title']
      }
    }, [_c('el-input', {
      model: {
        value: (box[_vm.addLanguageSuffix('button_title')]),
        callback: function($$v) {
          _vm.$set(box, _vm.addLanguageSuffix('button_title'), $$v)
        },
        expression: "box[addLanguageSuffix('button_title')]"
      }
    })], 1), _vm._v(" "), _c('link-component', {
      key: box.key || box.id,
      attrs: {
        "errors": _vm.errors.boxes && _vm.errors.boxes[i] && _vm.errors.boxes[i]['button_link']
      },
      model: {
        value: (box.button_link),
        callback: function($$v) {
          _vm.$set(box, "button_link", $$v)
        },
        expression: "box.button_link"
      }
    })], 1)], 2)], 1)
  }), 0), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.addSection
    }
  }, [_vm._v("+ box")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 757 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    staticClass: "sidebar",
    attrs: {
      "span": 6
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Add News'
      }
    }
  }, [_c('el-button', {
    staticClass: "fluid",
    attrs: {
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('add')) + " News "), _c('i', {
    staticClass: "el-icon-plus"
  })])], 1), _vm._v(" "), _c('ListFilterComponent', {
    attrs: {
      "selectedFilters": _vm.filters.selected,
      "listFilters": _vm.filters.available
    },
    on: {
      "setFilter": _vm.setFilter
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "box",
    attrs: {
      "span": 18
    }
  }, [_c('div', {
    staticClass: "list__header"
  }, [_c('p', {
    staticClass: "list__title"
  }, [_vm._v("\n                    " + _vm._s(_vm.getRouteName(_vm.$route)) + "\n                ")]), _vm._v(" "), _c('search-list-form', {
    on: {
      "submit": _vm.fetchData
    },
    model: {
      value: (_vm.filters.selected.search),
      callback: function($$v) {
        _vm.$set(_vm.filters.selected, "search", $$v)
      },
      expression: "filters.selected.search"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticClass: "list__table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.data,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "id",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "title_pl",
      "label": "tytuł (pl)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "title_en",
      "label": "tytuł (en)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "hide",
      "label": "ukryte"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.hide) ? _c('i', {
          staticClass: "el-icon-check"
        }) : _c('i', {
          staticClass: "el-icon-close"
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "slug",
      "label": "slug"
    }
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "pull-right",
    attrs: {
      "label": "akcje",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'Edit News',
              params: {
                id: scope.row.id
              }
            }
          }
        }, [_c('el-button', {
          attrs: {
            "size": "small",
            "title": _vm.$t('edit')
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        })])], 1), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small",
            "title": _vm.$t('delete')
          },
          on: {
            "click": function($event) {
              return _vm.handleDelete(scope.$index, scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        })])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "list__pagination",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.count
    },
    on: {
      "current-change": _vm.handleNewsChange
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 758 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": "Szczegóły widgetu",
      "before-close": _vm.handleClose,
      "width": "80vw",
      "visible": _vm.dialogFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "language-switcher"
  }, [_c('form-language-switcher')], 1), _vm._v(" "), _c('el-form', {
    attrs: {
      "model": _vm.formCopy,
      "label-width": "100px"
    }
  }, [(_vm.widgetType.global) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Widget"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Wybierz widget"
    },
    on: {
      "change": _vm.globalWidgetSet
    },
    model: {
      value: (_vm.formCopy.id),
      callback: function($$v) {
        _vm.$set(_vm.formCopy, "id", $$v)
      },
      expression: "formCopy.id"
    }
  }, _vm._l((_vm.availableWidgets), function(widget) {
    return _c('el-option', {
      key: widget.id,
      attrs: {
        "label": widget.name_pl,
        "value": widget.id
      }
    })
  }), 1)], 1)], 1) : _c('div', [_c('base-widget', {
    attrs: {
      "form": _vm.formCopy,
      "errors": _vm.errors
    },
    on: {
      "update:form": function($event) {
        _vm.formCopy = $event
      }
    }
  }), _vm._v(" "), _c(_vm.widgetComponent, {
    tag: "component",
    attrs: {
      "form": _vm.formCopy,
      "errors": _vm.errors
    },
    on: {
      "update:form": function($event) {
        _vm.formCopy = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.cancelForm()
      }
    }
  }, [_vm._v("Anuluj")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  }, [_vm._v("Zatwierdź\n            ")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 759 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "inline-form-group"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Wyświetl filtry",
      "error": _vm.errors['show_filter_bar']
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.form.show_filter_bar),
      callback: function($$v) {
        _vm.$set(_vm.form, "show_filter_bar", $$v)
      },
      expression: "form.show_filter_bar"
    }
  })], 1)], 1), _vm._v(" "), _c('el-collapse', {
    staticClass: "formset__list"
  }, _vm._l((_vm.form.sections), function(section, i) {
    return _c('div', {
      staticClass: "formset__item"
    }, [_c('el-collapse-item', {
      attrs: {
        "name": i
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('formset-header', {
      attrs: {
        "label": ("" + (_vm.getCategoryName(section.category) || 'Nowa sekcja')),
        "items": _vm.form.sections,
        "errors": _vm.checkForErrors(_vm.errors.sections, [i]),
        "index": i
      },
      on: {
        "update:items": function($event) {
          return _vm.$set(_vm.form, "sections", $event)
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "inline-form-group"
    }, [_c('el-form-item', {
      attrs: {
        "label": "Kolor tła",
        "error": _vm.errors.sections && _vm.errors.sections[i]['bg_color']
      }
    }, [_c('el-color-picker', {
      model: {
        value: (section.bg_color),
        callback: function($$v) {
          _vm.$set(section, "bg_color", $$v)
        },
        expression: "section.bg_color"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Kolor tekstu",
        "error": _vm.errors.sections && _vm.errors.sections[i]['text_color']
      }
    }, [_c('el-color-picker', {
      model: {
        value: (section.text_color),
        callback: function($$v) {
          _vm.$set(section, "text_color", $$v)
        },
        expression: "section.text_color"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Wyświetlaj pasek filtrów",
        "error": _vm.errors.sections && _vm.errors.sections[i]['show_tags_bar']
      }
    }, [_c('el-switch', {
      model: {
        value: (section.show_tags_bar),
        callback: function($$v) {
          _vm.$set(section, "show_tags_bar", $$v)
        },
        expression: "section.show_tags_bar"
      }
    })], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Edycja",
        "error": _vm.errors.sections && _vm.errors.sections[i]['edition'],
        "required": ""
      }
    }, [_c('el-select', {
      attrs: {
        "filterable": "",
        "placeholder": "Edycja"
      },
      model: {
        value: (section.edition),
        callback: function($$v) {
          _vm.$set(section, "edition", $$v)
        },
        expression: "section.edition"
      }
    }, _vm._l((_vm.$store.state.editions), function(edition) {
      return _c('el-option', {
        key: edition.id,
        attrs: {
          "label": edition.year,
          "value": edition.id
        }
      })
    }), 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Kategoria",
        "error": _vm.errors.sections && _vm.errors.sections[i]['category']
      }
    }, [_c('el-select', {
      staticClass: "fluid",
      attrs: {
        "filterable": "",
        "placeholder": "Kategoria"
      },
      model: {
        value: (section.category),
        callback: function($$v) {
          _vm.$set(section, "category", $$v)
        },
        expression: "section.category"
      }
    }, _vm._l((_vm.categories), function(item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "label": item.name_pl,
          "value": item.id
        }
      })
    }), 1)], 1)], 2)], 1)
  }), 0), _vm._v(" "), _c('el-button', {
    staticClass: "fluid",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addSection
    }
  }, [_vm._v("\n        Dodaj sekcję\n    ")])], 1)
},staticRenderFns: []}

/***/ }),
/* 760 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Tytuł",
      "error": _vm.errors[_vm.addLanguageSuffix('label')]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.item[_vm.addLanguageSuffix('label')]),
      callback: function($$v) {
        _vm.$set(_vm.item, _vm.addLanguageSuffix('label'), $$v)
      },
      expression: "item[addLanguageSuffix('label')]"
    }
  })], 1), _vm._v(" "), (_vm.allow_submenu) ? _c('el-form-item', {
    attrs: {
      "label": "Dodaj menu rozwijane"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "Menu rozwijane",
      "value": !(!!_vm.item.link)
    },
    on: {
      "change": function($event) {
        return _vm.changeMenuItemType(_vm.item)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.item.link) ? _c('link-component', {
    attrs: {
      "errors": _vm.errors['link']
    },
    model: {
      value: (_vm.item.link),
      callback: function($$v) {
        _vm.$set(_vm.item, "link", $$v)
      },
      expression: "item.link"
    }
  }) : _c('div', [_c('el-collapse', {
    staticClass: "formset__list"
  }, _vm._l((_vm.item.submenu), function(subitem, i) {
    return _c('el-collapse-item', {
      key: i,
      staticClass: "formset__item formset__item--nested"
    }, [_c('template', {
      slot: "title"
    }, [_c('formset-header', {
      attrs: {
        "label": ("" + (subitem.label_pl || 'Nowy element podmenu')),
        "errors": _vm.checkForErrors(_vm.errors.submenu, [i]),
        "items": _vm.item.submenu,
        "index": i
      },
      on: {
        "update:items": function($event) {
          return _vm.$set(_vm.item, "submenu", $event)
        }
      }
    })], 1), _vm._v(" "), _c('submenu-item', {
      attrs: {
        "itemKey": subitem.id || subitem.randomHash,
        "errors": (_vm.errors.submenu && _vm.errors.submenu[i]) || {},
        "item": subitem
      },
      on: {
        "update:item": function($event) {
          subitem = $event
        }
      }
    })], 2)
  }), 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.addSubmenuItem
    }
  }, [_vm._v("Dodaj pozycję w submenu")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 761 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    staticClass: "sidebar",
    attrs: {
      "span": 6
    }
  }, [_c('ListFilterComponent', {
    attrs: {
      "selectedFilters": _vm.filters.selected,
      "listFilters": _vm.filters.available
    },
    on: {
      "setFilter": _vm.setFilter
    }
  }), _vm._v(" "), _vm._l((_vm.types), function(values, type) {
    return _c('router-link', {
      key: type,
      staticClass: "add-buttons",
      attrs: {
        "to": {
          name: 'Add Widget',
          params: {
            type: type
          }
        }
      }
    }, [_c('el-button', {
      staticClass: "fluid",
      attrs: {
        "type": "primary"
      }
    }, [_vm._v("widget " + _vm._s(values && values.label) + " "), _c('i', {
      staticClass: "el-icon-plus"
    })])], 1)
  })], 2), _vm._v(" "), _c('el-col', {
    staticClass: "box",
    attrs: {
      "span": 18
    }
  }, [_c('div', {
    staticClass: "list__header"
  }, [_c('p', {
    staticClass: "list__title"
  }, [_vm._v("\n                    " + _vm._s(_vm.getRouteName(_vm.$route)) + "\n                ")]), _vm._v(" "), _c('search-list-form', {
    on: {
      "submit": _vm.fetchData
    },
    model: {
      value: (_vm.filters.selected.search),
      callback: function($$v) {
        _vm.$set(_vm.filters.selected, "search", $$v)
      },
      expression: "filters.selected.search"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticClass: "list__table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.data,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "id",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "typ"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm.types[scope.row.resourcetype] && _vm.types[scope.row.resourcetype].label) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "working_name",
      "label": "tytuł rob."
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name_pl",
      "label": "nazwa (pl)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name_en",
      "label": "nazwa (en)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "pull-right",
    attrs: {
      "label": "opcje",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'Edit Widget',
              params: {
                id: scope.row.id
              }
            }
          }
        }, [_c('el-button', {
          attrs: {
            "size": "small",
            "title": _vm.$t('edit')
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        })])], 1), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small",
            "title": _vm.$t('delete')
          },
          on: {
            "click": function($event) {
              return _vm.handleDelete(scope.$index, scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        })])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "list__pagination",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.count
    },
    on: {
      "current-change": _vm.handlePageChange
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 762 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('field-dialog', {
    attrs: {
      "bus": _vm.bus
    },
    on: {
      "cancel": _vm.dialogCancelled,
      "submit": _vm.dialogSubmitted
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "fields"
  }, [_c('ul', {
    staticClass: "fields__list"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fields.length === 0),
      expression: "fields.length === 0"
    }],
    staticClass: "fields__list--empty"
  }, [_vm._v("\n                    Wybierz pole po prawej stronie.\n                ")]), _vm._v(" "), _vm._l((_vm.fields), function(field, i) {
    return _c('li', {
      staticClass: "field",
      class: {
        'field--error': _vm.errors[i] && Object.keys(_vm.errors[i]).length > 0
      },
      on: {
        "click": function($event) {
          return _vm.editField(field, _vm.errors[i])
        }
      }
    }, [_c('div', {
      staticClass: "buttons"
    }, [(i !== _vm.fields.length - 1) ? _c('el-button', {
      attrs: {
        "size": "small",
        "title": "Przesuń w dół"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.changeOrder(_vm.fields, i, 1)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-arrow-down"
    })]) : _vm._e(), _vm._v(" "), _c('el-button', {
      style: ({
        opacity: i !== 0 ? 1 : 0
      }),
      attrs: {
        "size": "small",
        "title": "Przesuń do góry"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.changeOrder(_vm.fields, i, -1)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-arrow-up"
    })]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "danger",
        "size": "small"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.removeField(field, i)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-remove"
    })])], 1), _vm._v(" "), _c('strong', [_vm._v(_vm._s(field.text_pl || field.label_pl || 'Pusta nazwa'))]), _c('br'), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.getLabel(field.resourcetype)))])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "types"
  }, [_c('ul', {
    staticClass: "types__list"
  }, _vm._l((_vm.$store.state.fieldTypes), function(type, key) {
    return _c('li', {
      staticClass: "type",
      on: {
        "click": function($event) {
          return _vm.addField(key)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus-circle"
    }), _vm._v(" " + _vm._s(type.label) + "\n                ")])
  }), 0)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box__header"
  }, [_c('span', {
    staticClass: "box__header--text"
  }, [_vm._v("\n            Pola formularza\n        ")])])
}]}

/***/ }),
/* 763 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Treść lewej kolumny",
      "error": _vm.errors[_vm.addLanguageSuffix('title')]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('title')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('title'), $$v)
      },
      expression: "form[addLanguageSuffix('title')]"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Treść środkowej kolumny",
      "error": _vm.errors[_vm.addLanguageSuffix('content')]
    }
  }, [_c('wyswig-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('content')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('content'), $$v)
      },
      expression: "form[addLanguageSuffix('content')]"
    }
  })], 1), _vm._v(" "), _c('edition-input', {
    attrs: {
      "errors": _vm.errors.edition,
      "clearable": true,
      "required": true
    },
    model: {
      value: (_vm.form.edition),
      callback: function($$v) {
        _vm.$set(_vm.form, "edition", $$v)
      },
      expression: "form.edition"
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Rodzaj wydarzenia",
      "required": "",
      "error": _vm.errors['event_type']
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Wybierz typ wydarzenia"
    },
    model: {
      value: (_vm.form.event_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "event_type", $$v)
      },
      expression: "form.event_type"
    }
  }, _vm._l((_vm.types), function(type) {
    return _c('el-option', {
      key: type,
      attrs: {
        "label": _vm.translateType(type),
        "value": type
      }
    })
  }), 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 764 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.listFilters), function(entry) {
    return _c('div', {
      staticClass: "list-filter"
    }, [_c('p', {
      staticClass: "list-filter-title"
    }, [_vm._v(_vm._s(entry.name))]), _vm._v(" "), _c('ul', {
      staticClass: "list-filter-list"
    }, _vm._l((entry.options), function(option) {
      return _c('li', {
        staticClass: "list-filter-item",
        class: {
          'list-filter-item--active': _vm.activeOption(entry, option)
        },
        on: {
          "click": function($event) {
            return _vm.setFilter(entry, option)
          }
        }
      }, [(option.icon) ? _c('i', {
        staticClass: "list-filter-icon",
        class: option.icon
      }) : _vm._e(), _vm._v("\n                " + _vm._s(option.label) + "\n            ")])
    }), 0)])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 765 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Pokaż pasek filtrowania"
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.form.show_filter_bar),
      callback: function($$v) {
        _vm.$set(_vm.form, "show_filter_bar", $$v)
      },
      expression: "form.show_filter_bar"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "sections"
  }, [_c('el-collapse', {
    staticClass: "formset__list"
  }, _vm._l((_vm.form.sections), function(section, i) {
    return _c('div', {
      staticClass: "formset__item"
    }, [_c('el-collapse-item', {
      attrs: {
        "name": i
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('formset-header', {
      attrs: {
        "label": section.title_pl || 'Nowa sekcja',
        "items": _vm.form.sections,
        "errors": _vm.checkForErrors(_vm.errors.sections, [i]),
        "index": i
      },
      on: {
        "update:items": function($event) {
          return _vm.$set(_vm.form, "sections", $event)
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "inline-form-group"
    }, [_c('el-form-item', {
      attrs: {
        "label": "Tytuł",
        "error": _vm.errors.sections && _vm.errors.sections[i] && _vm.errors.sections[i][_vm.addLanguageSuffix('title')]
      }
    }, [_c('el-input', {
      model: {
        value: (section[_vm.addLanguageSuffix('title')]),
        callback: function($$v) {
          _vm.$set(section, _vm.addLanguageSuffix('title'), $$v)
        },
        expression: "section[addLanguageSuffix('title')]"
      }
    })], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Galerie (kolejność względem dodawania)",
        "error": _vm.errors.sections && _vm.errors.sections[i] && _vm.errors.sections[i]['galleries']
      }
    }, [_c('el-select', {
      attrs: {
        "multiple": "",
        "placeholder": "Wybierz galerie"
      },
      model: {
        value: (section.galleries),
        callback: function($$v) {
          _vm.$set(section, "galleries", $$v)
        },
        expression: "section.galleries"
      }
    }, _vm._l((_vm.groupedGalleries), function(group) {
      return _c('el-option-group', {
        key: group.label,
        attrs: {
          "label": group.label
        }
      }, _vm._l((group.options), function(item) {
        return _c('el-option', {
          key: item.id,
          attrs: {
            "label": item.name_pl,
            "value": item.id
          }
        })
      }), 1)
    }), 1)], 1)], 2)], 1)
  }), 0), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.addSection
    }
  }, [_vm._v("+ sekcja")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 766 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    staticClass: "sidebar",
    attrs: {
      "span": 6
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Add Color'
      }
    }
  }, [_c('el-button', {
    staticClass: "fluid",
    attrs: {
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('add')) + " Kolor "), _c('i', {
    staticClass: "el-icon-plus"
  })])], 1), _vm._v(" "), _c('ListFilterComponent', {
    attrs: {
      "selectedFilters": _vm.filters.selected,
      "listFilters": _vm.filters.available
    },
    on: {
      "setFilter": _vm.setFilter
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "box",
    attrs: {
      "span": 18
    }
  }, [_c('div', {
    staticClass: "list__header"
  }, [_c('p', {
    staticClass: "list__title"
  }, [_vm._v("\n                    " + _vm._s(_vm.getRouteName(_vm.$route)) + "\n                ")])]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticClass: "list__table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.data,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "id",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "nazwa"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "color",
      "label": "kolor"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          style: ({
            color: scope.row.color
          })
        }, [_vm._v("Lorem ipsum dolor ...")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "pull-right",
    attrs: {
      "label": "opcje",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'Edit Color',
              params: {
                id: scope.row.id
              }
            }
          }
        }, [_c('el-button', {
          attrs: {
            "size": "small",
            "title": _vm.$t('edit')
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        })])], 1), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small",
            "title": _vm.$t('delete')
          },
          on: {
            "click": function($event) {
              return _vm.handleDelete(scope.$index, scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        })])]
      }
    }])
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 767 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    staticClass: "sidebar",
    attrs: {
      "span": 6
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Add Popup'
      }
    }
  }, [_c('el-button', {
    staticClass: "fluid",
    attrs: {
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('add')) + " Popup "), _c('i', {
    staticClass: "el-icon-plus"
  })])], 1), _vm._v(" "), _c('ListFilterComponent', {
    attrs: {
      "selectedFilters": _vm.filters.selected,
      "listFilters": _vm.filters.available
    },
    on: {
      "setFilter": _vm.setFilter
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "box",
    attrs: {
      "span": 18
    }
  }, [_c('div', {
    staticClass: "list__header"
  }, [_c('p', {
    staticClass: "list__title"
  }, [_vm._v("\n                    " + _vm._s(_vm.getRouteName(_vm.$route)) + "\n                ")]), _vm._v(" "), _c('search-list-form', {
    on: {
      "submit": _vm.fetchData
    },
    model: {
      value: (_vm.filters.selected.search),
      callback: function($$v) {
        _vm.$set(_vm.filters.selected, "search", $$v)
      },
      expression: "filters.selected.search"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticClass: "list__table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.data,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "id",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "working_name",
      "label": "tytuł roboczy"
    }
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "pull-right",
    attrs: {
      "label": "opcje",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'Edit Popup',
              params: {
                id: scope.row.id
              }
            }
          }
        }, [_c('el-button', {
          attrs: {
            "size": "small",
            "title": _vm.$t('edit')
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        })])], 1), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small",
            "title": _vm.$t('delete')
          },
          on: {
            "click": function($event) {
              return _vm.handleDelete(scope.$index, scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        })])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "list__pagination",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.count
    },
    on: {
      "current-change": _vm.handlePageChange
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 768 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    staticClass: "sidebar",
    attrs: {
      "span": 6
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Add Lounger'
      }
    }
  }, [_c('el-button', {
    staticClass: "fluid",
    attrs: {
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('add')) + " Leżak "), _c('i', {
    staticClass: "el-icon-plus"
  })])], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "box",
    attrs: {
      "span": 18
    }
  }, [_c('div', {
    staticClass: "list__header"
  }, [_c('p', {
    staticClass: "list__title"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.getRouteName(_vm.$route)) + "\n\t\t\t\t\t")])]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticClass: "list__table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.data,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "id",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type_display",
      "label": "typ"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "date",
      "label": "data"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price_display",
      "label": "cena (zł)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "label": "ilość"
    }
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "pull-right",
    attrs: {
      "label": "opcje",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'Edit Lounger',
              params: {
                id: scope.row.id
              }
            }
          }
        }, [_c('el-button', {
          attrs: {
            "size": "small",
            "title": _vm.$t('edit')
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        })])], 1)]
      }
    }])
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 769 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "120px"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_c('span', {
    staticClass: "box__header--text"
  }, [_vm._v(_vm._s(_vm.getRouteName(_vm.$route)))]), _vm._v(" "), _c('form-language-switcher')], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nazwa galerii",
      "error": _vm.errors[_vm.addLanguageSuffix('name')],
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('name')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('name'), $$v)
      },
      expression: "form[addLanguageSuffix('name')]"
    }
  })], 1), _vm._v(" "), _c('edition-input', {
    attrs: {
      "errors": _vm.errors.edition,
      "required": true
    },
    model: {
      value: (_vm.form.edition),
      callback: function($$v) {
        _vm.$set(_vm.form, "edition", $$v)
      },
      expression: "form.edition"
    }
  })], 1), _vm._v(" "), _c('gallery-images', {
    attrs: {
      "images": _vm.form.images
    },
    on: {
      "update:images": function($event) {
        return _vm.$set(_vm.form, "images", $event)
      }
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('manage')) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form__buttons",
    attrs: {
      "label-width": "0"
    }
  }, [_c('router-link', {
    attrs: {
      "to": _vm.redirectRoute
    }
  }, [_c('el-button', {
    staticClass: "fluid form__button"
  }, [_vm._v(_vm._s(_vm.$t('cancel')))])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "fluid form__button",
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('submit')) + "\n                        ")])], 1)], 1)])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 770 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Pokaż pasek filtrowania"
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.form.show_filter_bar),
      callback: function($$v) {
        _vm.$set(_vm.form, "show_filter_bar", $$v)
      },
      expression: "form.show_filter_bar"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "sections"
  }, [_c('el-collapse', {
    staticClass: "formset__list"
  }, _vm._l((_vm.form.sections), function(section, i) {
    return _c('div', {
      staticClass: "formset__item"
    }, [_c('el-collapse-item', {
      attrs: {
        "name": i
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('formset-header', {
      attrs: {
        "label": section.title_pl || 'Nowa sekcja',
        "items": _vm.form.sections,
        "errors": _vm.checkForErrors(_vm.errors.sections, [i]),
        "index": i
      },
      on: {
        "update:items": function($event) {
          return _vm.$set(_vm.form, "sections", $event)
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "inline-form-group"
    }, [_c('el-form-item', {
      attrs: {
        "label": "Tytuł",
        "error": _vm.errors.sections && _vm.errors.sections[i] && _vm.errors.sections[i][_vm.addLanguageSuffix('title')]
      }
    }, [_c('el-input', {
      model: {
        value: (section[_vm.addLanguageSuffix('title')]),
        callback: function($$v) {
          _vm.$set(section, _vm.addLanguageSuffix('title'), $$v)
        },
        expression: "section[addLanguageSuffix('title')]"
      }
    })], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Kolor tła",
        "error": _vm.errors.sections && _vm.errors.sections[i] && _vm.errors.sections[i]['bg_color']
      }
    }, [_c('el-color-picker', {
      model: {
        value: (section.bg_color),
        callback: function($$v) {
          _vm.$set(section, "bg_color", $$v)
        },
        expression: "section.bg_color"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Kolor tekstu",
        "error": _vm.errors.sections && _vm.errors.sections[i] && _vm.errors.sections[i]['text_color']
      }
    }, [_c('el-color-picker', {
      model: {
        value: (section.text_color),
        callback: function($$v) {
          _vm.$set(section, "text_color", $$v)
        },
        expression: "section.text_color"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Typ kafla",
        "error": _vm.errors.sections && _vm.errors.sections[i] && _vm.errors.sections[i]['tile_type']
      }
    }, _vm._l((_vm.availableTileTypes), function(type) {
      return _c('el-radio', {
        key: type.value,
        attrs: {
          "label": type.value,
          "border": "",
          "size": "medium"
        },
        model: {
          value: (section.tile_type),
          callback: function($$v) {
            _vm.$set(section, "tile_type", $$v)
          },
          expression: "section.tile_type"
        }
      }, [_c('img', {
        staticClass: "tile",
        attrs: {
          "src": type.imgSrc,
          "alt": type.label
        }
      })])
    }), 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Tagi",
        "error": _vm.errors.sections && _vm.errors.sections[i] && _vm.errors.sections[i]['tags']
      }
    }, [_c('el-select', {
      attrs: {
        "multiple": "",
        "placeholder": "Wybierz tagi"
      },
      model: {
        value: (section.tags),
        callback: function($$v) {
          _vm.$set(section, "tags", $$v)
        },
        expression: "section.tags"
      }
    }, _vm._l((_vm.tags), function(option) {
      return _c('el-option', {
        key: option.id,
        attrs: {
          "label": option.name,
          "value": option.id
        }
      })
    }), 1)], 1)], 2)], 1)
  }), 0), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.addSection
    }
  }, [_vm._v("+ sekcja")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 771 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "100px"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_c('span', {
    staticClass: "box__header--text"
  }, [_vm._v(_vm._s(_vm.getRouteName(_vm.$route)))]), _vm._v(" "), _c('form-language-switcher')], 1), _vm._v(" "), _c('div', {
    staticClass: "inline-form-group"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Wydarzenie ukryte"
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.form.hide),
      callback: function($$v) {
        _vm.$set(_vm.form, "hide", $$v)
      },
      expression: "form.hide"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Data ukryta"
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.form.hide_date),
      callback: function($$v) {
        _vm.$set(_vm.form, "hide_date", $$v)
      },
      expression: "form.hide_date"
    }
  })], 1)], 1), _vm._v(" "), (_vm.eventType === 'others') ? _c('el-form-item', {
    attrs: {
      "label": "Typ wydarzenia",
      "error": _vm.errors['event_type'],
      "required": ""
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Typ wydarzenia",
      "allow-create": ""
    },
    model: {
      value: (_vm.form['event_type']),
      callback: function($$v) {
        _vm.$set(_vm.form, 'event_type', $$v)
      },
      expression: "form['event_type']"
    }
  }, _vm._l((_vm.availableEventTypes), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.eventDetails.labels['name'],
      "error": _vm.errors[_vm.addLanguageSuffix('name')],
      "required": ""
    }
  }, [_c('el-input', {
    on: {
      "blur": function($event) {
        return _vm.duplicateAnotherField($event.target.value, 'name_en')
      }
    },
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('name')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('name'), $$v)
      },
      expression: "form[addLanguageSuffix('name')]"
    }
  })], 1), _vm._v(" "), (_vm.eventDetails.labels['additional_name']) ? _c('el-form-item', {
    attrs: {
      "label": _vm.eventDetails.labels['additional_name'],
      "error": _vm.errors[_vm.addLanguageSuffix('additional_name')]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('additional_name')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('additional_name'), $$v)
      },
      expression: "form[addLanguageSuffix('additional_name')]"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Opis",
      "error": _vm.errors[_vm.addLanguageSuffix('description')]
    }
  }, [_c('wyswig-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('description')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('description'), $$v)
      },
      expression: "form[addLanguageSuffix('description')]"
    }
  })], 1), _vm._v(" "), (_vm.eventType !== 'music') ? _c('el-form-item', {
    attrs: {
      "label": "Tekst na kafelku",
      "error": _vm.errors[_vm.addLanguageSuffix('tile_text')]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('tile_text')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('tile_text'), $$v)
      },
      expression: "form[addLanguageSuffix('tile_text')]"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('edition-input', {
    attrs: {
      "errors": _vm.errors.edition,
      "required": true
    },
    model: {
      value: (_vm.form.edition),
      callback: function($$v) {
        _vm.$set(_vm.form, "edition", $$v)
      },
      expression: "form.edition"
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Popup"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "Wybierz popup"
    },
    model: {
      value: (_vm.form.popup),
      callback: function($$v) {
        _vm.$set(_vm.form, "popup", $$v)
      },
      expression: "form.popup"
    }
  }, _vm._l((_vm.popups), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.working_name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.eventType === 'theater' || _vm.eventType === 'others') ? _c('el-form-item', {
    attrs: {
      "label": "Logotyp",
      "error": _vm.errors['logotype']
    }
  }, [_c('image-input-component', {
    model: {
      value: (_vm.form.logotype),
      callback: function($$v) {
        _vm.$set(_vm.form, "logotype", $$v)
      },
      expression: "form.logotype"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tagi",
      "error": _vm.errors['tags']
    }
  }, [_c('el-select', {
    staticClass: "fluid",
    attrs: {
      "filterable": "",
      "multiple": "",
      "default-first-option": "",
      "placeholder": "Tagi",
      "allow-create": ""
    },
    model: {
      value: (_vm.form['tags']),
      callback: function($$v) {
        _vm.$set(_vm.form, 'tags', $$v)
      },
      expression: "form['tags']"
    }
  }, _vm._l((_vm.availableTags), function(item) {
    return _c('el-option', {
      key: item.name,
      attrs: {
        "label": item.name,
        "value": item.name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('EventOccurrences', {
    attrs: {
      "errors": _vm.errors.occurrences,
      "occurrences": _vm.form.occurrences
    },
    on: {
      "update:occurrences": function($event) {
        return _vm.$set(_vm.form, "occurrences", $event)
      }
    }
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "box__header box__header--photos"
  }, [_c('span', {
    staticClass: "box__header--text"
  }, [_vm._v("Zdjęcia:")])]), _vm._v(" "), _c('photo-cropper', {
    attrs: {
      "photo": _vm.form.photo,
      "errors": _vm.errors,
      "croppers": _vm.croppers
    },
    on: {
      "update:photo": function($event) {
        return _vm.$set(_vm.form, "photo", $event)
      },
      "update:croppers": function($event) {
        _vm.croppers = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "box__header"
  }, [_c('span', {
    staticClass: "box__header--text"
  }, [_vm._v("Widgety - widoczne w szczegółach:")])]), _vm._v(" "), _c('widgets-input', {
    attrs: {
      "widgets": _vm.form.widgets,
      "errors": _vm.errors.widgets || []
    },
    on: {
      "update:widgets": function($event) {
        return _vm.$set(_vm.form, "widgets", $event)
      }
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('manage')) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form__buttons",
    attrs: {
      "label-width": "0"
    }
  }, [_c('router-link', {
    attrs: {
      "to": _vm.redirectRoute
    }
  }, [_c('el-button', {
    staticClass: "fluid form__button"
  }, [_vm._v(_vm._s(_vm.$t('cancel')))])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "fluid form__button",
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('submit')) + "\n                        ")])], 1)], 1)])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 772 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _vm._l((_vm.occurrences), function(occurrence, i) {
    return _c('div', {
      staticClass: "occurrence"
    }, [_c('el-button', {
      staticClass: "occurrence__remove-button",
      attrs: {
        "type": "danger",
        "size": "small",
        "title": "Usuń termin"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.removeItemFromFormset(_vm.occurrences, occurrence)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-remove"
    })]), _vm._v(" "), _c('div', {
      staticClass: "inline-form-group"
    }, [_c('el-form-item', {
      attrs: {
        "label": "Data",
        "error": _vm.errors && _vm.errors[i] && _vm.errors[i]['date']
      }
    }, [_c('el-date-picker', {
      attrs: {
        "type": "date",
        "format": "yyyy/MM/dd",
        "value-format": "yyyy-MM-dd",
        "placeholder": "Data od"
      },
      model: {
        value: (occurrence.date),
        callback: function($$v) {
          _vm.$set(occurrence, "date", $$v)
        },
        expression: "occurrence.date"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Scena",
        "error": _vm.errors && _vm.errors[i] && _vm.errors[i]['stage']
      }
    }, [_c('el-select', {
      attrs: {
        "filterable": "",
        "clearable": "",
        "placeholder": "Scena"
      },
      model: {
        value: (occurrence.stage),
        callback: function($$v) {
          _vm.$set(occurrence, "stage", $$v)
        },
        expression: "occurrence.stage"
      }
    }, _vm._l((_vm.$store.state.stages), function(stage) {
      return _c('el-option', {
        key: stage.id,
        attrs: {
          "label": stage.name_pl,
          "value": stage.id
        }
      })
    }), 1)], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "inline-form-group"
    }, [_c('el-form-item', {
      attrs: {
        "label": "Godzina rozpoczęcia",
        "error": _vm.errors && _vm.errors[i] && _vm.errors[i]['hour_from']
      }
    }, [_c('el-time-picker', {
      attrs: {
        "value-format": "HH:mm:ss",
        "placeholder": "Godzina rozpoczęcia"
      },
      model: {
        value: (occurrence.hour_from),
        callback: function($$v) {
          _vm.$set(occurrence, "hour_from", $$v)
        },
        expression: "occurrence.hour_from"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Godzina zakończenia",
        "error": _vm.errors && _vm.errors[i] && _vm.errors[i]['hour_to']
      }
    }, [_c('el-time-picker', {
      attrs: {
        "value-format": "HH:mm:ss",
        "placeholder": "Godzina zakończenia"
      },
      model: {
        value: (occurrence.hour_to),
        callback: function($$v) {
          _vm.$set(occurrence, "hour_to", $$v)
        },
        expression: "occurrence.hour_to"
      }
    }), _vm._v(" "), _c('el-alert', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (occurrence.hour_from > occurrence.hour_to),
        expression: "occurrence.hour_from > occurrence.hour_to"
      }],
      attrs: {
        "title": "Podałeś godzinę następnego dnia.",
        "type": "warning",
        "show-icon": ""
      }
    })], 1)], 1), _vm._v(" "), (_vm.eventType === 'theater') ? _c('div', {
      staticClass: "inline-form-group"
    }, [_c('el-form-item', {
      attrs: {
        "label": "Liczba miejsc"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "Liczba miejsc"
      },
      model: {
        value: (occurrence.number_of_seats),
        callback: function($$v) {
          _vm.$set(occurrence, "number_of_seats", $$v)
        },
        expression: "occurrence.number_of_seats"
      }
    })], 1)], 1) : _vm._e()], 1)
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addOccurrence
    }
  }, [_vm._v("Dodaj termin")])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box__header"
  }, [_c('span', {
    staticClass: "box__header--text"
  }, [_vm._v("Terminy:")])])
}]}

/***/ }),
/* 773 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Rotacja slajdów",
      "error": _vm.errors.autorotate
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.form.autorotate),
      callback: function($$v) {
        _vm.$set(_vm.form, "autorotate", $$v)
      },
      expression: "form.autorotate"
    }
  })], 1), _vm._v(" "), (_vm.form.autorotate) ? _c('el-form-item', {
    attrs: {
      "label": "Czas pomiędzy automatyczną zmianą slajdu",
      "error": _vm.errors.autorotate_interval
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.form.autorotate_interval),
      callback: function($$v) {
        _vm.$set(_vm.form, "autorotate_interval", $$v)
      },
      expression: "form.autorotate_interval"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('div', {
    staticClass: "slides"
  }, [_c('el-collapse', {
    staticClass: "formset__list"
  }, _vm._l((_vm.form.slides), function(slide, i) {
    return _c('div', {
      staticClass: "formset__item"
    }, [_c('el-collapse-item', {
      attrs: {
        "name": i
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('formset-header', {
      attrs: {
        "label": ("" + (slide.title_pl || 'Nowy slajd')),
        "errors": _vm.checkForErrors(_vm.errors.slides, [i]),
        "items": _vm.form.slides,
        "index": i
      },
      on: {
        "update:items": function($event) {
          return _vm.$set(_vm.form, "slides", $event)
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "inline-form-group"
    }, [_c('el-form-item', {
      attrs: {
        "label": "Tytuł",
        "error": _vm.errors.slides && _vm.errors.slides[i] && _vm.errors.slides[i]['title']
      }
    }, [_c('el-input', {
      model: {
        value: (slide[_vm.addLanguageSuffix('title')]),
        callback: function($$v) {
          _vm.$set(slide, _vm.addLanguageSuffix('title'), $$v)
        },
        expression: "slide[addLanguageSuffix('title')]"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Podtytuł",
        "error": _vm.errors.slides && _vm.errors.slides[i] && _vm.errors.slides[i]['subtitle']
      }
    }, [_c('el-input', {
      model: {
        value: (slide[_vm.addLanguageSuffix('subtitle')]),
        callback: function($$v) {
          _vm.$set(slide, _vm.addLanguageSuffix('subtitle'), $$v)
        },
        expression: "slide[addLanguageSuffix('subtitle')]"
      }
    })], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Video",
        "error": _vm.errors.slides && _vm.errors.slides[i] && _vm.errors.slides[i]['video']
      }
    }, [_c('el-input', {
      model: {
        value: (slide.video),
        callback: function($$v) {
          _vm.$set(slide, "video", $$v)
        },
        expression: "slide.video"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Iframe",
        "error": _vm.errors.slides && _vm.errors.slides[i] && _vm.errors.slides[i]['iframe']
      }
    }, [_c('el-input', {
      attrs: {
        "type": "textarea"
      },
      model: {
        value: (slide.iframe),
        callback: function($$v) {
          _vm.$set(slide, "iframe", $$v)
        },
        expression: "slide.iframe"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "inline-form-group"
    }, [_c('el-form-item', {
      attrs: {
        "label": "Grafika",
        "error": _vm.errors.slides && _vm.errors.slides[i] && _vm.errors.slides[i]['image']
      }
    }, [_c('image-input-component', {
      model: {
        value: (slide.image),
        callback: function($$v) {
          _vm.$set(slide, "image", $$v)
        },
        expression: "slide.image"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Kolor tekstu",
        "error": _vm.errors.slides && _vm.errors.slides[i] && _vm.errors.slides[i]['text_color']
      }
    }, [_c('el-color-picker', {
      model: {
        value: (slide.text_color),
        callback: function($$v) {
          _vm.$set(slide, "text_color", $$v)
        },
        expression: "slide.text_color"
      }
    })], 1)], 1), _vm._v(" "), _c('el-collapse', {
      staticClass: "collapse"
    }, [_c('el-form-item', {
      attrs: {
        "label": ""
      }
    }, [_c('el-collapse-item', {
      attrs: {
        "title": "szczegóły lewego przycisku"
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "Nazwa lewego przycisku",
        "error": _vm.errors.slides && _vm.errors.slides[i]['left_button_title']
      }
    }, [_c('el-input', {
      model: {
        value: (slide[_vm.addLanguageSuffix('left_button_title')]),
        callback: function($$v) {
          _vm.$set(slide, _vm.addLanguageSuffix('left_button_title'), $$v)
        },
        expression: "slide[addLanguageSuffix('left_button_title')]"
      }
    })], 1), _vm._v(" "), _c('link-component', {
      key: slide.left_button_link_key || slide.id + 'left',
      attrs: {
        "errors": _vm.errors.slides && _vm.errors.slides[i]['left_button_link']
      },
      model: {
        value: (slide.left_button_link),
        callback: function($$v) {
          _vm.$set(slide, "left_button_link", $$v)
        },
        expression: "slide.left_button_link"
      }
    })], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": ""
      }
    }, [_c('el-collapse-item', {
      attrs: {
        "title": "szczegóły prawego przycisku"
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "Nazwa prawego przycisku",
        "error": _vm.errors.slides && _vm.errors.slides[i]['right_button_title']
      }
    }, [_c('el-input', {
      model: {
        value: (slide[_vm.addLanguageSuffix('right_button_title')]),
        callback: function($$v) {
          _vm.$set(slide, _vm.addLanguageSuffix('right_button_title'), $$v)
        },
        expression: "slide[addLanguageSuffix('right_button_title')]"
      }
    })], 1), _vm._v(" "), _c('link-component', {
      key: slide.right_button_link_key || slide.id + 'right',
      attrs: {
        "errors": _vm.errors.slides && _vm.errors.slides[i]['right_button_link']
      },
      model: {
        value: (slide.right_button_link),
        callback: function($$v) {
          _vm.$set(slide, "right_button_link", $$v)
        },
        expression: "slide.right_button_link"
      }
    })], 1)], 1)], 1)], 2)], 1)
  }), 0), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.addSection
    }
  }, [_vm._v("Dodaj slajd")]), _vm._v(" "), (typeof _vm.errors.slides === 'string') ? _c('div', {
    staticClass: "el-form-item__error"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.slides) + "\n            ")]) : _vm._e()], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 774 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form-item', {
    attrs: {
      "label": "Edycja",
      "error": _vm.errors,
      "required": _vm.required
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "value": _vm.value,
      "clearable": _vm.clearable,
      "placeholder": "Edycja"
    },
    on: {
      "change": function($event) {
        return _vm.$emit('input', $event)
      }
    }
  }, _vm._l((_vm.$store.state.editions), function(edition) {
    return _c('el-option', {
      key: edition.id,
      attrs: {
        "label": edition.year,
        "value": edition.id
      }
    })
  }), 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 775 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Typ",
      "error": _vm.errors.widget_type
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Wybierz typ"
    },
    model: {
      value: (_vm.form.widget_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "widget_type", $$v)
      },
      expression: "form.widget_type"
    }
  }, _vm._l((_vm.types), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.form.widget_type === 'ticket') ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Bilet",
      "error": _vm.errors.ticket
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Wybierz bilet"
    },
    model: {
      value: (_vm.form.ticket),
      callback: function($$v) {
        _vm.$set(_vm.form, "ticket", $$v)
      },
      expression: "form.ticket"
    }
  }, _vm._l((_vm.tickets), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name_pl,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Sold out",
      "error": _vm.errors.single_ticket_sold_out
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.form.single_ticket_sold_out),
      callback: function($$v) {
        _vm.$set(_vm.form, "single_ticket_sold_out", $$v)
      },
      expression: "form.single_ticket_sold_out"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.form.widget_type === 'period') ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Okres",
      "error": _vm.errors.period
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Wybierz okres"
    },
    model: {
      value: (_vm.form.period),
      callback: function($$v) {
        _vm.$set(_vm.form, "period", $$v)
      },
      expression: "form.period"
    }
  }, _vm._l((_vm.periods), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name_pl,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Domyślnie rozwinięty"
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.form.expanded_at_start),
      callback: function($$v) {
        _vm.$set(_vm.form, "expanded_at_start", $$v)
      },
      expression: "form.expanded_at_start"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Kolor tła",
      "error": _vm.errors['bg_color']
    }
  }, [_c('el-color-picker', {
    model: {
      value: (_vm.form.bg_color),
      callback: function($$v) {
        _vm.$set(_vm.form, "bg_color", $$v)
      },
      expression: "form.bg_color"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Kolor tekstu",
      "error": _vm.errors['text_color']
    }
  }, [_c('el-color-picker', {
    model: {
      value: (_vm.form.text_color),
      callback: function($$v) {
        _vm.$set(_vm.form, "text_color", $$v)
      },
      expression: "form.text_color"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Program"
    }
  }, [_c('link-component', {
    attrs: {
      "errors": _vm.errors['program']
    },
    model: {
      value: (_vm.form.program),
      callback: function($$v) {
        _vm.$set(_vm.form, "program", $$v)
      },
      expression: "form.program"
    }
  })], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 776 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    staticClass: "sidebar",
    attrs: {
      "span": 6
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: _vm.eventDetails.routes.add
      }
    }
  }, [_c('el-button', {
    staticClass: "fluid",
    attrs: {
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('add')) + " Wydarzenie "), _c('i', {
    staticClass: "el-icon-plus"
  })])], 1), _vm._v(" "), _c('ListFilterComponent', {
    attrs: {
      "selectedFilters": _vm.filters.selected,
      "listFilters": _vm.filters.available
    },
    on: {
      "setFilter": _vm.setFilter
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "box",
    attrs: {
      "span": 18
    }
  }, [_c('div', {
    staticClass: "list__header"
  }, [_c('p', {
    staticClass: "list__title"
  }, [_vm._v("\n                    " + _vm._s(_vm.getRouteName(_vm.$route)) + "\n                ")]), _vm._v(" "), _c('search-list-form', {
    on: {
      "submit": _vm.fetchData
    },
    model: {
      value: (_vm.filters.selected.search),
      callback: function($$v) {
        _vm.$set(_vm.filters.selected, "search", $$v)
      },
      expression: "filters.selected.search"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticClass: "list__table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.data,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "id",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name_pl",
      "label": "nazwa (pl)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name_en",
      "label": "nazwa (en)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "hide",
      "label": "ukryte"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.hide) ? _c('i', {
          staticClass: "el-icon-check"
        }) : _c('i', {
          staticClass: "el-icon-close"
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "pull-right",
    attrs: {
      "label": "akcje",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: _vm.eventDetails.routes.edit,
              params: {
                id: scope.row.id
              }
            }
          }
        }, [_c('el-button', {
          attrs: {
            "size": "small",
            "title": _vm.$t('edit')
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        })])], 1), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small",
            "title": _vm.$t('delete')
          },
          on: {
            "click": function($event) {
              return _vm.handleDelete(scope.$index, scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        })])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "list__pagination",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.count
    },
    on: {
      "current-change": _vm.handlePageChange
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 777 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    staticClass: "sidebar",
    attrs: {
      "span": 6
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Add Edition'
      }
    }
  }, [_c('el-button', {
    staticClass: "fluid",
    attrs: {
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('add')) + " Edycję "), _c('i', {
    staticClass: "el-icon-plus"
  })])], 1), _vm._v(" "), _c('ListFilterComponent', {
    attrs: {
      "selectedFilters": _vm.filters.selected,
      "listFilters": _vm.filters.available
    },
    on: {
      "setFilter": _vm.setFilter
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "box",
    attrs: {
      "span": 18
    }
  }, [_c('div', {
    staticClass: "list__header"
  }, [_c('p', {
    staticClass: "list__title"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.getRouteName(_vm.$route)) + "\n\t\t\t\t\t")])]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticClass: "list__table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.data,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "id",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "year",
      "label": "rok"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "visible",
      "label": "obecna"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.current) ? _c('i', {
          staticClass: "el-icon-check"
        }) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "pull-right",
    attrs: {
      "label": "opcje",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'Edit Edition',
              params: {
                id: scope.row.id
              }
            }
          }
        }, [_c('el-button', {
          attrs: {
            "size": "small",
            "title": _vm.$t('edit')
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        })])], 1)]
      }
    }])
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 778 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Folder",
      "required": "",
      "error": _vm.errors['folder']
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Wybierz folder"
    },
    model: {
      value: (_vm.form.folder),
      callback: function($$v) {
        _vm.$set(_vm.form, "folder", $$v)
      },
      expression: "form.folder"
    }
  }, _vm._l((_vm.folders), function(folder) {
    return _c('el-option', {
      key: folder.id,
      attrs: {
        "label": folder.working_name,
        "value": folder.id
      }
    })
  }), 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 779 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('edition-input', {
    attrs: {
      "errors": _vm.errors.edition,
      "clearable": true,
      "required": false
    },
    model: {
      value: (_vm.form.edition),
      callback: function($$v) {
        _vm.$set(_vm.form, "edition", $$v)
      },
      expression: "form.edition"
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Rodzaj wydarzenia",
      "required": "",
      "error": _vm.errors['event_type']
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Wybierz typ wydarzenia"
    },
    model: {
      value: (_vm.form.event_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "event_type", $$v)
      },
      expression: "form.event_type"
    }
  }, _vm._l((_vm.types), function(type) {
    return _c('el-option', {
      key: type,
      attrs: {
        "label": _vm.translateType(type),
        "value": type
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Kolor tła",
      "error": _vm.errors['bg_color']
    }
  }, [_c('el-color-picker', {
    model: {
      value: (_vm.form.bg_color),
      callback: function($$v) {
        _vm.$set(_vm.form, "bg_color", $$v)
      },
      expression: "form.bg_color"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Kolor tekstu",
      "error": _vm.errors['text_color']
    }
  }, [_c('el-color-picker', {
    model: {
      value: (_vm.form.text_color),
      callback: function($$v) {
        _vm.$set(_vm.form, "text_color", $$v)
      },
      expression: "form.text_color"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 780 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    staticClass: "sidebar",
    attrs: {
      "span": 6
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Add StandCategory'
      }
    }
  }, [_c('el-button', {
    staticClass: "fluid",
    attrs: {
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('add')) + " Kategorię "), _c('i', {
    staticClass: "el-icon-plus"
  })])], 1), _vm._v(" "), _c('ListFilterComponent', {
    attrs: {
      "selectedFilters": _vm.filters.selected,
      "listFilters": _vm.filters.available
    },
    on: {
      "setFilter": _vm.setFilter
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "box",
    attrs: {
      "span": 18
    }
  }, [_c('div', {
    staticClass: "list__header"
  }, [_c('p', {
    staticClass: "list__title"
  }, [_vm._v("\n                    " + _vm._s(_vm.getRouteName(_vm.$route)) + "\n                ")]), _vm._v(" "), _c('search-list-form', {
    on: {
      "submit": _vm.fetchData
    },
    model: {
      value: (_vm.filters.selected.search),
      callback: function($$v) {
        _vm.$set(_vm.filters.selected, "search", $$v)
      },
      expression: "filters.selected.search"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticClass: "list__table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.data,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "id",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name_pl",
      "label": "nazwa (pl)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name_en",
      "label": "nazwa (en)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "pull-right",
    attrs: {
      "label": "opcje",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'Edit StandCategory',
              params: {
                id: scope.row.id
              }
            }
          }
        }, [_c('el-button', {
          attrs: {
            "size": "small",
            "title": _vm.$t('edit')
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        })])], 1), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small",
            "title": _vm.$t('delete')
          },
          on: {
            "click": function($event) {
              return _vm.handleDelete(scope.$index, scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        })])]
      }
    }])
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 781 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Alt",
      "error": _vm.errors[_vm.addLanguageSuffix('alt')]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "Alt"
    },
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('alt')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('alt'), $$v)
      },
      expression: "form[addLanguageSuffix('alt')]"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Grafika desktop (1160px szerokości)",
      "error": _vm.errors['desktop_image']
    }
  }, [_c('image-input-component', {
    model: {
      value: (_vm.form.desktop_image),
      callback: function($$v) {
        _vm.$set(_vm.form, "desktop_image", $$v)
      },
      expression: "form.desktop_image"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Mapa desktop",
      "error": _vm.errors['desktop_map']
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": _vm.mapPlaceholder
    },
    model: {
      value: (_vm.form.desktop_map),
      callback: function($$v) {
        _vm.$set(_vm.form, "desktop_map", $$v)
      },
      expression: "form.desktop_map"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Grafika tablet (max 1160px szerokości)",
      "error": _vm.errors['tablet_image']
    }
  }, [_c('image-input-component', {
    model: {
      value: (_vm.form.tablet_image),
      callback: function($$v) {
        _vm.$set(_vm.form, "tablet_image", $$v)
      },
      expression: "form.tablet_image"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Mapa desktop",
      "error": _vm.errors['tablet_map']
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": _vm.mapPlaceholder
    },
    model: {
      value: (_vm.form.tablet_map),
      callback: function($$v) {
        _vm.$set(_vm.form, "tablet_map", $$v)
      },
      expression: "form.tablet_map"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Grafika mobile (max 768px)",
      "error": _vm.errors['mobile_image']
    }
  }, [_c('image-input-component', {
    model: {
      value: (_vm.form.mobile_image),
      callback: function($$v) {
        _vm.$set(_vm.form, "mobile_image", $$v)
      },
      expression: "form.mobile_image"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Mapa desktop",
      "error": _vm.errors['mobile_map']
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": _vm.mapPlaceholder
    },
    model: {
      value: (_vm.form.mobile_map),
      callback: function($$v) {
        _vm.$set(_vm.form, "mobile_map", $$v)
      },
      expression: "form.mobile_map"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 782 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._v("\n\tmain\n")])
},staticRenderFns: []}

/***/ }),
/* 783 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": ("Podgląd - " + (_vm.simpleFormData.timestamp)),
      "width": "70vw",
      "visible": _vm.dialogFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "sections"
  }, _vm._l((_vm.formData.sections), function(section, i) {
    return _c('div', [_c('h2', {
      staticClass: "section__title"
    }, [_vm._v("Sekcja: " + _vm._s(section.name))]), _vm._v(" "), _vm._l((section.fields), function(field, i) {
      return _c('div', [_c('strong', {
        staticClass: "field__label"
      }, [_vm._v("\n                        " + _vm._s(i + 1) + ". " + _vm._s(field.label) + "\n                    ")]), _vm._v(" "), _c('p', [(field.answer.value === 'true') ? _c('span', [_c('i', {
        staticClass: "fa fa-check"
      })]) : (field.answer.kind === 'photo') ? _c('img', {
        staticClass: "field__thumbnail",
        attrs: {
          "src": field.answer.value,
          "alt": ""
        }
      }) : _c('span', [_vm._v("\n                            " + _vm._s(field.answer.value) + "\n                        ")])])])
    })], 2)
  }), 0), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.$emit('previousPreview')
      }
    }
  }, [_vm._v("<")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.$emit('nextPreview')
      }
    }
  }, [_vm._v(">")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.cancelForm()
      }
    }
  }, [_vm._v("Zamknij")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 784 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "100px"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_c('span', {
    staticClass: "box__header--text"
  }, [_vm._v(_vm._s(_vm.getRouteName(_vm.$route)))]), _vm._v(" "), _c('form-language-switcher')], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nazwa",
      "error": _vm.errors[_vm.addLanguageSuffix('name')],
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('name')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('name'), $$v)
      },
      expression: "form[addLanguageSuffix('name')]"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Opis strony (dla: google, facebook)",
      "error": _vm.errors[_vm.addLanguageSuffix('meta_description')]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('meta_description')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('meta_description'), $$v)
      },
      expression: "form[addLanguageSuffix('meta_description')]"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Popup",
      "error": _vm.errors['popup']
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "Wybierz popup"
    },
    model: {
      value: (_vm.form.popup),
      callback: function($$v) {
        _vm.$set(_vm.form, "popup", $$v)
      },
      expression: "form.popup"
    }
  }, _vm._l((_vm.popups), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.working_name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "box__header"
  }, [_c('span', {
    staticClass: "box__header--text"
  }, [_vm._v("Widgety - widoczne w szczegółach:")])]), _vm._v(" "), _c('widgets-input', {
    attrs: {
      "widgets": _vm.form.widgets,
      "lessDetails": true,
      "errors": _vm.errors.widgets || []
    },
    on: {
      "update:widgets": function($event) {
        return _vm.$set(_vm.form, "widgets", $event)
      }
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('manage')) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form__buttons",
    attrs: {
      "label-width": "0"
    }
  }, [_c('router-link', {
    attrs: {
      "to": _vm.redirectRoute
    }
  }, [_c('el-button', {
    staticClass: "fluid form__button"
  }, [_vm._v(_vm._s(_vm.$t('cancel')))])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "fluid form__button",
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('submit')) + "\n                        ")]), _vm._v(" "), _c('label', [_vm._v("\n                            Ukryj\n                            "), _c('el-switch', {
    model: {
      value: (_vm.form.hide),
      callback: function($$v) {
        _vm.$set(_vm.form, "hide", $$v)
      },
      expression: "form.hide"
    }
  })], 1)], 1)], 1)])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 785 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    attrs: {
      "inline": true
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.$emit('submit')
      }
    }
  }, [_c('el-form-item', {
    staticClass: "list__search-wrapper"
  }, [_c('el-input', {
    staticClass: "list__search",
    attrs: {
      "value": _vm.value,
      "placeholder": _vm.$t('query')
    },
    on: {
      "input": _vm.onInput
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "list__search-wrapper"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.$emit('submit')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('search')))])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 786 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    staticClass: "sidebar",
    attrs: {
      "span": 6
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Add Period'
      }
    }
  }, [_c('el-button', {
    staticClass: "fluid",
    attrs: {
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('add')) + " Okres "), _c('i', {
    staticClass: "el-icon-plus"
  })])], 1), _vm._v(" "), _c('ListFilterComponent', {
    attrs: {
      "selectedFilters": _vm.filters.selected,
      "listFilters": _vm.filters.available
    },
    on: {
      "setFilter": _vm.setFilter
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "box",
    attrs: {
      "span": 18
    }
  }, [_c('div', {
    staticClass: "list__header"
  }, [_c('p', {
    staticClass: "list__title"
  }, [_vm._v("\n                    " + _vm._s(_vm.getRouteName(_vm.$route)) + "\n                ")]), _vm._v(" "), _c('search-list-form', {
    on: {
      "submit": _vm.fetchData
    },
    model: {
      value: (_vm.filters.selected.search),
      callback: function($$v) {
        _vm.$set(_vm.filters.selected, "search", $$v)
      },
      expression: "filters.selected.search"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticClass: "list__table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.data,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "id",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name_pl",
      "label": "nazwa (pl)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name_en",
      "label": "nazwa (en)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "visible",
      "label": "sold out"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.sold_out) ? _c('i', {
          staticClass: "el-icon-check"
        }) : _c('i', {
          staticClass: "el-icon-close"
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "pull-right",
    attrs: {
      "label": "opcje",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'Edit Period',
              params: {
                id: scope.row.id
              }
            }
          }
        }, [_c('el-button', {
          attrs: {
            "size": "small",
            "title": _vm.$t('edit')
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        })])], 1), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small",
            "title": _vm.$t('delete')
          },
          on: {
            "click": function($event) {
              return _vm.handleDelete(scope.$index, scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        })])]
      }
    }])
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 787 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', [_c('div', {
    staticClass: "questions"
  }, [_c('el-collapse', {
    staticClass: "formset__list"
  }, _vm._l((_vm.form.questions), function(question, i) {
    return _c('div', {
      staticClass: "formset__item"
    }, [_c('el-collapse-item', {
      attrs: {
        "name": i
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('formset-header', {
      attrs: {
        "label": ("" + (question.question_pl || 'Nowe pytanie')),
        "errors": _vm.checkForErrors(_vm.errors.questions, [i]),
        "items": _vm.form.questions,
        "index": i
      },
      on: {
        "update:items": function($event) {
          return _vm.$set(_vm.form, "questions", $event)
        }
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Pytanie",
        "error": _vm.errors.questions && _vm.errors.questions[i] && _vm.errors.questions[i]['question']
      }
    }, [_c('el-input', {
      attrs: {
        "type": "textarea"
      },
      model: {
        value: (question[_vm.addLanguageSuffix('question')]),
        callback: function($$v) {
          _vm.$set(question, _vm.addLanguageSuffix('question'), $$v)
        },
        expression: "question[addLanguageSuffix('question')]"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Odpowiedź",
        "error": _vm.errors.questions && _vm.errors.questions[i] && _vm.errors.questions[i]['answer']
      }
    }, [_c('wyswig-input', {
      model: {
        value: (question[_vm.addLanguageSuffix('answer')]),
        callback: function($$v) {
          _vm.$set(question, _vm.addLanguageSuffix('answer'), $$v)
        },
        expression: "question[addLanguageSuffix('answer')]"
      }
    })], 1)], 2)], 1)
  }), 0), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.addSection
    }
  }, [_vm._v("Dodaj pytanie")]), _vm._v(" "), (typeof _vm.errors.questions === 'string') ? _c('div', {
    staticClass: "el-form-item__error"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.questions) + "\n            ")]) : _vm._e()], 1)]), _vm._v(" "), _c('el-form-item', {
    staticClass: "left-image",
    attrs: {
      "label": "Grafika po lewej stronie",
      "error": _vm.errors.left_image
    }
  }, [_c('image-input-component', {
    model: {
      value: (_vm.form.left_image),
      callback: function($$v) {
        _vm.$set(_vm.form, "left_image", $$v)
      },
      expression: "form.left_image"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Grafika po prawej stronie",
      "error": _vm.errors.right_image
    }
  }, [_c('image-input-component', {
    model: {
      value: (_vm.form.right_image),
      callback: function($$v) {
        _vm.$set(_vm.form, "right_image", $$v)
      },
      expression: "form.right_image"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 788 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "120px"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_c('span', {
    staticClass: "box__header--text"
  }, [_vm._v(_vm._s(_vm.getRouteName(_vm.$route)))]), _vm._v(" "), _c('form-language-switcher')], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nazwa",
      "error": _vm.errors['name'],
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form['name']),
      callback: function($$v) {
        _vm.$set(_vm.form, 'name', $$v)
      },
      expression: "form['name']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Kolor",
      "error": _vm.errors.color
    }
  }, [_c('el-color-picker', {
    model: {
      value: (_vm.form.color),
      callback: function($$v) {
        _vm.$set(_vm.form, "color", $$v)
      },
      expression: "form.color"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('manage')) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form__buttons",
    attrs: {
      "label-width": "0"
    }
  }, [_c('router-link', {
    attrs: {
      "to": _vm.redirectRoute
    }
  }, [_c('el-button', {
    staticClass: "fluid form__button"
  }, [_vm._v(_vm._s(_vm.$t('cancel')))])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "fluid form__button",
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('submit')) + "\n                        ")])], 1)], 1)])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 789 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    staticClass: "sidebar",
    attrs: {
      "span": 6
    }
  }, [_c('ListFilterComponent', {
    attrs: {
      "selectedFilters": _vm.filters.selected,
      "listFilters": _vm.filters.available
    },
    on: {
      "setFilter": _vm.setFilter
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "box",
    attrs: {
      "span": 18
    }
  }, [_c('div', {
    staticClass: "list__header"
  }, [_c('p', {
    staticClass: "list__title"
  }, [_vm._v("\n                    " + _vm._s(_vm.getRouteName(_vm.$route)) + "\n                ")]), _vm._v(" "), _c('search-list-form', {
    on: {
      "submit": _vm.fetchData
    },
    model: {
      value: (_vm.filters.selected.search),
      callback: function($$v) {
        _vm.$set(_vm.filters.selected, "search", $$v)
      },
      expression: "filters.selected.search"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticClass: "list__table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.data,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "id",
      "width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "zdjęcie"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          attrs: {
            "src": scope.row.thumbnail,
            "alt": scope.row.alt_pl
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "autor"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.photoDuringEdition(scope.row)) ? _c('el-input', {
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.duringEditing[scope.row.id].author),
            callback: function($$v) {
              _vm.$set(_vm.duringEditing[scope.row.id], "author", $$v)
            },
            expression: "duringEditing[scope.row.id].author"
          }
        }) : _vm._e(), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.photoDuringEdition(scope.row)),
            expression: "!photoDuringEdition(scope.row)"
          }]
        }, [_vm._v(_vm._s(scope.row.author))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "alt (pl)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.photoDuringEdition(scope.row)) ? _c('el-input', {
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.duringEditing[scope.row.id].alt_pl),
            callback: function($$v) {
              _vm.$set(_vm.duringEditing[scope.row.id], "alt_pl", $$v)
            },
            expression: "duringEditing[scope.row.id].alt_pl"
          }
        }) : _vm._e(), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.photoDuringEdition(scope.row)),
            expression: "!photoDuringEdition(scope.row)"
          }]
        }, [_vm._v(_vm._s(scope.row.alt_pl))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "alt (en)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.photoDuringEdition(scope.row)) ? _c('el-input', {
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.duringEditing[scope.row.id].alt_en),
            callback: function($$v) {
              _vm.$set(_vm.duringEditing[scope.row.id], "alt_en", $$v)
            },
            expression: "duringEditing[scope.row.id].alt_en"
          }
        }) : _vm._e(), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.photoDuringEdition(scope.row)),
            expression: "!photoDuringEdition(scope.row)"
          }]
        }, [_vm._v(_vm._s(scope.row.alt_en))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "pull-right",
    attrs: {
      "label": "opcje",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.photoDuringEdition(scope.row)),
            expression: "!photoDuringEdition(scope.row)"
          }],
          attrs: {
            "title": "Edytuj szczegóły zdjęcia",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.editPhoto(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        })]), _vm._v(" "), _c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.photoDuringEdition(scope.row)),
            expression: "photoDuringEdition(scope.row)"
          }],
          attrs: {
            "title": "Zatwierdź edycję",
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.submitEditedPhoto(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-check"
        })]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small",
            "title": _vm.$t('delete')
          },
          on: {
            "click": function($event) {
              return _vm.handleDelete(scope.$index, scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        })])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "list__pagination",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.count
    },
    on: {
      "current-change": _vm.handlePageChange
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 790 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "120px"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_c('span', {
    staticClass: "box__header--text"
  }, [_vm._v(_vm._s(_vm.getRouteName(_vm.$route)))]), _vm._v(" "), _c('form-language-switcher')], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nazwa",
      "error": _vm.errors[_vm.addLanguageSuffix('name')],
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('name')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('name'), $$v)
      },
      expression: "form[addLanguageSuffix('name')]"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Opis",
      "error": _vm.errors[_vm.addLanguageSuffix('description')]
    }
  }, [_c('wyswig-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('description')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('description'), $$v)
      },
      expression: "form[addLanguageSuffix('description')]"
    }
  })], 1), _vm._v(" "), _c('edition-input', {
    attrs: {
      "errors": _vm.errors.edition,
      "required": true
    },
    model: {
      value: (_vm.form.edition),
      callback: function($$v) {
        _vm.$set(_vm.form, "edition", $$v)
      },
      expression: "form.edition"
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Popup"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "Wybierz popup"
    },
    model: {
      value: (_vm.form.popup),
      callback: function($$v) {
        _vm.$set(_vm.form, "popup", $$v)
      },
      expression: "form.popup"
    }
  }, _vm._l((_vm.popups), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.working_name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Logotyp",
      "error": _vm.errors['logotype']
    }
  }, [_c('image-input-component', {
    model: {
      value: (_vm.form.logotype),
      callback: function($$v) {
        _vm.$set(_vm.form, "logotype", $$v)
      },
      expression: "form.logotype"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Kategoria główna",
      "error": _vm.errors['category']
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Kategoria"
    },
    model: {
      value: (_vm.form.category),
      callback: function($$v) {
        _vm.$set(_vm.form, "category", $$v)
      },
      expression: "form.category"
    }
  }, _vm._l((_vm.categories), function(category) {
    return _c('el-option', {
      key: category.id,
      attrs: {
        "label": category.name_pl,
        "value": category.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Podkategorie",
      "error": _vm.errors['tags']
    }
  }, [_c('el-select', {
    staticClass: "fluid",
    attrs: {
      "filterable": "",
      "multiple": "",
      "default-first-option": "",
      "placeholder": "Tagi",
      "allow-create": ""
    },
    model: {
      value: (_vm.form['tags']),
      callback: function($$v) {
        _vm.$set(_vm.form, 'tags', $$v)
      },
      expression: "form['tags']"
    }
  }, _vm._l((_vm.availableTags), function(item) {
    return _c('el-option', {
      key: item.name,
      attrs: {
        "label": item.name,
        "value": item.name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Miejsca",
      "error": _vm.errors['stages']
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "multiple": "",
      "placeholder": "Sceny"
    },
    model: {
      value: (_vm.form.stages),
      callback: function($$v) {
        _vm.$set(_vm.form, "stages", $$v)
      },
      expression: "form.stages"
    }
  }, _vm._l((_vm.$store.state.stages), function(stage) {
    return _c('el-option', {
      key: stage.id,
      attrs: {
        "label": stage.name_pl,
        "value": stage.id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "box__header box__header--photos"
  }, [_c('span', {
    staticClass: "box__header--text"
  }, [_vm._v("Zdjęcia:")])]), _vm._v(" "), _c('photo-cropper', {
    attrs: {
      "photo": _vm.form.photo,
      "errors": _vm.errors,
      "croppers": _vm.croppers
    },
    on: {
      "update:photo": function($event) {
        return _vm.$set(_vm.form, "photo", $event)
      },
      "update:croppers": function($event) {
        _vm.croppers = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "box__header"
  }, [_c('span', {
    staticClass: "box__header--text"
  }, [_vm._v("Widgety - widoczne w szczegółach:")])]), _vm._v(" "), _c('widgets-input', {
    attrs: {
      "widgets": _vm.form.widgets,
      "errors": _vm.errors.widgets || []
    },
    on: {
      "update:widgets": function($event) {
        return _vm.$set(_vm.form, "widgets", $event)
      }
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('manage')) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form__buttons",
    attrs: {
      "label-width": "0"
    }
  }, [_c('router-link', {
    attrs: {
      "to": _vm.redirectRoute
    }
  }, [_c('el-button', {
    staticClass: "fluid form__button"
  }, [_vm._v(_vm._s(_vm.$t('cancel')))])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "fluid form__button",
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('submit')) + "\n                        ")])], 1), _vm._v(" "), _c('label', [_vm._v("\n                        Ukryj\n                        "), _c('el-switch', {
    model: {
      value: (_vm.form.hide),
      callback: function($$v) {
        _vm.$set(_vm.form, "hide", $$v)
      },
      expression: "form.hide"
    }
  })], 1)], 1)])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 791 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Liczba newsów na stronę",
      "required": "",
      "error": _vm.errors.page_size
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.form.page_size),
      callback: function($$v) {
        _vm.$set(_vm.form, "page_size", $$v)
      },
      expression: "form.page_size"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Kolor tła",
      "error": _vm.errors['bg_color']
    }
  }, [_c('el-color-picker', {
    model: {
      value: (_vm.form.bg_color),
      callback: function($$v) {
        _vm.$set(_vm.form, "bg_color", $$v)
      },
      expression: "form.bg_color"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Kolor tekstu",
      "error": _vm.errors['text_color']
    }
  }, [_c('el-color-picker', {
    model: {
      value: (_vm.form.text_color),
      callback: function($$v) {
        _vm.$set(_vm.form, "text_color", $$v)
      },
      expression: "form.text_color"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tagi",
      "error": _vm.errors['tags']
    }
  }, [_c('el-select', {
    staticClass: "fluid",
    attrs: {
      "filterable": "",
      "multiple": "",
      "clearable": "",
      "default-first-option": "",
      "placeholder": "Tagi"
    },
    model: {
      value: (_vm.form['tags']),
      callback: function($$v) {
        _vm.$set(_vm.form, 'tags', $$v)
      },
      expression: "form['tags']"
    }
  }, _vm._l((_vm.tags), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 792 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "120px"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_c('span', {
    staticClass: "box__header--text"
  }, [_vm._v(_vm._s(_vm.getRouteName(_vm.$route)) + " - " + _vm._s(_vm.form.name))]), _vm._v(" "), _c('form-language-switcher')], 1), _vm._v(" "), _c('el-collapse', {
    staticClass: "formset__list"
  }, _vm._l((_vm.form.items), function(item, i) {
    return _c('div', {
      staticClass: "formset__item"
    }, [_c('el-collapse-item', {
      attrs: {
        "name": i
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('formset-header', {
      attrs: {
        "label": ("" + (item.label_pl || 'Nowa pozycja')),
        "items": _vm.form.items,
        "errors": _vm.checkForErrors(_vm.errors.items, [i]),
        "index": i
      },
      on: {
        "update:items": function($event) {
          return _vm.$set(_vm.form, "items", $event)
        }
      }
    })], 1), _vm._v(" "), _c('menu-item', {
      attrs: {
        "item": item,
        "allow_submenu": _vm.form.allow_submenu,
        "errors": (_vm.errors.items && _vm.errors.items[i]) || {}
      },
      on: {
        "update:item": function($event) {
          item = $event
        }
      }
    })], 2)], 1)
  }), 0), _vm._v(" "), _c('el-button', {
    staticClass: "fluid",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addMenuItem
    }
  }, [_vm._v("\n                        Dodaj pozycje menu\n                    ")])], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('manage')) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form__buttons",
    attrs: {
      "label-width": "0"
    }
  }, [_c('router-link', {
    attrs: {
      "to": _vm.redirectRoute
    }
  }, [_c('el-button', {
    staticClass: "fluid form__button"
  }, [_vm._v(_vm._s(_vm.$t('cancel')))])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "fluid form__button",
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('submit')) + "\n                        ")])], 1)], 1)])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 793 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "120px"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_c('span', {
    staticClass: "box__header--text"
  }, [_vm._v(_vm._s(_vm.getRouteName(_vm.$route)))]), _vm._v(" "), _c('form-language-switcher')], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nazwa robocza",
      "error": _vm.errors['working_name'],
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form['working_name']),
      callback: function($$v) {
        _vm.$set(_vm.form, 'working_name', $$v)
      },
      expression: "form['working_name']"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "slides"
  }, [_c('el-collapse', {
    staticClass: "formset__list"
  }, _vm._l((_vm.form.slides), function(slide, i) {
    return _c('div', {
      staticClass: "formset__item"
    }, [_c('el-collapse-item', {
      attrs: {
        "name": i
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('formset-header', {
      attrs: {
        "label": ("" + (slide.title_pl || 'Nowy slajd')),
        "errors": _vm.checkForErrors(_vm.errors.slides, [i]),
        "items": _vm.form.slides,
        "index": i
      },
      on: {
        "update:items": function($event) {
          return _vm.$set(_vm.form, "slides", $event)
        }
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Wyświetlaj grafikę na całym slajdzie",
        "error": _vm.errors.slides && _vm.errors.slides[i] && _vm.errors.slides[i]['media_on_whole_slide']
      }
    }, [_c('el-switch', {
      model: {
        value: (slide['media_on_whole_slide']),
        callback: function($$v) {
          _vm.$set(slide, 'media_on_whole_slide', $$v)
        },
        expression: "slide['media_on_whole_slide']"
      }
    })], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!slide['media_on_whole_slide']),
        expression: "!slide['media_on_whole_slide']"
      }],
      staticClass: "inline-form-group"
    }, [_c('el-form-item', {
      attrs: {
        "label": "Tytuł",
        "error": _vm.errors.slides && _vm.errors.slides[i] && _vm.errors.slides[i][_vm.addLanguageSuffix('title')]
      }
    }, [_c('el-input', {
      attrs: {
        "disabled": slide['media_on_whole_slide']
      },
      model: {
        value: (slide[_vm.addLanguageSuffix('title')]),
        callback: function($$v) {
          _vm.$set(slide, _vm.addLanguageSuffix('title'), $$v)
        },
        expression: "slide[addLanguageSuffix('title')]"
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "inline-form-group"
    }, [_c('el-form-item', {
      attrs: {
        "label": "Kolor tła",
        "error": _vm.errors.slides && _vm.errors.slides[i] && _vm.errors.slides[i]['bg_color']
      }
    }, [_c('el-color-picker', {
      model: {
        value: (slide.bg_color),
        callback: function($$v) {
          _vm.$set(slide, "bg_color", $$v)
        },
        expression: "slide.bg_color"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!slide['media_on_whole_slide']),
        expression: "!slide['media_on_whole_slide']"
      }],
      attrs: {
        "label": "Kolor tekstu",
        "error": _vm.errors.slides && _vm.errors.slides[i] && _vm.errors.slides[i]['text_color']
      }
    }, [_c('el-color-picker', {
      model: {
        value: (slide.text_color),
        callback: function($$v) {
          _vm.$set(slide, "text_color", $$v)
        },
        expression: "slide.text_color"
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!slide['media_on_whole_slide']),
        expression: "!slide['media_on_whole_slide']"
      }],
      staticClass: "inline-form-group"
    }, [_c('el-form-item', {
      attrs: {
        "label": "Podtytuł",
        "error": _vm.errors.slides && _vm.errors.slides[i] && _vm.errors.slides[i][_vm.addLanguageSuffix('subtitle')]
      }
    }, [_c('wyswig-input', {
      attrs: {
        "simple": true
      },
      model: {
        value: (slide[_vm.addLanguageSuffix('subtitle')]),
        callback: function($$v) {
          _vm.$set(slide, _vm.addLanguageSuffix('subtitle'), $$v)
        },
        expression: "slide[addLanguageSuffix('subtitle')]"
      }
    })], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "źródło iframe (domyślnie na całym slajdzie)",
        "error": _vm.errors.slides && _vm.errors.slides[i] && _vm.errors.slides[i].iframe
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "https://player.vimeo.com/video/278003111?autoplay=1&muted=1"
      },
      model: {
        value: (slide.iframe),
        callback: function($$v) {
          _vm.$set(slide, "iframe", $$v)
        },
        expression: "slide.iframe"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "inline-form-group"
    }, [_c('el-form-item', {
      attrs: {
        "label": "Grafika",
        "error": _vm.errors.slides && _vm.errors.slides[i] && _vm.errors.slides[i]['image']
      }
    }, [_c('image-input-component', {
      model: {
        value: (slide.image),
        callback: function($$v) {
          _vm.$set(slide, "image", $$v)
        },
        expression: "slide.image"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "URL do filmu",
        "error": _vm.errors.slides && _vm.errors.slides[i] && _vm.errors.slides[i]['video']
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "https://www.youtube.com/watch?v=blJKoXWlqJk"
      },
      model: {
        value: (slide['video']),
        callback: function($$v) {
          _vm.$set(slide, 'video', $$v)
        },
        expression: "slide['video']"
      }
    })], 1)], 1), _vm._v(" "), _c('el-form-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!slide['media_on_whole_slide']),
        expression: "!slide['media_on_whole_slide']"
      }],
      attrs: {
        "label": "Przycisk"
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "Ukryj przycisk"
      }
    }, [_c('el-switch', {
      attrs: {
        "disabled": slide.media_on_whole_slide
      },
      model: {
        value: (slide.hide_button),
        callback: function($$v) {
          _vm.$set(slide, "hide_button", $$v)
        },
        expression: "slide.hide_button"
      }
    })], 1), _vm._v(" "), (!slide.hide_button) ? _c('el-form-item', {
      attrs: {
        "label": "Nazwa",
        "error": _vm.errors.slides && _vm.errors.slides[i] && _vm.errors.slides[i]['button_title']
      }
    }, [_c('el-input', {
      attrs: {
        "disabled": slide.hide_button
      },
      model: {
        value: (slide[_vm.addLanguageSuffix('button_title')]),
        callback: function($$v) {
          _vm.$set(slide, _vm.addLanguageSuffix('button_title'), $$v)
        },
        expression: "slide[addLanguageSuffix('button_title')]"
      }
    })], 1) : _vm._e(), _vm._v(" "), (!slide.hide_button) ? _c('link-component', {
      attrs: {
        "errors": _vm.errors.slides && _vm.errors.slides[i] && _vm.errors.slides[i]['button_link']
      },
      model: {
        value: (slide.button_link),
        callback: function($$v) {
          _vm.$set(slide, "button_link", $$v)
        },
        expression: "slide.button_link"
      }
    }) : _vm._e()], 1)], 2)], 1)
  }), 0), _vm._v(" "), _c('el-button', {
    staticClass: "fluid",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addSlide
    }
  }, [_vm._v("\n                            Dodaj slajd\n                        ")])], 1)], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('manage')) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form__buttons",
    attrs: {
      "label-width": "0"
    }
  }, [_c('router-link', {
    attrs: {
      "to": _vm.redirectRoute
    }
  }, [_c('el-button', {
    staticClass: "fluid form__button"
  }, [_vm._v(_vm._s(_vm.$t('cancel')))])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "fluid form__button",
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('submit')) + "\n                        ")])], 1)], 1)])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 794 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    staticClass: "sidebar",
    attrs: {
      "span": 6
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Add Folder'
      }
    }
  }, [_c('el-button', {
    staticClass: "fluid",
    attrs: {
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('add')) + " folder "), _c('i', {
    staticClass: "el-icon-plus"
  })])], 1), _vm._v(" "), _c('ListFilterComponent', {
    attrs: {
      "selectedFilters": _vm.filters.selected,
      "listFilters": _vm.filters.available
    },
    on: {
      "setFilter": _vm.setFilter
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "box",
    attrs: {
      "span": 18
    }
  }, [_c('div', {
    staticClass: "list__header"
  }, [_c('p', {
    staticClass: "list__title"
  }, [_vm._v("\n                    " + _vm._s(_vm.getRouteName(_vm.$route)) + "\n                ")]), _vm._v(" "), _c('search-list-form', {
    on: {
      "submit": _vm.fetchData
    },
    model: {
      value: (_vm.filters.selected.search),
      callback: function($$v) {
        _vm.$set(_vm.filters.selected, "search", $$v)
      },
      expression: "filters.selected.search"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticClass: "list__table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.data,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "id",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "working_name",
      "label": "nazwa folderu"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tags",
      "label": "tagi"
    }
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "pull-right",
    attrs: {
      "label": "opcje",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'Edit Folder',
              params: {
                id: scope.row.id
              }
            }
          }
        }, [_c('el-button', {
          attrs: {
            "size": "small",
            "title": _vm.$t('edit')
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        })])], 1), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small",
            "title": _vm.$t('delete')
          },
          on: {
            "click": function($event) {
              return _vm.handleDelete(scope.$index, scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        })])]
      }
    }])
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 795 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('el-form', {
    ref: "form",
    staticClass: "login-container",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-position": "left",
      "label-width": "0px"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Login")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "username"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "login"
    },
    model: {
      value: (_vm.form.username),
      callback: function($$v) {
        _vm.$set(_vm.form, "username", $$v)
      },
      expression: "form.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "password"
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.$set(_vm.form, "password", $$v)
      },
      expression: "form.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('button', {
    staticClass: "el-button el-button--primary",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "submit",
      "loading": _vm.loading
    }
  }, [_c('span', [_vm._v("Login")])])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 796 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "inline-form-group"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tryb kafelków",
      "error": _vm.errors['tiles_mode']
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.form.tiles_mode),
      callback: function($$v) {
        _vm.$set(_vm.form, "tiles_mode", $$v)
      },
      expression: "form.tiles_mode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tryb kalendarza",
      "error": _vm.errors['calendar_mode']
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.form.calendar_mode),
      callback: function($$v) {
        _vm.$set(_vm.form, "calendar_mode", $$v)
      },
      expression: "form.calendar_mode"
    }
  })], 1)], 1), _vm._v(" "), _c('el-collapse', {
    staticClass: "formset__list"
  }, _vm._l((_vm.form.sections), function(section, i) {
    return _c('div', {
      staticClass: "formset__item"
    }, [_c('el-collapse-item', {
      attrs: {
        "name": i
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('formset-header', {
      attrs: {
        "label": ("" + (section.name_pl || 'Nowa sekcja')),
        "items": _vm.form.sections,
        "errors": _vm.checkForErrors(_vm.errors.sections, [i]),
        "index": i
      },
      on: {
        "update:items": function($event) {
          return _vm.$set(_vm.form, "sections", $event)
        }
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Tytuł sekcji",
        "error": _vm.errors.sections && _vm.errors.sections[i] && _vm.errors.sections[i][_vm.addLanguageSuffix('name')]
      }
    }, [_c('el-input', {
      model: {
        value: (section[_vm.addLanguageSuffix('name')]),
        callback: function($$v) {
          _vm.$set(section, _vm.addLanguageSuffix('name'), $$v)
        },
        expression: "section[addLanguageSuffix('name')]"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "inline-form-group"
    }, [_c('el-form-item', {
      attrs: {
        "label": "Kolor tła",
        "error": _vm.errors.sections && _vm.errors.sections[i] && _vm.errors.sections[i]['bg_color']
      }
    }, [_c('el-color-picker', {
      model: {
        value: (section.bg_color),
        callback: function($$v) {
          _vm.$set(section, "bg_color", $$v)
        },
        expression: "section.bg_color"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Wyświetlaj w kafelkach",
        "error": _vm.errors.sections && _vm.errors.sections[i] && _vm.errors.sections[i]['show_in_tiles']
      }
    }, [_c('el-switch', {
      model: {
        value: (section.show_in_tiles),
        callback: function($$v) {
          _vm.$set(section, "show_in_tiles", $$v)
        },
        expression: "section.show_in_tiles"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Wyświetlaj w kalendarzu",
        "error": _vm.errors.sections && _vm.errors.sections[i] && _vm.errors.sections[i]['show_in_calendar']
      }
    }, [_c('el-switch', {
      model: {
        value: (section.show_in_calendar),
        callback: function($$v) {
          _vm.$set(section, "show_in_calendar", $$v)
        },
        expression: "section.show_in_calendar"
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "inline-form-group"
    }, [_c('el-form-item', {
      attrs: {
        "label": "Typ wydarzeń",
        "error": _vm.errors.sections && _vm.errors.sections[i] && _vm.errors.sections[i]['event_type']
      }
    }, [_c('el-select', {
      staticClass: "fluid",
      attrs: {
        "filterable": "",
        "placeholder": "Typ wydarzenia"
      },
      on: {
        "change": function($event) {
          return _vm.resetTags(section)
        }
      },
      model: {
        value: (section.event_type),
        callback: function($$v) {
          _vm.$set(section, "event_type", $$v)
        },
        expression: "section.event_type"
      }
    }, _vm._l((_vm.availableTypes), function(item) {
      return _c('el-option', {
        key: item,
        attrs: {
          "label": _vm.translateType(item),
          "value": item
        }
      })
    }), 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Tagi",
        "error": _vm.errors.sections && _vm.errors.sections[i] && _vm.errors.sections[i]['tags']
      }
    }, [_c('el-select', {
      staticClass: "fluid",
      attrs: {
        "filterable": "",
        "multiple": "",
        "disabled": !(!!section.event_type),
        "placeholder": "Wybierz tagi"
      },
      model: {
        value: (section.tags),
        callback: function($$v) {
          _vm.$set(section, "tags", $$v)
        },
        expression: "section.tags"
      }
    }, _vm._l((_vm.tagsForType(section.event_type)), function(item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "label": item.name,
          "value": item.id
        }
      })
    }), 1)], 1)], 1)], 2)], 1)
  }), 0), _vm._v(" "), _c('el-button', {
    staticClass: "fluid",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addSection
    }
  }, [_vm._v("\n        Dodaj sekcję\n    ")])], 1)
},staticRenderFns: []}

/***/ }),
/* 797 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 798 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container"
  }, [_c('HeaderComponent'), _vm._v(" "), _c('el-col', {
    staticClass: "main",
    attrs: {
      "span": 24
    }
  }, [_c('SidebarComponent'), _vm._v(" "), _c('section', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [(_vm.showBreadcrumbs) ? _c('el-col', {
    staticClass: "breadcrumb-container",
    attrs: {
      "span": 24
    }
  }, [_c('strong', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$route.name))]), _vm._v(" "), _c('el-breadcrumb', {
    staticClass: "breadcrumb-inner",
    attrs: {
      "separator": "/"
    }
  }, _vm._l((_vm.$route.matched), function(item) {
    return _c('el-breadcrumb-item', {
      key: item.path
    }, [_vm._v("\n                            " + _vm._s(item.name) + "\n                        ")])
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    staticClass: "content-wrapper",
    attrs: {
      "span": 24
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view', {
    key: _vm.$route.fullPath
  })], 1)], 1)], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 799 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "100px"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_c('span', {
    staticClass: "box__header--text"
  }, [_vm._v(_vm._s(_vm.getRouteName(_vm.$route)))]), _vm._v(" "), _c('form-language-switcher')], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tytuł",
      "error": _vm.errors[_vm.addLanguageSuffix('title')],
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('title')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('title'), $$v)
      },
      expression: "form[addLanguageSuffix('title')]"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Ukryj zdjęcie oraz treść w szczegółach"
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.form.hide_default_widget),
      callback: function($$v) {
        _vm.$set(_vm.form, "hide_default_widget", $$v)
      },
      expression: "form.hide_default_widget"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tekst na kafelku",
      "error": _vm.errors[_vm.addLanguageSuffix('tile_text')]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('tile_text')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('tile_text'), $$v)
      },
      expression: "form[addLanguageSuffix('tile_text')]"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Treść",
      "error": _vm.errors[_vm.addLanguageSuffix('description')]
    }
  }, [_c('wyswig-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('description')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('description'), $$v)
      },
      expression: "form[addLanguageSuffix('description')]"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tagi",
      "error": _vm.errors['tags']
    }
  }, [_c('el-select', {
    staticClass: "fluid",
    attrs: {
      "filterable": "",
      "multiple": "",
      "default-first-option": "",
      "placeholder": "Tagi",
      "allow-create": ""
    },
    model: {
      value: (_vm.form['tags']),
      callback: function($$v) {
        _vm.$set(_vm.form, 'tags', $$v)
      },
      expression: "form['tags']"
    }
  }, _vm._l((_vm.tags), function(item) {
    return _c('el-option', {
      key: item.name,
      attrs: {
        "label": item.name,
        "value": item.name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Popup"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "Wybierz popup"
    },
    model: {
      value: (_vm.form.popup),
      callback: function($$v) {
        _vm.$set(_vm.form, "popup", $$v)
      },
      expression: "form.popup"
    }
  }, _vm._l((_vm.popups), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.working_name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "box__header box__header--photos"
  }, [_c('span', {
    staticClass: "box__header--text"
  }, [_vm._v("Zdjęcia:")])]), _vm._v(" "), _c('photo-cropper', {
    attrs: {
      "photo": _vm.form.photo,
      "errors": _vm.errors,
      "croppers": _vm.croppers
    },
    on: {
      "update:photo": function($event) {
        return _vm.$set(_vm.form, "photo", $event)
      },
      "update:croppers": function($event) {
        _vm.croppers = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "box__header"
  }, [_c('span', {
    staticClass: "box__header--text"
  }, [_vm._v("Widgety - widoczne w szczegółach:")])]), _vm._v(" "), _c('widgets-input', {
    attrs: {
      "widgets": _vm.form.widgets,
      "lessDetails": true,
      "errors": _vm.errors.widgets || []
    },
    on: {
      "update:widgets": function($event) {
        return _vm.$set(_vm.form, "widgets", $event)
      }
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('manage')) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form__buttons",
    attrs: {
      "label-width": "0"
    }
  }, [_c('router-link', {
    attrs: {
      "to": _vm.redirectRoute
    }
  }, [_c('el-button', {
    staticClass: "fluid form__button"
  }, [_vm._v(_vm._s(_vm.$t('cancel')))])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "fluid form__button",
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('submit')) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "el-form-item timestamp"
  }, [_c('label', [_vm._v("\n                                Data publikacji\n                                "), (_vm.errors.timestamp) ? _c('div', {
    staticClass: "el-form-item__error"
  }, [_vm._v("\n                                    " + _vm._s(_vm.errors.timestamp) + "\n                                ")]) : _vm._e(), _vm._v(" "), _c('el-date-picker', {
    staticClass: "timestamp__input",
    attrs: {
      "clearable": false,
      "value-format": "yyyy-MM-dd HH:mm:ss",
      "type": "datetime",
      "placeholder": "Select date and time"
    },
    model: {
      value: (_vm.form.timestamp),
      callback: function($$v) {
        _vm.$set(_vm.form, "timestamp", $$v)
      },
      expression: "form.timestamp"
    }
  })], 1)]), _vm._v(" "), _c('label', [_vm._v("\n                            Ukryj\n                            "), _c('el-switch', {
    model: {
      value: (_vm.form.hide),
      callback: function($$v) {
        _vm.$set(_vm.form, "hide", $$v)
      },
      expression: "form.hide"
    }
  })], 1)], 1)], 1)])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 800 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Liczba kolumn",
      "error": _vm.errors['columns']
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "Wskaż liczbę kolumn"
    },
    on: {
      "change": _vm.columnsChanged
    },
    model: {
      value: (_vm.form.columns),
      callback: function($$v) {
        _vm.$set(_vm.form, "columns", $$v)
      },
      expression: "form.columns"
    }
  }, _vm._l((_vm.maxColumns - 1), function(i) {
    return _c('el-option', {
      key: i + 1,
      attrs: {
        "label": i + 1,
        "value": i + 1
      }
    })
  }), 1)], 1), _vm._v(" "), _vm._l((_vm.maxColumns), function(column) {
    return (_vm.form.columns && _vm.form.columns > column - 1) ? _c('el-form-item', {
      key: column,
      attrs: {
        "label": ("Kolumna " + column),
        "required": "",
        "error": _vm.errors[_vm.addLanguageSuffix(("column_" + column))]
      }
    }, [_c('wyswig-input', {
      model: {
        value: (_vm.form[_vm.addLanguageSuffix(("column_" + column))]),
        callback: function($$v) {
          _vm.$set(_vm.form, _vm.addLanguageSuffix(("column_" + column)), $$v)
        },
        expression: "form[addLanguageSuffix(`column_${column}`)]"
      }
    })], 1) : _vm._e()
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 801 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Treść",
      "required": "",
      "error": _vm.errors[_vm.addLanguageSuffix('content')]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('content')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('content'), $$v)
      },
      expression: "form[addLanguageSuffix('content')]"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 802 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Tytuł",
      "error": _vm.errors[_vm.addLanguageSuffix('label')]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.item[_vm.addLanguageSuffix('label')]),
      callback: function($$v) {
        _vm.$set(_vm.item, _vm.addLanguageSuffix('label'), $$v)
      },
      expression: "item[addLanguageSuffix('label')]"
    }
  })], 1), _vm._v(" "), _c('link-component', {
    key: ("submenu_link_" + _vm.itemKey),
    attrs: {
      "errors": _vm.errors['link']
    },
    model: {
      value: (_vm.item.link),
      callback: function($$v) {
        _vm.$set(_vm.item, "link", $$v)
      },
      expression: "item.link"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 803 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Opis",
      "required": "",
      "error": _vm.errors[_vm.addLanguageSuffix('content')]
    }
  }, [_c('wyswig-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('content')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('content'), $$v)
      },
      expression: "form[addLanguageSuffix('content')]"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 804 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('editor', {
    ref: "editor",
    attrs: {
      "init": _vm.simple ? _vm.simpleEditorInit : _vm.editorInit,
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input', $event)
      }
    }
  }), _vm._v(" "), _c('photos-dialog', {
    attrs: {
      "bus": _vm.bus
    },
    on: {
      "cancel": _vm.dialogCancelled,
      "submit": _vm.dialogSubmitted
    }
  }), _vm._v(" "), _c('el-dialog', {
    staticClass: "file-dialog",
    attrs: {
      "title": "Wgraj plik",
      "width": "408px",
      "top": "0",
      "center": "",
      "append-to-body": "",
      "visible": _vm.innerVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.innerVisible = $event
      }
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "drag": "",
      "action": "",
      "show-file-list": false,
      "http-request": _vm.sendFile
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v("\n                Przeciągnij i upuść plik, lub "), _c('em', [_vm._v("kliknij tutaj")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "existing-button"
  }, [_c('el-button', {
    staticClass: "open-dialog-button",
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.openPhotosDialog
    }
  }, [_c('i', {
    staticClass: "fa fa-file-image-o"
  }), _vm._v(" Wybierz z istniejących\n            ")])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.innerVisible = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.innerVisible = false
      }
    }
  }, [_vm._v("Confirm")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 805 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "120px"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_c('span', {
    staticClass: "box__header--text"
  }, [_vm._v(_vm._s(_vm.getRouteName(_vm.$route)))]), _vm._v(" "), _c('form-language-switcher')], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Hashtag w nagłówku",
      "error": _vm.errors[_vm.addLanguageSuffix('header_hashtag')]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('header_hashtag')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('header_hashtag'), $$v)
      },
      expression: "form[addLanguageSuffix('header_hashtag')]"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Data w nagłówku",
      "error": _vm.errors[_vm.addLanguageSuffix('header_date')]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('header_date')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('header_date'), $$v)
      },
      expression: "form[addLanguageSuffix('header_date')]"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Data rozpoczęcia",
      "error": _vm.errors.start_date
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy/MM/dd",
      "value-format": "yyyy-MM-dd",
      "placeholder": "Data rozpoczecia festiwalu"
    },
    model: {
      value: (_vm.form.start_date),
      callback: function($$v) {
        _vm.$set(_vm.form, "start_date", $$v)
      },
      expression: "form.start_date"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Data zakończenia",
      "error": _vm.errors.end_date
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy/MM/dd",
      "value-format": "yyyy-MM-dd",
      "placeholder": "Data zakończenia festiwalu"
    },
    model: {
      value: (_vm.form.end_date),
      callback: function($$v) {
        _vm.$set(_vm.form, "end_date", $$v)
      },
      expression: "form.end_date"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Pokaż zegar odliczający do początku festiwalu"
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.form.show_counting_down),
      callback: function($$v) {
        _vm.$set(_vm.form, "show_counting_down", $$v)
      },
      expression: "form.show_counting_down"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Domena z biletami",
      "error": _vm.errors.tickets_url
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "https://www.altersklep.pl"
    },
    model: {
      value: (_vm.form.tickets_url),
      callback: function($$v) {
        _vm.$set(_vm.form, "tickets_url", $$v)
      },
      expression: "form.tickets_url"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Odnośnik do polityki prywatności",
      "error": _vm.errors.policy_link
    }
  }, [_c('link-component', {
    attrs: {
      "errors": _vm.errors['policy_link']
    },
    model: {
      value: (_vm.form.policy_link),
      callback: function($$v) {
        _vm.$set(_vm.form, "policy_link", $$v)
      },
      expression: "form.policy_link"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('manage')) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form__buttons",
    attrs: {
      "label-width": "0"
    }
  }, [_c('el-button', {
    staticClass: "fluid form__button",
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('submit')) + "\n                        ")])], 1)], 1)])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 806 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "120px"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_c('span', {
    staticClass: "box__header--text"
  }, [_vm._v(_vm._s(_vm.getRouteName(_vm.$route)))]), _vm._v(" "), _c('form-language-switcher')], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nazwa robocza",
      "error": _vm.errors['working_name'],
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form['working_name']),
      callback: function($$v) {
        _vm.$set(_vm.form, 'working_name', $$v)
      },
      expression: "form['working_name']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tagi z instagrama",
      "error": _vm.errors['working_name'],
      "required": ""
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "filterable": "",
      "allow-create": "",
      "default-first-option": "",
      "placeholder": "Wpisz tagi, po których mają być wyszukiwane zdjęcia"
    },
    model: {
      value: (_vm.form.tags),
      callback: function($$v) {
        _vm.$set(_vm.form, "tags", $$v)
      },
      expression: "form.tags"
    }
  }, _vm._l(([]), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('photos-preview', {
    attrs: {
      "form": _vm.form
    },
    on: {
      "update:form": function($event) {
        _vm.form = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('manage')) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form__buttons",
    attrs: {
      "label-width": "0"
    }
  }, [_c('router-link', {
    attrs: {
      "to": _vm.redirectRoute
    }
  }, [_c('el-button', {
    staticClass: "fluid form__button"
  }, [_vm._v(_vm._s(_vm.$t('cancel')))])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "fluid form__button",
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('submit')) + "\n                        ")])], 1)], 1)])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 807 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "80px"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_c('span', {
    staticClass: "box__header--text"
  }, [_vm._v("\n                            " + _vm._s(_vm.getRouteName(_vm.$route)) + " " + _vm._s(_vm.types[_vm.form.resourcetype] &&
    _vm.types[_vm.form.resourcetype].label) + "\n                        ")]), _vm._v(" "), _c('form-language-switcher')], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nazwa robocza",
      "error": _vm.errors['working_name']
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Nazwa robocza dla administratorów"
    },
    model: {
      value: (_vm.form['working_name']),
      callback: function($$v) {
        _vm.$set(_vm.form, 'working_name', $$v)
      },
      expression: "form['working_name']"
    }
  })], 1), _vm._v(" "), _c('base-widget', {
    attrs: {
      "form": _vm.form,
      "errors": _vm.errors
    },
    on: {
      "update:form": function($event) {
        _vm.form = $event
      }
    }
  }), _vm._v(" "), _c(_vm.widgetComponent, {
    tag: "component",
    attrs: {
      "form": _vm.form,
      "errors": _vm.errors
    },
    on: {
      "update:form": function($event) {
        _vm.form = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('manage')) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form__buttons",
    attrs: {
      "label-width": "0"
    }
  }, [_c('router-link', {
    attrs: {
      "to": _vm.redirectRoute
    }
  }, [_c('el-button', {
    staticClass: "fluid form__button"
  }, [_vm._v(_vm._s(_vm.$t('cancel')))])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "fluid form__button",
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('submit')) + "\n                        ")])], 1)], 1)])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 808 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "inline-form-group"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Typ linku",
      "error": _vm.anchorErrors()
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Wybierz typ linku",
      "clearable": ""
    },
    on: {
      "change": _vm.resetOptions
    },
    model: {
      value: (_vm.form.anchor_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "anchor_type", $$v)
      },
      expression: "form.anchor_type"
    }
  }, _vm._l((_vm.anchorOptions), function(option) {
    return _c('el-option', {
      key: option.value,
      attrs: {
        "label": option.label,
        "value": option.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Otwieraj w nowym oknie",
      "label-width": "200px"
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.form.target_blank),
      callback: function($$v) {
        _vm.$set(_vm.form, "target_blank", $$v)
      },
      expression: "form.target_blank"
    }
  })], 1)], 1), _vm._v(" "), (_vm.form.anchor_type === 'url') ? _c('el-form-item', {
    attrs: {
      "label": "URL",
      "error": _vm.errorsParsed.url
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.url),
      callback: function($$v) {
        _vm.$set(_vm.form, "url", $$v)
      },
      expression: "form.url"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "inline-form-group"
  }, [(_vm.form.anchor_type === 'event') ? _c('el-form-item', {
    attrs: {
      "label": "Wydarzenie",
      "error": _vm.errorsParsed.event
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Wybierz wydarzenie"
    },
    on: {
      "change": function($event) {
        delete _vm.form['widget']
      }
    },
    model: {
      value: (_vm.form.event),
      callback: function($$v) {
        _vm.$set(_vm.form, "event", $$v)
      },
      expression: "form.event"
    }
  }, _vm._l((_vm.availableLinkOptions.event), function(option) {
    return _c('el-option', {
      key: option.value,
      attrs: {
        "label": option.label,
        "value": option.value
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.form.anchor_type === 'page') ? _c('el-form-item', {
    attrs: {
      "label": "Podstrona",
      "error": _vm.errorsParsed.page
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Wybierz podstronę"
    },
    on: {
      "change": function($event) {
        delete _vm.form['widget']
      }
    },
    model: {
      value: (_vm.form.page),
      callback: function($$v) {
        _vm.$set(_vm.form, "page", $$v)
      },
      expression: "form.page"
    }
  }, _vm._l((_vm.availableLinkOptions.page), function(option) {
    return _c('el-option', {
      key: option.value,
      attrs: {
        "label": option.label,
        "value": option.value
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.form.anchor_type === 'stand') ? _c('el-form-item', {
    attrs: {
      "label": "Stoiska",
      "error": _vm.errorsParsed.stand
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Wybierz stoiska"
    },
    on: {
      "change": function($event) {
        delete _vm.form['widget']
      }
    },
    model: {
      value: (_vm.form.stand),
      callback: function($$v) {
        _vm.$set(_vm.form, "stand", $$v)
      },
      expression: "form.stand"
    }
  }, _vm._l((_vm.availableLinkOptions.stand), function(option) {
    return _c('el-option', {
      key: option.value,
      attrs: {
        "label": option.label,
        "value": option.value
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.form.anchor_type === 'news') ? _c('el-form-item', {
    attrs: {
      "label": "Aktualność",
      "error": _vm.errorsParsed.news
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Wybierz aktualność"
    },
    on: {
      "change": function($event) {
        delete _vm.form['widget']
      }
    },
    model: {
      value: (_vm.form.news),
      callback: function($$v) {
        _vm.$set(_vm.form, "news", $$v)
      },
      expression: "form.news"
    }
  }, _vm._l((_vm.availableLinkOptions.news), function(option) {
    return _c('el-option', {
      key: option.value,
      attrs: {
        "label": option.label,
        "value": option.value
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.availableWidgets.length > 0) ? _c('el-form-item', {
    attrs: {
      "label": "Nazwa widgetu",
      "error": _vm.errorsParsed.widget
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("\n                Nazwa widgetu\n                "), _c('el-tooltip', {
    attrs: {
      "content": "Widget, do którego domyślnie przescrolluje się strona po kliknięciu w link.",
      "placement": "bottom"
    }
  }, [_c('el-button', {
    staticClass: "widget-info"
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  })])], 1)], 1), _vm._v(" "), _c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "Wybierz widget"
    },
    model: {
      value: (_vm.form.widget),
      callback: function($$v) {
        _vm.$set(_vm.form, "widget", $$v)
      },
      expression: "form.widget"
    }
  }, _vm._l((_vm.availableWidgets), function(option) {
    return _c('el-option', {
      key: option.id,
      attrs: {
        "label": option.name_pl,
        "value": option.id
      }
    })
  }), 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 809 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Zdjęcia")]), _vm._v(" "), _c('div', {
    staticClass: "filters"
  }, [_c('el-button', {
    attrs: {
      "type": _vm.showUnaccepted ? 'primary' : 'basic'
    },
    on: {
      "click": function($event) {
        _vm.showUnaccepted = !_vm.showUnaccepted
      }
    }
  }, [_vm._v("\n            Pokaż odrzucone\n        ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": _vm.showAccepted ? 'primary' : 'basic'
    },
    on: {
      "click": function($event) {
        _vm.showAccepted = !_vm.showAccepted
      }
    }
  }, [_vm._v("\n            Pokaż zaakceptowane\n        ")])], 1), _vm._v(" "), _c('ul', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.previewIsUpdating),
      expression: "previewIsUpdating"
    }],
    staticClass: "list"
  }, _vm._l((_vm.instagramPhotos), function(photo) {
    return _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.tileVisible(photo)),
        expression: "tileVisible(photo)"
      }],
      staticClass: "item"
    }, [_c('img', {
      staticClass: "thumbnail",
      attrs: {
        "src": photo.thumbnail_src,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "photo__buttons"
    }, [_c('el-button', {
      attrs: {
        "size": "small",
        "title": "Akceptuj",
        "type": _vm.photosDict[photo.id] && _vm.photosDict[photo.id].accepted ? 'primary' : 'basic'
      },
      on: {
        "click": function($event) {
          return _vm.changePhotoStatus(photo, true)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-check-circle"
    })]), _vm._v(" "), _c('el-button', {
      attrs: {
        "size": "small",
        "title": "Odrzuć",
        "type": _vm.photosDict[photo.id] && !_vm.photosDict[photo.id].accepted ? 'danger' : 'basic'
      },
      on: {
        "click": function($event) {
          return _vm.changePhotoStatus(photo, false)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-remove"
    })])], 1)])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 810 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    staticClass: "box",
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "list__header"
  }, [_c('p', {
    staticClass: "list__title"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.getRouteName(_vm.$route)) + "\n\t\t\t\t")])]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticClass: "list__table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.data,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "nazwa"
    }
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "pull-right",
    attrs: {
      "label": "opcje",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'Edit Menu',
              params: {
                id: scope.row.id
              }
            }
          }
        }, [_c('el-button', {
          attrs: {
            "size": "small",
            "title": _vm.$t('edit')
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        })])], 1), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small",
            "title": _vm.$t('delete')
          },
          on: {
            "click": function($event) {
              return _vm.handleDelete(scope.$index, scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        })])]
      }
    }])
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ })
],[410]);


// WEBPACK FOOTER //
// static/js/app.bc9a6d5e17c756104024.js